/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
let domain = ''
export const getDomain = () => {
  return domain
}
export const setDomain = ($domain) => {
  domain = $domain
}
export const request = (method, url, body, queryParameters, form, config) => {
  method = method.toLowerCase()
  let keys = Object.keys(queryParameters)
  let queryUrl = url
  if (keys.length > 0) {
    queryUrl = url + '?' + qs.stringify(queryParameters)
  }
  // let queryUrl = url+(keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
  if (body) {
    return axios[method](queryUrl, body, config)
  } else if (method === 'get') {
    return axios[method](queryUrl, {
      ...config, params: form
    }, config)
  } else {
    return axios[method](queryUrl, qs.stringify(form), config)
  }
}
/*==========================================================
 *                    
 ==========================================================*/
/**
 * 
 * request: handleUsingREQUEST
 * url: handleUsingREQUESTURL
 * method: handleUsingREQUEST_TYPE
 * raw_url: handleUsingREQUEST_RAW_URL
 */
export const handleUsingREQUEST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/mcp/**'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const handleUsingREQUEST_RAW_URL = function() {
  return '/mcp/**'
}
export const handleUsingREQUEST_TYPE = function() {
  return 'get'
}
export const handleUsingREQUESTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/mcp/**'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: handleUsingREQUEST_1
 * url: handleUsingREQUEST_1URL
 * method: handleUsingREQUEST_1_TYPE
 * raw_url: handleUsingREQUEST_1_RAW_URL
 */
export const handleUsingREQUEST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/mcp/**'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const handleUsingREQUEST_1_RAW_URL = function() {
  return '/mcp/**'
}
export const handleUsingREQUEST_1_TYPE = function() {
  return 'post'
}
export const handleUsingREQUEST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/mcp/**'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: handleUsingREQUEST_2
 * url: handleUsingREQUEST_2URL
 * method: handleUsingREQUEST_2_TYPE
 * raw_url: handleUsingREQUEST_2_RAW_URL
 */
export const handleUsingREQUEST_2 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/mcp/**'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const handleUsingREQUEST_2_RAW_URL = function() {
  return '/mcp/**'
}
export const handleUsingREQUEST_2_TYPE = function() {
  return 'delete'
}
export const handleUsingREQUEST_2URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/mcp/**'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getValidationRuleByIdUsingGET
 * url: getValidationRuleByIdUsingGETURL
 * method: getValidationRuleByIdUsingGET_TYPE
 * raw_url: getValidationRuleByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getValidationRuleByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/validation-rule/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getValidationRuleByIdUsingGET_RAW_URL = function() {
  return '/validation-rule/{id}'
}
export const getValidationRuleByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getValidationRuleByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/validation-rule/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateValidationRuleUsingPUT
 * url: updateValidationRuleUsingPUTURL
 * method: updateValidationRuleUsingPUT_TYPE
 * raw_url: updateValidationRuleUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateValidationRuleUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/validation-rule/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateValidationRuleUsingPUT_RAW_URL = function() {
  return '/validation-rule/{id}'
}
export const updateValidationRuleUsingPUT_TYPE = function() {
  return 'put'
}
export const updateValidationRuleUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/validation-rule/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteValidationRuleUsingDELETE
 * url: deleteValidationRuleUsingDELETEURL
 * method: deleteValidationRuleUsingDELETE_TYPE
 * raw_url: deleteValidationRuleUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteValidationRuleUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/validation-rule/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteValidationRuleUsingDELETE_RAW_URL = function() {
  return '/validation-rule/{id}'
}
export const deleteValidationRuleUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteValidationRuleUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/validation-rule/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateValidationRuleRolesUsingPUT
 * url: updateValidationRuleRolesUsingPUTURL
 * method: updateValidationRuleRolesUsingPUT_TYPE
 * raw_url: updateValidationRuleRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateValidationRuleRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/validation-rule/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateValidationRuleRolesUsingPUT_RAW_URL = function() {
  return '/validation-rule/{id}/roles'
}
export const updateValidationRuleRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateValidationRuleRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/validation-rule/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getUserByIdUsingGET
 * url: getUserByIdUsingGETURL
 * method: getUserByIdUsingGET_TYPE
 * raw_url: getUserByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getUserByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserByIdUsingGET_RAW_URL = function() {
  return '/user/{id}'
}
export const getUserByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getUserByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateUserUsingPUT
 * url: updateUserUsingPUTURL
 * method: updateUserUsingPUT_TYPE
 * raw_url: updateUserUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateUserUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateUserUsingPUT_RAW_URL = function() {
  return '/user/{id}'
}
export const updateUserUsingPUT_TYPE = function() {
  return 'put'
}
export const updateUserUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteUserUsingDELETE
 * url: deleteUserUsingDELETEURL
 * method: deleteUserUsingDELETE_TYPE
 * raw_url: deleteUserUsingDELETE_RAW_URL
 * @param id - 
 */
export const deleteUserUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteUserUsingDELETE_RAW_URL = function() {
  return '/user/{id}'
}
export const deleteUserUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteUserUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: setMfaStartingDateUsingPUT
 * url: setMfaStartingDateUsingPUTURL
 * method: setMfaStartingDateUsingPUT_TYPE
 * raw_url: setMfaStartingDateUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const setMfaStartingDateUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/mfa-starting-date'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const setMfaStartingDateUsingPUT_RAW_URL = function() {
  return '/user/{id}/mfa-starting-date'
}
export const setMfaStartingDateUsingPUT_TYPE = function() {
  return 'put'
}
export const setMfaStartingDateUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/mfa-starting-date'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: generateApiKeyUsingPUT
 * url: generateApiKeyUsingPUTURL
 * method: generateApiKeyUsingPUT_TYPE
 * raw_url: generateApiKeyUsingPUT_RAW_URL
 * @param id - 
 */
export const generateApiKeyUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/generate-api-key'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const generateApiKeyUsingPUT_RAW_URL = function() {
  return '/user/{id}/generate-api-key'
}
export const generateApiKeyUsingPUT_TYPE = function() {
  return 'put'
}
export const generateApiKeyUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/generate-api-key'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: resetFailedAuthAttemptsUsingPUT
 * url: resetFailedAuthAttemptsUsingPUTURL
 * method: resetFailedAuthAttemptsUsingPUT_TYPE
 * raw_url: resetFailedAuthAttemptsUsingPUT_RAW_URL
 * @param id - 
 */
export const resetFailedAuthAttemptsUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/failed-auth-attempts/reset'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const resetFailedAuthAttemptsUsingPUT_RAW_URL = function() {
  return '/user/{id}/failed-auth-attempts/reset'
}
export const resetFailedAuthAttemptsUsingPUT_TYPE = function() {
  return 'put'
}
export const resetFailedAuthAttemptsUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/failed-auth-attempts/reset'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerWhatsAppByIdUsingGET
 * url: getTriggerWhatsAppByIdUsingGETURL
 * method: getTriggerWhatsAppByIdUsingGET_TYPE
 * raw_url: getTriggerWhatsAppByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerWhatsAppByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerWhatsAppByIdUsingGET_RAW_URL = function() {
  return '/trigger-whatsapp/{id}'
}
export const getTriggerWhatsAppByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerWhatsAppByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerWhatsAppUsingPUT
 * url: updateTriggerWhatsAppUsingPUTURL
 * method: updateTriggerWhatsAppUsingPUT_TYPE
 * raw_url: updateTriggerWhatsAppUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerWhatsAppUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerWhatsAppUsingPUT_RAW_URL = function() {
  return '/trigger-whatsapp/{id}'
}
export const updateTriggerWhatsAppUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerWhatsAppUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteTriggerWhatsAppUsingDELETE
 * url: deleteTriggerWhatsAppUsingDELETEURL
 * method: deleteTriggerWhatsAppUsingDELETE_TYPE
 * raw_url: deleteTriggerWhatsAppUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteTriggerWhatsAppUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTriggerWhatsAppUsingDELETE_RAW_URL = function() {
  return '/trigger-whatsapp/{id}'
}
export const deleteTriggerWhatsAppUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTriggerWhatsAppUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerWhatsAppRolesUsingPUT
 * url: updateTriggerWhatsAppRolesUsingPUTURL
 * method: updateTriggerWhatsAppRolesUsingPUT_TYPE
 * raw_url: updateTriggerWhatsAppRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerWhatsAppRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerWhatsAppRolesUsingPUT_RAW_URL = function() {
  return '/trigger-whatsapp/{id}/roles'
}
export const updateTriggerWhatsAppRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerWhatsAppRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerUiByIdUsingGET
 * url: getTriggerUiByIdUsingGETURL
 * method: getTriggerUiByIdUsingGET_TYPE
 * raw_url: getTriggerUiByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerUiByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerUiByIdUsingGET_RAW_URL = function() {
  return '/trigger-ui/{id}'
}
export const getTriggerUiByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerUiByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerUiUsingPUT
 * url: updateTriggerUiUsingPUTURL
 * method: updateTriggerUiUsingPUT_TYPE
 * raw_url: updateTriggerUiUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerUiUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerUiUsingPUT_RAW_URL = function() {
  return '/trigger-ui/{id}'
}
export const updateTriggerUiUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerUiUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteTriggerUiUsingDELETE
 * url: deleteTriggerUiUsingDELETEURL
 * method: deleteTriggerUiUsingDELETE_TYPE
 * raw_url: deleteTriggerUiUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteTriggerUiUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTriggerUiUsingDELETE_RAW_URL = function() {
  return '/trigger-ui/{id}'
}
export const deleteTriggerUiUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTriggerUiUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerUiRolesUsingPUT
 * url: updateTriggerUiRolesUsingPUTURL
 * method: updateTriggerUiRolesUsingPUT_TYPE
 * raw_url: updateTriggerUiRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerUiRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerUiRolesUsingPUT_RAW_URL = function() {
  return '/trigger-ui/{id}/roles'
}
export const updateTriggerUiRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerUiRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerRestByIdUsingGET
 * url: getTriggerRestByIdUsingGETURL
 * method: getTriggerRestByIdUsingGET_TYPE
 * raw_url: getTriggerRestByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerRestByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerRestByIdUsingGET_RAW_URL = function() {
  return '/trigger-rest/{id}'
}
export const getTriggerRestByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerRestByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerRestUsingPUT
 * url: updateTriggerRestUsingPUTURL
 * method: updateTriggerRestUsingPUT_TYPE
 * raw_url: updateTriggerRestUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerRestUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerRestUsingPUT_RAW_URL = function() {
  return '/trigger-rest/{id}'
}
export const updateTriggerRestUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerRestUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteRestTriggerUsingDELETE
 * url: deleteRestTriggerUsingDELETEURL
 * method: deleteRestTriggerUsingDELETE_TYPE
 * raw_url: deleteRestTriggerUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteRestTriggerUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteRestTriggerUsingDELETE_RAW_URL = function() {
  return '/trigger-rest/{id}'
}
export const deleteRestTriggerUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteRestTriggerUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerRestRolesUsingPUT
 * url: updateTriggerRestRolesUsingPUTURL
 * method: updateTriggerRestRolesUsingPUT_TYPE
 * raw_url: updateTriggerRestRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerRestRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerRestRolesUsingPUT_RAW_URL = function() {
  return '/trigger-rest/{id}/roles'
}
export const updateTriggerRestRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerRestRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerMessagingByIdUsingGET
 * url: getTriggerMessagingByIdUsingGETURL
 * method: getTriggerMessagingByIdUsingGET_TYPE
 * raw_url: getTriggerMessagingByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerMessagingByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerMessagingByIdUsingGET_RAW_URL = function() {
  return '/trigger-messaging/{id}'
}
export const getTriggerMessagingByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerMessagingByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerMessagingUsingPUT
 * url: updateTriggerMessagingUsingPUTURL
 * method: updateTriggerMessagingUsingPUT_TYPE
 * raw_url: updateTriggerMessagingUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerMessagingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerMessagingUsingPUT_RAW_URL = function() {
  return '/trigger-messaging/{id}'
}
export const updateTriggerMessagingUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerMessagingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteMessagingTriggerUsingDELETE
 * url: deleteMessagingTriggerUsingDELETEURL
 * method: deleteMessagingTriggerUsingDELETE_TYPE
 * raw_url: deleteMessagingTriggerUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteMessagingTriggerUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteMessagingTriggerUsingDELETE_RAW_URL = function() {
  return '/trigger-messaging/{id}'
}
export const deleteMessagingTriggerUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteMessagingTriggerUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerMessagingRolesUsingPUT
 * url: updateTriggerMessagingRolesUsingPUTURL
 * method: updateTriggerMessagingRolesUsingPUT_TYPE
 * raw_url: updateTriggerMessagingRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerMessagingRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerMessagingRolesUsingPUT_RAW_URL = function() {
  return '/trigger-messaging/{id}/roles'
}
export const updateTriggerMessagingRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerMessagingRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerMcpByIdUsingGET
 * url: getTriggerMcpByIdUsingGETURL
 * method: getTriggerMcpByIdUsingGET_TYPE
 * raw_url: getTriggerMcpByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerMcpByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerMcpByIdUsingGET_RAW_URL = function() {
  return '/trigger-mcp/{id}'
}
export const getTriggerMcpByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerMcpByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerMcpUsingPUT
 * url: updateTriggerMcpUsingPUTURL
 * method: updateTriggerMcpUsingPUT_TYPE
 * raw_url: updateTriggerMcpUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerMcpUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerMcpUsingPUT_RAW_URL = function() {
  return '/trigger-mcp/{id}'
}
export const updateTriggerMcpUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerMcpUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteMcpTriggerUsingDELETE
 * url: deleteMcpTriggerUsingDELETEURL
 * method: deleteMcpTriggerUsingDELETE_TYPE
 * raw_url: deleteMcpTriggerUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteMcpTriggerUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteMcpTriggerUsingDELETE_RAW_URL = function() {
  return '/trigger-mcp/{id}'
}
export const deleteMcpTriggerUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteMcpTriggerUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerRestRolesUsingPUT_1
 * url: updateTriggerRestRolesUsingPUT_1URL
 * method: updateTriggerRestRolesUsingPUT_1_TYPE
 * raw_url: updateTriggerRestRolesUsingPUT_1_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerRestRolesUsingPUT_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerRestRolesUsingPUT_1_RAW_URL = function() {
  return '/trigger-mcp/{id}/roles'
}
export const updateTriggerRestRolesUsingPUT_1_TYPE = function() {
  return 'put'
}
export const updateTriggerRestRolesUsingPUT_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerEventHandlerByIdUsingGET
 * url: getTriggerEventHandlerByIdUsingGETURL
 * method: getTriggerEventHandlerByIdUsingGET_TYPE
 * raw_url: getTriggerEventHandlerByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerEventHandlerByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerEventHandlerByIdUsingGET_RAW_URL = function() {
  return '/trigger-event-handler/{id}'
}
export const getTriggerEventHandlerByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerEventHandlerByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerEventHandlerUsingPUT
 * url: updateTriggerEventHandlerUsingPUTURL
 * method: updateTriggerEventHandlerUsingPUT_TYPE
 * raw_url: updateTriggerEventHandlerUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerEventHandlerUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerEventHandlerUsingPUT_RAW_URL = function() {
  return '/trigger-event-handler/{id}'
}
export const updateTriggerEventHandlerUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerEventHandlerUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteTriggerEventHandlerUsingDELETE
 * url: deleteTriggerEventHandlerUsingDELETEURL
 * method: deleteTriggerEventHandlerUsingDELETE_TYPE
 * raw_url: deleteTriggerEventHandlerUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteTriggerEventHandlerUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTriggerEventHandlerUsingDELETE_RAW_URL = function() {
  return '/trigger-event-handler/{id}'
}
export const deleteTriggerEventHandlerUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTriggerEventHandlerUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerEventHandlerRolesUsingPUT
 * url: updateTriggerEventHandlerRolesUsingPUTURL
 * method: updateTriggerEventHandlerRolesUsingPUT_TYPE
 * raw_url: updateTriggerEventHandlerRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerEventHandlerRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerEventHandlerRolesUsingPUT_RAW_URL = function() {
  return '/trigger-event-handler/{id}/roles'
}
export const updateTriggerEventHandlerRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerEventHandlerRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerCronByIdUsingGET
 * url: getTriggerCronByIdUsingGETURL
 * method: getTriggerCronByIdUsingGET_TYPE
 * raw_url: getTriggerCronByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerCronByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerCronByIdUsingGET_RAW_URL = function() {
  return '/trigger-cron/{id}'
}
export const getTriggerCronByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerCronByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerCronUsingPUT
 * url: updateTriggerCronUsingPUTURL
 * method: updateTriggerCronUsingPUT_TYPE
 * raw_url: updateTriggerCronUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerCronUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerCronUsingPUT_RAW_URL = function() {
  return '/trigger-cron/{id}'
}
export const updateTriggerCronUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerCronUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteCronTriggerUsingDELETE
 * url: deleteCronTriggerUsingDELETEURL
 * method: deleteCronTriggerUsingDELETE_TYPE
 * raw_url: deleteCronTriggerUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteCronTriggerUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteCronTriggerUsingDELETE_RAW_URL = function() {
  return '/trigger-cron/{id}'
}
export const deleteCronTriggerUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteCronTriggerUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTriggerCronRolesUsingPUT
 * url: updateTriggerCronRolesUsingPUTURL
 * method: updateTriggerCronRolesUsingPUT_TYPE
 * raw_url: updateTriggerCronRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTriggerCronRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTriggerCronRolesUsingPUT_RAW_URL = function() {
  return '/trigger-cron/{id}/roles'
}
export const updateTriggerCronRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTriggerCronRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTranslationUsingPUT
 * url: updateTranslationUsingPUTURL
 * method: updateTranslationUsingPUT_TYPE
 * raw_url: updateTranslationUsingPUT_RAW_URL
 * @param translationId - 
 * @param body - 
 */
export const updateTranslationUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/translation/{translationId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters['translationId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: translationId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTranslationUsingPUT_RAW_URL = function() {
  return '/translation/{translationId}'
}
export const updateTranslationUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTranslationUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/translation/{translationId}'
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteTranslationUsingDELETE
 * url: deleteTranslationUsingDELETEURL
 * method: deleteTranslationUsingDELETE_TYPE
 * raw_url: deleteTranslationUsingDELETE_RAW_URL
 * @param translationId - 
 * @param force - 
 */
export const deleteTranslationUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/translation/{translationId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters['translationId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: translationId'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTranslationUsingDELETE_RAW_URL = function() {
  return '/translation/{translationId}'
}
export const deleteTranslationUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTranslationUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/translation/{translationId}'
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTranslationRolesUsingPUT
 * url: updateTranslationRolesUsingPUTURL
 * method: updateTranslationRolesUsingPUT_TYPE
 * raw_url: updateTranslationRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTranslationRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/translation/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTranslationRolesUsingPUT_RAW_URL = function() {
  return '/translation/{id}/roles'
}
export const updateTranslationRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTranslationRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/translation/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTextTemplateByIdUsingGET
 * url: getTextTemplateByIdUsingGETURL
 * method: getTextTemplateByIdUsingGET_TYPE
 * raw_url: getTextTemplateByIdUsingGET_RAW_URL
 * @param templateId - 
 */
export const getTextTemplateByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTextTemplateByIdUsingGET_RAW_URL = function() {
  return '/text-template/{templateId}'
}
export const getTextTemplateByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTextTemplateByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTextTemplateUsingPUT
 * url: updateTextTemplateUsingPUTURL
 * method: updateTextTemplateUsingPUT_TYPE
 * raw_url: updateTextTemplateUsingPUT_RAW_URL
 * @param templateId - 
 * @param body - 
 */
export const updateTextTemplateUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTextTemplateUsingPUT_RAW_URL = function() {
  return '/text-template/{templateId}'
}
export const updateTextTemplateUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTextTemplateUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteTextTemplateUsingDELETE
 * url: deleteTextTemplateUsingDELETEURL
 * method: deleteTextTemplateUsingDELETE_TYPE
 * raw_url: deleteTextTemplateUsingDELETE_RAW_URL
 * @param templateId - 
 * @param force - 
 */
export const deleteTextTemplateUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTextTemplateUsingDELETE_RAW_URL = function() {
  return '/text-template/{templateId}'
}
export const deleteTextTemplateUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTextTemplateUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTextTemplateTranslationUsingGET
 * url: getTextTemplateTranslationUsingGETURL
 * method: getTextTemplateTranslationUsingGET_TYPE
 * raw_url: getTextTemplateTranslationUsingGET_RAW_URL
 * @param templateId - 
 * @param translationId - 
 */
export const getTextTemplateTranslationUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}/translation/{translationId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters['translationId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: translationId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTextTemplateTranslationUsingGET_RAW_URL = function() {
  return '/text-template/{templateId}/translation/{translationId}'
}
export const getTextTemplateTranslationUsingGET_TYPE = function() {
  return 'get'
}
export const getTextTemplateTranslationUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}/translation/{translationId}'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTextTemplateTranslationUsingPUT
 * url: updateTextTemplateTranslationUsingPUTURL
 * method: updateTextTemplateTranslationUsingPUT_TYPE
 * raw_url: updateTextTemplateTranslationUsingPUT_RAW_URL
 * @param templateId - 
 * @param translationId - 
 * @param body - 
 */
export const updateTextTemplateTranslationUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}/translation/{translationId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters['translationId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: translationId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTextTemplateTranslationUsingPUT_RAW_URL = function() {
  return '/text-template/{templateId}/translation/{translationId}'
}
export const updateTextTemplateTranslationUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTextTemplateTranslationUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}/translation/{translationId}'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteTextTemplateTranslationUsingDELETE
 * url: deleteTextTemplateTranslationUsingDELETEURL
 * method: deleteTextTemplateTranslationUsingDELETE_TYPE
 * raw_url: deleteTextTemplateTranslationUsingDELETE_RAW_URL
 * @param templateId - 
 * @param translationId - 
 */
export const deleteTextTemplateTranslationUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}/translation/{translationId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters['translationId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: translationId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTextTemplateTranslationUsingDELETE_RAW_URL = function() {
  return '/text-template/{templateId}/translation/{translationId}'
}
export const deleteTextTemplateTranslationUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTextTemplateTranslationUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}/translation/{translationId}'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  path = path.replace('{translationId}', `${parameters['translationId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTextTemplateRolesUsingPUT
 * url: updateTextTemplateRolesUsingPUTURL
 * method: updateTextTemplateRolesUsingPUT_TYPE
 * raw_url: updateTextTemplateRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTextTemplateRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTextTemplateRolesUsingPUT_RAW_URL = function() {
  return '/text-template/{id}/roles'
}
export const updateTextTemplateRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTextTemplateRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTenantUserUsingPUT
 * url: enableTenantUserUsingPUTURL
 * method: enableTenantUserUsingPUT_TYPE
 * raw_url: enableTenantUserUsingPUT_RAW_URL
 * @param tenantId - 
 * @param id - 
 */
export const enableTenantUserUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{tenantId}/user/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters['tenantId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tenantId'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const enableTenantUserUsingPUT_RAW_URL = function() {
  return '/tenant/{tenantId}/user/{id}/enable'
}
export const enableTenantUserUsingPUT_TYPE = function() {
  return 'put'
}
export const enableTenantUserUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{tenantId}/user/{id}/enable'
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTenantUserUsingPUT
 * url: disableTenantUserUsingPUTURL
 * method: disableTenantUserUsingPUT_TYPE
 * raw_url: disableTenantUserUsingPUT_RAW_URL
 * @param tenantId - 
 * @param id - 
 */
export const disableTenantUserUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{tenantId}/user/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters['tenantId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tenantId'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const disableTenantUserUsingPUT_RAW_URL = function() {
  return '/tenant/{tenantId}/user/{id}/disable'
}
export const disableTenantUserUsingPUT_TYPE = function() {
  return 'put'
}
export const disableTenantUserUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{tenantId}/user/{id}/disable'
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTenantByIdUsingGET
 * url: getTenantByIdUsingGETURL
 * method: getTenantByIdUsingGET_TYPE
 * raw_url: getTenantByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTenantByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTenantByIdUsingGET_RAW_URL = function() {
  return '/tenant/{id}'
}
export const getTenantByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTenantByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTenantUsingPUT
 * url: updateTenantUsingPUTURL
 * method: updateTenantUsingPUT_TYPE
 * raw_url: updateTenantUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTenantUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTenantUsingPUT_RAW_URL = function() {
  return '/tenant/{id}'
}
export const updateTenantUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTenantUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteTenantUsingDELETE
 * url: deleteTenantUsingDELETEURL
 * method: deleteTenantUsingDELETE_TYPE
 * raw_url: deleteTenantUsingDELETE_RAW_URL
 * @param id - 
 */
export const deleteTenantUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTenantUsingDELETE_RAW_URL = function() {
  return '/tenant/{id}'
}
export const deleteTenantUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTenantUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTagByIdUsingGET
 * url: getTagByIdUsingGETURL
 * method: getTagByIdUsingGET_TYPE
 * raw_url: getTagByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getTagByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tag/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTagByIdUsingGET_RAW_URL = function() {
  return '/tag/{id}'
}
export const getTagByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTagByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tag/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTagUsingPUT
 * url: updateTagUsingPUTURL
 * method: updateTagUsingPUT_TYPE
 * raw_url: updateTagUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTagUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tag/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTagUsingPUT_RAW_URL = function() {
  return '/tag/{id}'
}
export const updateTagUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTagUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tag/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteTagUsingDELETE
 * url: deleteTagUsingDELETEURL
 * method: deleteTagUsingDELETE_TYPE
 * raw_url: deleteTagUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteTagUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tag/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteTagUsingDELETE_RAW_URL = function() {
  return '/tag/{id}'
}
export const deleteTagUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteTagUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tag/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getStorageByIdUsingGET
 * url: getStorageByIdUsingGETURL
 * method: getStorageByIdUsingGET_TYPE
 * raw_url: getStorageByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getStorageByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/storage/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStorageByIdUsingGET_RAW_URL = function() {
  return '/storage/{id}'
}
export const getStorageByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getStorageByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/storage/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateStorageUsingPUT
 * url: updateStorageUsingPUTURL
 * method: updateStorageUsingPUT_TYPE
 * raw_url: updateStorageUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateStorageUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/storage/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateStorageUsingPUT_RAW_URL = function() {
  return '/storage/{id}'
}
export const updateStorageUsingPUT_TYPE = function() {
  return 'put'
}
export const updateStorageUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/storage/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteStorageUsingDELETE
 * url: deleteStorageUsingDELETEURL
 * method: deleteStorageUsingDELETE_TYPE
 * raw_url: deleteStorageUsingDELETE_RAW_URL
 * @param id - 
 */
export const deleteStorageUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/storage/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteStorageUsingDELETE_RAW_URL = function() {
  return '/storage/{id}'
}
export const deleteStorageUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteStorageUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/storage/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getStaticResourceByIdUsingGET
 * url: getStaticResourceByIdUsingGETURL
 * method: getStaticResourceByIdUsingGET_TYPE
 * raw_url: getStaticResourceByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getStaticResourceByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStaticResourceByIdUsingGET_RAW_URL = function() {
  return '/static-resource/{id}'
}
export const getStaticResourceByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getStaticResourceByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateStaticResourceUsingPUT
 * url: updateStaticResourceUsingPUTURL
 * method: updateStaticResourceUsingPUT_TYPE
 * raw_url: updateStaticResourceUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateStaticResourceUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateStaticResourceUsingPUT_RAW_URL = function() {
  return '/static-resource/{id}'
}
export const updateStaticResourceUsingPUT_TYPE = function() {
  return 'put'
}
export const updateStaticResourceUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteStaticResourceUsingDELETE
 * url: deleteStaticResourceUsingDELETEURL
 * method: deleteStaticResourceUsingDELETE_TYPE
 * raw_url: deleteStaticResourceUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteStaticResourceUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteStaticResourceUsingDELETE_RAW_URL = function() {
  return '/static-resource/{id}'
}
export const deleteStaticResourceUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteStaticResourceUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateStaticResourceRolesUsingPUT
 * url: updateStaticResourceRolesUsingPUTURL
 * method: updateStaticResourceRolesUsingPUT_TYPE
 * raw_url: updateStaticResourceRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateStaticResourceRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateStaticResourceRolesUsingPUT_RAW_URL = function() {
  return '/static-resource/{id}/roles'
}
export const updateStaticResourceRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateStaticResourceRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateSettingRolesUsingPUT
 * url: updateSettingRolesUsingPUTURL
 * method: updateSettingRolesUsingPUT_TYPE
 * raw_url: updateSettingRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateSettingRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateSettingRolesUsingPUT_RAW_URL = function() {
  return '/setting/{id}/roles'
}
export const updateSettingRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateSettingRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateProcessSettingUsingPUT
 * url: updateProcessSettingUsingPUTURL
 * method: updateProcessSettingUsingPUT_TYPE
 * raw_url: updateProcessSettingUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateProcessSettingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/process/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateProcessSettingUsingPUT_RAW_URL = function() {
  return '/setting/process/{id}'
}
export const updateProcessSettingUsingPUT_TYPE = function() {
  return 'put'
}
export const updateProcessSettingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/process/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updatePluginSettingUsingPUT
 * url: updatePluginSettingUsingPUTURL
 * method: updatePluginSettingUsingPUT_TYPE
 * raw_url: updatePluginSettingUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updatePluginSettingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/plugin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updatePluginSettingUsingPUT_RAW_URL = function() {
  return '/setting/plugin/{id}'
}
export const updatePluginSettingUsingPUT_TYPE = function() {
  return 'put'
}
export const updatePluginSettingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/plugin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateInstanceProcessingSettingUsingPUT
 * url: updateInstanceProcessingSettingUsingPUTURL
 * method: updateInstanceProcessingSettingUsingPUT_TYPE
 * raw_url: updateInstanceProcessingSettingUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateInstanceProcessingSettingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/instance-processing/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateInstanceProcessingSettingUsingPUT_RAW_URL = function() {
  return '/setting/instance-processing/{id}'
}
export const updateInstanceProcessingSettingUsingPUT_TYPE = function() {
  return 'put'
}
export const updateInstanceProcessingSettingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/instance-processing/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateInstanceAdminSettingUsingPUT
 * url: updateInstanceAdminSettingUsingPUTURL
 * method: updateInstanceAdminSettingUsingPUT_TYPE
 * raw_url: updateInstanceAdminSettingUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateInstanceAdminSettingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/instance-admin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateInstanceAdminSettingUsingPUT_RAW_URL = function() {
  return '/setting/instance-admin/{id}'
}
export const updateInstanceAdminSettingUsingPUT_TYPE = function() {
  return 'put'
}
export const updateInstanceAdminSettingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/instance-admin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getScreenByIdUsingGET
 * url: getScreenByIdUsingGETURL
 * method: getScreenByIdUsingGET_TYPE
 * raw_url: getScreenByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getScreenByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getScreenByIdUsingGET_RAW_URL = function() {
  return '/screen/{id}'
}
export const getScreenByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getScreenByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateScreenUsingPUT
 * url: updateScreenUsingPUTURL
 * method: updateScreenUsingPUT_TYPE
 * raw_url: updateScreenUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateScreenUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateScreenUsingPUT_RAW_URL = function() {
  return '/screen/{id}'
}
export const updateScreenUsingPUT_TYPE = function() {
  return 'put'
}
export const updateScreenUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteScreenUsingDELETE
 * url: deleteScreenUsingDELETEURL
 * method: deleteScreenUsingDELETE_TYPE
 * raw_url: deleteScreenUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteScreenUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteScreenUsingDELETE_RAW_URL = function() {
  return '/screen/{id}'
}
export const deleteScreenUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteScreenUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateScreenRolesUsingPUT
 * url: updateScreenRolesUsingPUTURL
 * method: updateScreenRolesUsingPUT_TYPE
 * raw_url: updateScreenRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateScreenRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateScreenRolesUsingPUT_RAW_URL = function() {
  return '/screen/{id}/roles'
}
export const updateScreenRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateScreenRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getRoleByIdUsingGET
 * url: getRoleByIdUsingGETURL
 * method: getRoleByIdUsingGET_TYPE
 * raw_url: getRoleByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getRoleByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/role/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleByIdUsingGET_RAW_URL = function() {
  return '/role/{id}'
}
export const getRoleByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getRoleByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/role/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateRoleUsingPUT
 * url: updateRoleUsingPUTURL
 * method: updateRoleUsingPUT_TYPE
 * raw_url: updateRoleUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateRoleUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/role/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateRoleUsingPUT_RAW_URL = function() {
  return '/role/{id}'
}
export const updateRoleUsingPUT_TYPE = function() {
  return 'put'
}
export const updateRoleUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/role/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteRoleUsingDELETE
 * url: deleteRoleUsingDELETEURL
 * method: deleteRoleUsingDELETE_TYPE
 * raw_url: deleteRoleUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteRoleUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/role/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteRoleUsingDELETE_RAW_URL = function() {
  return '/role/{id}'
}
export const deleteRoleUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteRoleUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/role/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessByIdUsingGET
 * url: getProcessByIdUsingGETURL
 * method: getProcessByIdUsingGET_TYPE
 * raw_url: getProcessByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getProcessByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessByIdUsingGET_RAW_URL = function() {
  return '/process/{id}'
}
export const getProcessByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateProcessUsingPUT
 * url: updateProcessUsingPUTURL
 * method: updateProcessUsingPUT_TYPE
 * raw_url: updateProcessUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateProcessUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateProcessUsingPUT_RAW_URL = function() {
  return '/process/{id}'
}
export const updateProcessUsingPUT_TYPE = function() {
  return 'put'
}
export const updateProcessUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteProcessUsingDELETE
 * url: deleteProcessUsingDELETEURL
 * method: deleteProcessUsingDELETE_TYPE
 * raw_url: deleteProcessUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteProcessUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteProcessUsingDELETE_RAW_URL = function() {
  return '/process/{id}'
}
export const deleteProcessUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteProcessUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateProcessRolesUsingPUT
 * url: updateProcessRolesUsingPUTURL
 * method: updateProcessRolesUsingPUT_TYPE
 * raw_url: updateProcessRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateProcessRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateProcessRolesUsingPUT_RAW_URL = function() {
  return '/process/{id}/roles'
}
export const updateProcessRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateProcessRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateProcessCredentialRolesUsingPUT
 * url: updateProcessCredentialRolesUsingPUTURL
 * method: updateProcessCredentialRolesUsingPUT_TYPE
 * raw_url: updateProcessCredentialRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateProcessCredentialRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateProcessCredentialRolesUsingPUT_RAW_URL = function() {
  return '/process-credential/{id}/roles'
}
export const updateProcessCredentialRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateProcessCredentialRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateWhatsAppProcessCredentialUsingPUT
 * url: updateWhatsAppProcessCredentialUsingPUTURL
 * method: updateWhatsAppProcessCredentialUsingPUT_TYPE
 * raw_url: updateWhatsAppProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateWhatsAppProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/whatsapp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateWhatsAppProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/whatsapp/{id}'
}
export const updateWhatsAppProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateWhatsAppProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/whatsapp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateTwilioProcessCredentialUsingPUT
 * url: updateTwilioProcessCredentialUsingPUTURL
 * method: updateTwilioProcessCredentialUsingPUT_TYPE
 * raw_url: updateTwilioProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateTwilioProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/twilio/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTwilioProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/twilio/{id}'
}
export const updateTwilioProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTwilioProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/twilio/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateStripeConnectProcessCredentialUsingPUT
 * url: updateStripeConnectProcessCredentialUsingPUTURL
 * method: updateStripeConnectProcessCredentialUsingPUT_TYPE
 * raw_url: updateStripeConnectProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateStripeConnectProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/stripe-connect/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateStripeConnectProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/stripe-connect/{id}'
}
export const updateStripeConnectProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateStripeConnectProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/stripe-connect/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateSshCredentialUsingPUT
 * url: updateSshCredentialUsingPUTURL
 * method: updateSshCredentialUsingPUT_TYPE
 * raw_url: updateSshCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateSshCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ssh/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateSshCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/ssh/{id}'
}
export const updateSshCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateSshCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ssh/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateSshKeyCredentialUsingPUT
 * url: updateSshKeyCredentialUsingPUTURL
 * method: updateSshKeyCredentialUsingPUT_TYPE
 * raw_url: updateSshKeyCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateSshKeyCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ssh-key/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateSshKeyCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/ssh-key/{id}'
}
export const updateSshKeyCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateSshKeyCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ssh-key/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateSoapCredentialUsingPUT
 * url: updateSoapCredentialUsingPUTURL
 * method: updateSoapCredentialUsingPUT_TYPE
 * raw_url: updateSoapCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateSoapCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/soap/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateSoapCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/soap/{id}'
}
export const updateSoapCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateSoapCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/soap/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateSmtpProcessCredentialUsingPUT
 * url: updateSmtpProcessCredentialUsingPUTURL
 * method: updateSmtpProcessCredentialUsingPUT_TYPE
 * raw_url: updateSmtpProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateSmtpProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/smtp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateSmtpProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/smtp/{id}'
}
export const updateSmtpProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateSmtpProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/smtp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateSlackProcessCredentialUsingPUT
 * url: updateSlackProcessCredentialUsingPUTURL
 * method: updateSlackProcessCredentialUsingPUT_TYPE
 * raw_url: updateSlackProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateSlackProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/slack/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateSlackProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/slack/{id}'
}
export const updateSlackProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateSlackProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/slack/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateSftpProcessCredentialUsingPUT
 * url: updateSftpProcessCredentialUsingPUTURL
 * method: updateSftpProcessCredentialUsingPUT_TYPE
 * raw_url: updateSftpProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateSftpProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/sftp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateSftpProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/sftp/{id}'
}
export const updateSftpProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateSftpProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/sftp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateSecurityCredentialUsingPUT
 * url: updateSecurityCredentialUsingPUTURL
 * method: updateSecurityCredentialUsingPUT_TYPE
 * raw_url: updateSecurityCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateSecurityCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/security/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateSecurityCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/security/{id}'
}
export const updateSecurityCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateSecurityCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/security/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateScriptCredentialUsingPUT
 * url: updateScriptCredentialUsingPUTURL
 * method: updateScriptCredentialUsingPUT_TYPE
 * raw_url: updateScriptCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateScriptCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/script/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateScriptCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/script/{id}'
}
export const updateScriptCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateScriptCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/script/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateRestCredentialUsingPUT
 * url: updateRestCredentialUsingPUTURL
 * method: updateRestCredentialUsingPUT_TYPE
 * raw_url: updateRestCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateRestCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/rest/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateRestCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/rest/{id}'
}
export const updateRestCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateRestCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/rest/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateRestBearerCredentialUsingPUT
 * url: updateRestBearerCredentialUsingPUTURL
 * method: updateRestBearerCredentialUsingPUT_TYPE
 * raw_url: updateRestBearerCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateRestBearerCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/rest-bearer/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateRestBearerCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/rest-bearer/{id}'
}
export const updateRestBearerCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateRestBearerCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/rest-bearer/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateRestBasicCredentialUsingPUT
 * url: updateRestBasicCredentialUsingPUTURL
 * method: updateRestBasicCredentialUsingPUT_TYPE
 * raw_url: updateRestBasicCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateRestBasicCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/rest-basic/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateRestBasicCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/rest-basic/{id}'
}
export const updateRestBasicCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateRestBasicCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/rest-basic/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateRabbitmqCredentialUsingPUT
 * url: updateRabbitmqCredentialUsingPUTURL
 * method: updateRabbitmqCredentialUsingPUT_TYPE
 * raw_url: updateRabbitmqCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateRabbitmqCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/rabbitmq/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateRabbitmqCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/rabbitmq/{id}'
}
export const updateRabbitmqCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateRabbitmqCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/rabbitmq/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updatePluginCredentialUsingPUT
 * url: updatePluginCredentialUsingPUTURL
 * method: updatePluginCredentialUsingPUT_TYPE
 * raw_url: updatePluginCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updatePluginCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/plugin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updatePluginCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/plugin/{id}'
}
export const updatePluginCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updatePluginCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/plugin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updatePaymentSensePacCredentialUsingPUT
 * url: updatePaymentSensePacCredentialUsingPUTURL
 * method: updatePaymentSensePacCredentialUsingPUT_TYPE
 * raw_url: updatePaymentSensePacCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updatePaymentSensePacCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/payment-sense-pac/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updatePaymentSensePacCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/payment-sense-pac/{id}'
}
export const updatePaymentSensePacCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updatePaymentSensePacCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/payment-sense-pac/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updatePaymentSenseConnectECredentialUsingPUT
 * url: updatePaymentSenseConnectECredentialUsingPUTURL
 * method: updatePaymentSenseConnectECredentialUsingPUT_TYPE
 * raw_url: updatePaymentSenseConnectECredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updatePaymentSenseConnectECredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/payment-sense-connect-e/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updatePaymentSenseConnectECredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/payment-sense-connect-e/{id}'
}
export const updatePaymentSenseConnectECredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updatePaymentSenseConnectECredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/payment-sense-connect-e/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateOpenAIProcessCredentialUsingPUT
 * url: updateOpenAIProcessCredentialUsingPUTURL
 * method: updateOpenAIProcessCredentialUsingPUT_TYPE
 * raw_url: updateOpenAIProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateOpenAIProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/open-ai/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateOpenAIProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/open-ai/{id}'
}
export const updateOpenAIProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateOpenAIProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/open-ai/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateNeo4jCredentialUsingPUT
 * url: updateNeo4jCredentialUsingPUTURL
 * method: updateNeo4jCredentialUsingPUT_TYPE
 * raw_url: updateNeo4jCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateNeo4jCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/neo4j/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateNeo4jCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/neo4j/{id}'
}
export const updateNeo4jCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateNeo4jCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/neo4j/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateMsGraphApiProcessCredentialUsingPUT
 * url: updateMsGraphApiProcessCredentialUsingPUTURL
 * method: updateMsGraphApiProcessCredentialUsingPUT_TYPE
 * raw_url: updateMsGraphApiProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateMsGraphApiProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ms-graph-api/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateMsGraphApiProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/ms-graph-api/{id}'
}
export const updateMsGraphApiProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateMsGraphApiProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ms-graph-api/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateMqttCredentialUsingPUT
 * url: updateMqttCredentialUsingPUTURL
 * method: updateMqttCredentialUsingPUT_TYPE
 * raw_url: updateMqttCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateMqttCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mqtt/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateMqttCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/mqtt/{id}'
}
export const updateMqttCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateMqttCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mqtt/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateMongodbProcessCredentialUsingPUT
 * url: updateMongodbProcessCredentialUsingPUTURL
 * method: updateMongodbProcessCredentialUsingPUT_TYPE
 * raw_url: updateMongodbProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateMongodbProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mongodb/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateMongodbProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/mongodb/{id}'
}
export const updateMongodbProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateMongodbProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mongodb/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateMcpStdioProcessCredentialUsingPUT
 * url: updateMcpStdioProcessCredentialUsingPUTURL
 * method: updateMcpStdioProcessCredentialUsingPUT_TYPE
 * raw_url: updateMcpStdioProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateMcpStdioProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mcp-stdio/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateMcpStdioProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/mcp-stdio/{id}'
}
export const updateMcpStdioProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateMcpStdioProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mcp-stdio/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateMcpSseProcessCredentialUsingPUT
 * url: updateMcpSseProcessCredentialUsingPUTURL
 * method: updateMcpSseProcessCredentialUsingPUT_TYPE
 * raw_url: updateMcpSseProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateMcpSseProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mcp-sse/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateMcpSseProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/mcp-sse/{id}'
}
export const updateMcpSseProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateMcpSseProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mcp-sse/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateMcpOpenaiConnectorProcessCredentialUsingPUT
 * url: updateMcpOpenaiConnectorProcessCredentialUsingPUTURL
 * method: updateMcpOpenaiConnectorProcessCredentialUsingPUT_TYPE
 * raw_url: updateMcpOpenaiConnectorProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateMcpOpenaiConnectorProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mcp-openai-connector/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateMcpOpenaiConnectorProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/mcp-openai-connector/{id}'
}
export const updateMcpOpenaiConnectorProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateMcpOpenaiConnectorProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mcp-openai-connector/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateMcpHttpProcessCredentialUsingPUT
 * url: updateMcpHttpProcessCredentialUsingPUTURL
 * method: updateMcpHttpProcessCredentialUsingPUT_TYPE
 * raw_url: updateMcpHttpProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateMcpHttpProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mcp-http/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateMcpHttpProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/mcp-http/{id}'
}
export const updateMcpHttpProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateMcpHttpProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mcp-http/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateLdapCredentialUsingPUT
 * url: updateLdapCredentialUsingPUTURL
 * method: updateLdapCredentialUsingPUT_TYPE
 * raw_url: updateLdapCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateLdapCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ldap/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateLdapCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/ldap/{id}'
}
export const updateLdapCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateLdapCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ldap/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateKafkaCredentialUsingPUT
 * url: updateKafkaCredentialUsingPUTURL
 * method: updateKafkaCredentialUsingPUT_TYPE
 * raw_url: updateKafkaCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateKafkaCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/kafka/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateKafkaCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/kafka/{id}'
}
export const updateKafkaCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateKafkaCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/kafka/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateJwtProcessCredentialUsingPUT
 * url: updateJwtProcessCredentialUsingPUTURL
 * method: updateJwtProcessCredentialUsingPUT_TYPE
 * raw_url: updateJwtProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateJwtProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jwt/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateJwtProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/jwt/{id}'
}
export const updateJwtProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateJwtProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jwt/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateJmsCredentialUsingPUT
 * url: updateJmsCredentialUsingPUTURL
 * method: updateJmsCredentialUsingPUT_TYPE
 * raw_url: updateJmsCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateJmsCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jms/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateJmsCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/jms/{id}'
}
export const updateJmsCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateJmsCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jms/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateJiraCredentialUsingPUT
 * url: updateJiraCredentialUsingPUTURL
 * method: updateJiraCredentialUsingPUT_TYPE
 * raw_url: updateJiraCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateJiraCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jira/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateJiraCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/jira/{id}'
}
export const updateJiraCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateJiraCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jira/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateJdbcProcessCredentialUsingPUT
 * url: updateJdbcProcessCredentialUsingPUTURL
 * method: updateJdbcProcessCredentialUsingPUT_TYPE
 * raw_url: updateJdbcProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateJdbcProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jdbc/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateJdbcProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/jdbc/{id}'
}
export const updateJdbcProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateJdbcProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jdbc/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateImapProcessCredentialUsingPUT
 * url: updateImapProcessCredentialUsingPUTURL
 * method: updateImapProcessCredentialUsingPUT_TYPE
 * raw_url: updateImapProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateImapProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/imap/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateImapProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/imap/{id}'
}
export const updateImapProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateImapProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/imap/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateGotenbergCredentialUsingPUT
 * url: updateGotenbergCredentialUsingPUTURL
 * method: updateGotenbergCredentialUsingPUT_TYPE
 * raw_url: updateGotenbergCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateGotenbergCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/gotenberg/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateGotenbergCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/gotenberg/{id}'
}
export const updateGotenbergCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateGotenbergCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/gotenberg/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateGitCredentialUsingPUT
 * url: updateGitCredentialUsingPUTURL
 * method: updateGitCredentialUsingPUT_TYPE
 * raw_url: updateGitCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateGitCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/git/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateGitCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/git/{id}'
}
export const updateGitCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateGitCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/git/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateFtpProcessCredentialUsingPUT
 * url: updateFtpProcessCredentialUsingPUTURL
 * method: updateFtpProcessCredentialUsingPUT_TYPE
 * raw_url: updateFtpProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateFtpProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ftp/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateFtpProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/ftp/{id}'
}
export const updateFtpProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateFtpProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ftp/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateFlowyCredentialUsingPUT
 * url: updateFlowyCredentialUsingPUTURL
 * method: updateFlowyCredentialUsingPUT_TYPE
 * raw_url: updateFlowyCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateFlowyCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/flowy/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateFlowyCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/flowy/{id}'
}
export const updateFlowyCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateFlowyCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/flowy/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateDeepSeekProcessCredentialUsingPUT
 * url: updateDeepSeekProcessCredentialUsingPUTURL
 * method: updateDeepSeekProcessCredentialUsingPUT_TYPE
 * raw_url: updateDeepSeekProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateDeepSeekProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/deep-seek/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateDeepSeekProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/deep-seek/{id}'
}
export const updateDeepSeekProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateDeepSeekProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/deep-seek/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateAwsCredentialUsingPUT
 * url: updateAwsCredentialUsingPUTURL
 * method: updateAwsCredentialUsingPUT_TYPE
 * raw_url: updateAwsCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateAwsCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/aws/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateAwsCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/aws/{id}'
}
export const updateAwsCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateAwsCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/aws/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateAnthropicProcessCredentialUsingPUT
 * url: updateAnthropicProcessCredentialUsingPUTURL
 * method: updateAnthropicProcessCredentialUsingPUT_TYPE
 * raw_url: updateAnthropicProcessCredentialUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateAnthropicProcessCredentialUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/anthropic/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateAnthropicProcessCredentialUsingPUT_RAW_URL = function() {
  return '/process-credential/anthropic/{id}'
}
export const updateAnthropicProcessCredentialUsingPUT_TYPE = function() {
  return 'put'
}
export const updateAnthropicProcessCredentialUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/anthropic/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getPluginByIdUsingGET
 * url: getPluginByIdUsingGETURL
 * method: getPluginByIdUsingGET_TYPE
 * raw_url: getPluginByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getPluginByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPluginByIdUsingGET_RAW_URL = function() {
  return '/plugin/{id}'
}
export const getPluginByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getPluginByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updatePluginUsingPUT
 * url: updatePluginUsingPUTURL
 * method: updatePluginUsingPUT_TYPE
 * raw_url: updatePluginUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updatePluginUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updatePluginUsingPUT_RAW_URL = function() {
  return '/plugin/{id}'
}
export const updatePluginUsingPUT_TYPE = function() {
  return 'put'
}
export const updatePluginUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deletePluginUsingDELETE
 * url: deletePluginUsingDELETEURL
 * method: deletePluginUsingDELETE_TYPE
 * raw_url: deletePluginUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deletePluginUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deletePluginUsingDELETE_RAW_URL = function() {
  return '/plugin/{id}'
}
export const deletePluginUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deletePluginUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updatePluginRolesUsingPUT
 * url: updatePluginRolesUsingPUTURL
 * method: updatePluginRolesUsingPUT_TYPE
 * raw_url: updatePluginRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updatePluginRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updatePluginRolesUsingPUT_RAW_URL = function() {
  return '/plugin/{id}/roles'
}
export const updatePluginRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updatePluginRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updatePasswordUsingPUT
 * url: updatePasswordUsingPUTURL
 * method: updatePasswordUsingPUT_TYPE
 * raw_url: updatePasswordUsingPUT_RAW_URL
 * @param body - 
 */
export const updatePasswordUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/password'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updatePasswordUsingPUT_RAW_URL = function() {
  return '/password'
}
export const updatePasswordUsingPUT_TYPE = function() {
  return 'put'
}
export const updatePasswordUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/password'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getModuleByIdUsingGET
 * url: getModuleByIdUsingGETURL
 * method: getModuleByIdUsingGET_TYPE
 * raw_url: getModuleByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getModuleByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleByIdUsingGET_RAW_URL = function() {
  return '/module/{id}'
}
export const getModuleByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateModuleUsingPUT
 * url: updateModuleUsingPUTURL
 * method: updateModuleUsingPUT_TYPE
 * raw_url: updateModuleUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateModuleUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateModuleUsingPUT_RAW_URL = function() {
  return '/module/{id}'
}
export const updateModuleUsingPUT_TYPE = function() {
  return 'put'
}
export const updateModuleUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteModuleUsingDELETE
 * url: deleteModuleUsingDELETEURL
 * method: deleteModuleUsingDELETE_TYPE
 * raw_url: deleteModuleUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteModuleUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteModuleUsingDELETE_RAW_URL = function() {
  return '/module/{id}'
}
export const deleteModuleUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteModuleUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateModuleRolesUsingPUT
 * url: updateModuleRolesUsingPUTURL
 * method: updateModuleRolesUsingPUT_TYPE
 * raw_url: updateModuleRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateModuleRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateModuleRolesUsingPUT_RAW_URL = function() {
  return '/module/{id}/roles'
}
export const updateModuleRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateModuleRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getLibraryByIdUsingGET
 * url: getLibraryByIdUsingGETURL
 * method: getLibraryByIdUsingGET_TYPE
 * raw_url: getLibraryByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getLibraryByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getLibraryByIdUsingGET_RAW_URL = function() {
  return '/library/{id}'
}
export const getLibraryByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getLibraryByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateLibraryUsingPUT
 * url: updateLibraryUsingPUTURL
 * method: updateLibraryUsingPUT_TYPE
 * raw_url: updateLibraryUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateLibraryUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateLibraryUsingPUT_RAW_URL = function() {
  return '/library/{id}'
}
export const updateLibraryUsingPUT_TYPE = function() {
  return 'put'
}
export const updateLibraryUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteLibraryUsingDELETE
 * url: deleteLibraryUsingDELETEURL
 * method: deleteLibraryUsingDELETE_TYPE
 * raw_url: deleteLibraryUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteLibraryUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteLibraryUsingDELETE_RAW_URL = function() {
  return '/library/{id}'
}
export const deleteLibraryUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteLibraryUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateLibraryRolesUsingPUT
 * url: updateLibraryRolesUsingPUTURL
 * method: updateLibraryRolesUsingPUT_TYPE
 * raw_url: updateLibraryRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateLibraryRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateLibraryRolesUsingPUT_RAW_URL = function() {
  return '/library/{id}/roles'
}
export const updateLibraryRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateLibraryRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateUploadModuleUsingPUT
 * url: updateUploadModuleUsingPUTURL
 * method: updateUploadModuleUsingPUT_TYPE
 * raw_url: updateUploadModuleUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateUploadModuleUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/module/upload/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateUploadModuleUsingPUT_RAW_URL = function() {
  return '/hub/module/upload/{id}'
}
export const updateUploadModuleUsingPUT_TYPE = function() {
  return 'put'
}
export const updateUploadModuleUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/module/upload/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateProcessingGlobalSettingUsingPUT
 * url: updateProcessingGlobalSettingUsingPUTURL
 * method: updateProcessingGlobalSettingUsingPUT_TYPE
 * raw_url: updateProcessingGlobalSettingUsingPUT_RAW_URL
 * @param body - 
 */
export const updateProcessingGlobalSettingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/global-setting/processing'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateProcessingGlobalSettingUsingPUT_RAW_URL = function() {
  return '/global-setting/processing'
}
export const updateProcessingGlobalSettingUsingPUT_TYPE = function() {
  return 'put'
}
export const updateProcessingGlobalSettingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/global-setting/processing'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateOAuthGlobalSettingUsingPUT
 * url: updateOAuthGlobalSettingUsingPUTURL
 * method: updateOAuthGlobalSettingUsingPUT_TYPE
 * raw_url: updateOAuthGlobalSettingUsingPUT_RAW_URL
 * @param body - 
 */
export const updateOAuthGlobalSettingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/global-setting/oauth'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateOAuthGlobalSettingUsingPUT_RAW_URL = function() {
  return '/global-setting/oauth'
}
export const updateOAuthGlobalSettingUsingPUT_TYPE = function() {
  return 'put'
}
export const updateOAuthGlobalSettingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/global-setting/oauth'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateFrontendGlobalSettingUsingPUT
 * url: updateFrontendGlobalSettingUsingPUTURL
 * method: updateFrontendGlobalSettingUsingPUT_TYPE
 * raw_url: updateFrontendGlobalSettingUsingPUT_RAW_URL
 * @param body - 
 */
export const updateFrontendGlobalSettingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/global-setting/frontend'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateFrontendGlobalSettingUsingPUT_RAW_URL = function() {
  return '/global-setting/frontend'
}
export const updateFrontendGlobalSettingUsingPUT_TYPE = function() {
  return 'put'
}
export const updateFrontendGlobalSettingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/global-setting/frontend'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateAdminGlobalSettingUsingPUT
 * url: updateAdminGlobalSettingUsingPUTURL
 * method: updateAdminGlobalSettingUsingPUT_TYPE
 * raw_url: updateAdminGlobalSettingUsingPUT_RAW_URL
 * @param body - 
 */
export const updateAdminGlobalSettingUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/global-setting/admin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateAdminGlobalSettingUsingPUT_RAW_URL = function() {
  return '/global-setting/admin'
}
export const updateAdminGlobalSettingUsingPUT_TYPE = function() {
  return 'put'
}
export const updateAdminGlobalSettingUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/global-setting/admin'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getFlowByIdUsingGET
 * url: getFlowByIdUsingGETURL
 * method: getFlowByIdUsingGET_TYPE
 * raw_url: getFlowByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getFlowByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFlowByIdUsingGET_RAW_URL = function() {
  return '/flow/{id}'
}
export const getFlowByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getFlowByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateFlowUsingPUT
 * url: updateFlowUsingPUTURL
 * method: updateFlowUsingPUT_TYPE
 * raw_url: updateFlowUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateFlowUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateFlowUsingPUT_RAW_URL = function() {
  return '/flow/{id}'
}
export const updateFlowUsingPUT_TYPE = function() {
  return 'put'
}
export const updateFlowUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteFlowUsingDELETE
 * url: deleteFlowUsingDELETEURL
 * method: deleteFlowUsingDELETE_TYPE
 * raw_url: deleteFlowUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteFlowUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteFlowUsingDELETE_RAW_URL = function() {
  return '/flow/{id}'
}
export const deleteFlowUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteFlowUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateFlowRolesUsingPUT
 * url: updateFlowRolesUsingPUTURL
 * method: updateFlowRolesUsingPUT_TYPE
 * raw_url: updateFlowRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateFlowRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateFlowRolesUsingPUT_RAW_URL = function() {
  return '/flow/{id}/roles'
}
export const updateFlowRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateFlowRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEntityByIdUsingGET
 * url: getEntityByIdUsingGETURL
 * method: getEntityByIdUsingGET_TYPE
 * raw_url: getEntityByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getEntityByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEntityByIdUsingGET_RAW_URL = function() {
  return '/entity/{id}'
}
export const getEntityByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getEntityByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateEntityUsingPUT
 * url: updateEntityUsingPUTURL
 * method: updateEntityUsingPUT_TYPE
 * raw_url: updateEntityUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateEntityUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateEntityUsingPUT_RAW_URL = function() {
  return '/entity/{id}'
}
export const updateEntityUsingPUT_TYPE = function() {
  return 'put'
}
export const updateEntityUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteEntityUsingDELETE
 * url: deleteEntityUsingDELETEURL
 * method: deleteEntityUsingDELETE_TYPE
 * raw_url: deleteEntityUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteEntityUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteEntityUsingDELETE_RAW_URL = function() {
  return '/entity/{id}'
}
export const deleteEntityUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteEntityUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEntityTagsUsingGET
 * url: getEntityTagsUsingGETURL
 * method: getEntityTagsUsingGET_TYPE
 * raw_url: getEntityTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getEntityTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEntityTagsUsingGET_RAW_URL = function() {
  return '/entity/{id}/tags'
}
export const getEntityTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getEntityTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: setEntityTagsUsingPUT
 * url: setEntityTagsUsingPUTURL
 * method: setEntityTagsUsingPUT_TYPE
 * raw_url: setEntityTagsUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const setEntityTagsUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const setEntityTagsUsingPUT_RAW_URL = function() {
  return '/entity/{id}/tags'
}
export const setEntityTagsUsingPUT_TYPE = function() {
  return 'put'
}
export const setEntityTagsUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateEntityRolesUsingPUT
 * url: updateEntityRolesUsingPUTURL
 * method: updateEntityRolesUsingPUT_TYPE
 * raw_url: updateEntityRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateEntityRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateEntityRolesUsingPUT_RAW_URL = function() {
  return '/entity/{id}/roles'
}
export const updateEntityRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateEntityRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: entityPersistenceExecuteUpdateUsingPUT
 * url: entityPersistenceExecuteUpdateUsingPUTURL
 * method: entityPersistenceExecuteUpdateUsingPUT_TYPE
 * raw_url: entityPersistenceExecuteUpdateUsingPUT_RAW_URL
 * @param id - 
 */
export const entityPersistenceExecuteUpdateUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/persistence/update/execute'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const entityPersistenceExecuteUpdateUsingPUT_RAW_URL = function() {
  return '/entity/{id}/persistence/update/execute'
}
export const entityPersistenceExecuteUpdateUsingPUT_TYPE = function() {
  return 'put'
}
export const entityPersistenceExecuteUpdateUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/persistence/update/execute'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationByIdUsingGET
 * url: getApplicationByIdUsingGETURL
 * method: getApplicationByIdUsingGET_TYPE
 * raw_url: getApplicationByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getApplicationByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationByIdUsingGET_RAW_URL = function() {
  return '/application/{id}'
}
export const getApplicationByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateApplicationUsingPUT
 * url: updateApplicationUsingPUTURL
 * method: updateApplicationUsingPUT_TYPE
 * raw_url: updateApplicationUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateApplicationUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateApplicationUsingPUT_RAW_URL = function() {
  return '/application/{id}'
}
export const updateApplicationUsingPUT_TYPE = function() {
  return 'put'
}
export const updateApplicationUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteApplicationUsingDELETE
 * url: deleteApplicationUsingDELETEURL
 * method: deleteApplicationUsingDELETE_TYPE
 * raw_url: deleteApplicationUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteApplicationUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteApplicationUsingDELETE_RAW_URL = function() {
  return '/application/{id}'
}
export const deleteApplicationUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteApplicationUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateApplicationRolesUsingPUT
 * url: updateApplicationRolesUsingPUTURL
 * method: updateApplicationRolesUsingPUT_TYPE
 * raw_url: updateApplicationRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateApplicationRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateApplicationRolesUsingPUT_RAW_URL = function() {
  return '/application/{id}/roles'
}
export const updateApplicationRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateApplicationRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getAiAgentByIdUsingGET
 * url: getAiAgentByIdUsingGETURL
 * method: getAiAgentByIdUsingGET_TYPE
 * raw_url: getAiAgentByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getAiAgentByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAiAgentByIdUsingGET_RAW_URL = function() {
  return '/ai-agent/{id}'
}
export const getAiAgentByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getAiAgentByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateAiAgentUsingPUT
 * url: updateAiAgentUsingPUTURL
 * method: updateAiAgentUsingPUT_TYPE
 * raw_url: updateAiAgentUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateAiAgentUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateAiAgentUsingPUT_RAW_URL = function() {
  return '/ai-agent/{id}'
}
export const updateAiAgentUsingPUT_TYPE = function() {
  return 'put'
}
export const updateAiAgentUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteAiAgentUsingDELETE
 * url: deleteAiAgentUsingDELETEURL
 * method: deleteAiAgentUsingDELETE_TYPE
 * raw_url: deleteAiAgentUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteAiAgentUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteAiAgentUsingDELETE_RAW_URL = function() {
  return '/ai-agent/{id}'
}
export const deleteAiAgentUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteAiAgentUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: updateAiAgentRolesUsingPUT
 * url: updateAiAgentRolesUsingPUTURL
 * method: updateAiAgentRolesUsingPUT_TYPE
 * raw_url: updateAiAgentRolesUsingPUT_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateAiAgentRolesUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/roles'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateAiAgentRolesUsingPUT_RAW_URL = function() {
  return '/ai-agent/{id}/roles'
}
export const updateAiAgentRolesUsingPUT_TYPE = function() {
  return 'put'
}
export const updateAiAgentRolesUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/roles'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getValidationRulesUsingGET
 * url: getValidationRulesUsingGETURL
 * method: getValidationRulesUsingGET_TYPE
 * raw_url: getValidationRulesUsingGET_RAW_URL
 * @param isSystem - 
 * @param isAutoGenerated - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getValidationRulesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/validation-rule'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['isAutoGenerated'] !== undefined) {
    queryParameters['isAutoGenerated'] = parameters['isAutoGenerated']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getValidationRulesUsingGET_RAW_URL = function() {
  return '/validation-rule'
}
export const getValidationRulesUsingGET_TYPE = function() {
  return 'get'
}
export const getValidationRulesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/validation-rule'
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['isAutoGenerated'] !== undefined) {
    queryParameters['isAutoGenerated'] = parameters['isAutoGenerated']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createValidationRuleUsingPOST
 * url: createValidationRuleUsingPOSTURL
 * method: createValidationRuleUsingPOST_TYPE
 * raw_url: createValidationRuleUsingPOST_RAW_URL
 * @param body - 
 */
export const createValidationRuleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/validation-rule'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createValidationRuleUsingPOST_RAW_URL = function() {
  return '/validation-rule'
}
export const createValidationRuleUsingPOST_TYPE = function() {
  return 'post'
}
export const createValidationRuleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/validation-rule'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getUsersUsingGET
 * url: getUsersUsingGETURL
 * method: getUsersUsingGET_TYPE
 * raw_url: getUsersUsingGET_RAW_URL
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUsersUsingGET_RAW_URL = function() {
  return '/user'
}
export const getUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user'
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createUserUsingPOST
 * url: createUserUsingPOSTURL
 * method: createUserUsingPOST_TYPE
 * raw_url: createUserUsingPOST_RAW_URL
 * @param body - 
 */
export const createUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createUserUsingPOST_RAW_URL = function() {
  return '/user'
}
export const createUserUsingPOST_TYPE = function() {
  return 'post'
}
export const createUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: resendRegisterTokenUsingPOST
 * url: resendRegisterTokenUsingPOSTURL
 * method: resendRegisterTokenUsingPOST_TYPE
 * raw_url: resendRegisterTokenUsingPOST_RAW_URL
 * @param id - 
 */
export const resendRegisterTokenUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/resend-register-token'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const resendRegisterTokenUsingPOST_RAW_URL = function() {
  return '/user/{id}/resend-register-token'
}
export const resendRegisterTokenUsingPOST_TYPE = function() {
  return 'post'
}
export const resendRegisterTokenUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/resend-register-token'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTwoFactorAuthQRCodeUsingGET
 * url: getTwoFactorAuthQRCodeUsingGETURL
 * method: getTwoFactorAuthQRCodeUsingGET_TYPE
 * raw_url: getTwoFactorAuthQRCodeUsingGET_RAW_URL
 */
export const getTwoFactorAuthQRCodeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/two-factor-auth'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTwoFactorAuthQRCodeUsingGET_RAW_URL = function() {
  return '/user/two-factor-auth'
}
export const getTwoFactorAuthQRCodeUsingGET_TYPE = function() {
  return 'get'
}
export const getTwoFactorAuthQRCodeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/two-factor-auth'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: twoFactorAuthEnableUsingPOST
 * url: twoFactorAuthEnableUsingPOSTURL
 * method: twoFactorAuthEnableUsingPOST_TYPE
 * raw_url: twoFactorAuthEnableUsingPOST_RAW_URL
 * @param body - 
 */
export const twoFactorAuthEnableUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/two-factor-auth'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const twoFactorAuthEnableUsingPOST_RAW_URL = function() {
  return '/user/two-factor-auth'
}
export const twoFactorAuthEnableUsingPOST_TYPE = function() {
  return 'post'
}
export const twoFactorAuthEnableUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/two-factor-auth'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: twoFactorAuthDisableUsingDELETE
 * url: twoFactorAuthDisableUsingDELETEURL
 * method: twoFactorAuthDisableUsingDELETE_TYPE
 * raw_url: twoFactorAuthDisableUsingDELETE_RAW_URL
 */
export const twoFactorAuthDisableUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/two-factor-auth'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const twoFactorAuthDisableUsingDELETE_RAW_URL = function() {
  return '/user/two-factor-auth'
}
export const twoFactorAuthDisableUsingDELETE_TYPE = function() {
  return 'delete'
}
export const twoFactorAuthDisableUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/two-factor-auth'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getAllUserSettingsUsingGET
 * url: getAllUserSettingsUsingGETURL
 * method: getAllUserSettingsUsingGET_TYPE
 * raw_url: getAllUserSettingsUsingGET_RAW_URL
 */
export const getAllUserSettingsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user-setting'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllUserSettingsUsingGET_RAW_URL = function() {
  return '/user-setting'
}
export const getAllUserSettingsUsingGET_TYPE = function() {
  return 'get'
}
export const getAllUserSettingsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user-setting'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: saveUserSettingsUsingPOST
 * url: saveUserSettingsUsingPOSTURL
 * method: saveUserSettingsUsingPOST_TYPE
 * raw_url: saveUserSettingsUsingPOST_RAW_URL
 * @param body - 
 */
export const saveUserSettingsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user-setting'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveUserSettingsUsingPOST_RAW_URL = function() {
  return '/user-setting'
}
export const saveUserSettingsUsingPOST_TYPE = function() {
  return 'post'
}
export const saveUserSettingsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user-setting'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerWhatsAppsUsingGET
 * url: getTriggerWhatsAppsUsingGETURL
 * method: getTriggerWhatsAppsUsingGET_TYPE
 * raw_url: getTriggerWhatsAppsUsingGET_RAW_URL
 * @param credentialName - 
 * @param webhookPath - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTriggerWhatsAppsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['credentialName'] !== undefined) {
    queryParameters['credentialName'] = parameters['credentialName']
  }
  if (parameters['webhookPath'] !== undefined) {
    queryParameters['webhookPath'] = parameters['webhookPath']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerWhatsAppsUsingGET_RAW_URL = function() {
  return '/trigger-whatsapp'
}
export const getTriggerWhatsAppsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerWhatsAppsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp'
  if (parameters['credentialName'] !== undefined) {
    queryParameters['credentialName'] = parameters['credentialName']
  }
  if (parameters['webhookPath'] !== undefined) {
    queryParameters['webhookPath'] = parameters['webhookPath']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTriggerWhatsAppUsingPOST
 * url: createTriggerWhatsAppUsingPOSTURL
 * method: createTriggerWhatsAppUsingPOST_TYPE
 * raw_url: createTriggerWhatsAppUsingPOST_RAW_URL
 * @param body - 
 */
export const createTriggerWhatsAppUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTriggerWhatsAppUsingPOST_RAW_URL = function() {
  return '/trigger-whatsapp'
}
export const createTriggerWhatsAppUsingPOST_TYPE = function() {
  return 'post'
}
export const createTriggerWhatsAppUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerUisUsingGET
 * url: getTriggerUisUsingGETURL
 * method: getTriggerUisUsingGET_TYPE
 * raw_url: getTriggerUisUsingGET_RAW_URL
 * @param screenName - 
 * @param flowName - 
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTriggerUisUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['screenName'] !== undefined) {
    queryParameters['screenName'] = parameters['screenName']
  }
  if (parameters['flowName'] !== undefined) {
    queryParameters['flowName'] = parameters['flowName']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerUisUsingGET_RAW_URL = function() {
  return '/trigger-ui'
}
export const getTriggerUisUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerUisUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui'
  if (parameters['screenName'] !== undefined) {
    queryParameters['screenName'] = parameters['screenName']
  }
  if (parameters['flowName'] !== undefined) {
    queryParameters['flowName'] = parameters['flowName']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTriggerUiUsingPOST
 * url: createTriggerUiUsingPOSTURL
 * method: createTriggerUiUsingPOST_TYPE
 * raw_url: createTriggerUiUsingPOST_RAW_URL
 * @param body - 
 */
export const createTriggerUiUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTriggerUiUsingPOST_RAW_URL = function() {
  return '/trigger-ui'
}
export const createTriggerUiUsingPOST_TYPE = function() {
  return 'post'
}
export const createTriggerUiUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerRestsUsingGET
 * url: getTriggerRestsUsingGETURL
 * method: getTriggerRestsUsingGET_TYPE
 * raw_url: getTriggerRestsUsingGET_RAW_URL
 * @param url - 
 * @param method - 
 * @param applicationName - 
 * @param isSystem - 
 * @param isAutoGenerated - 
 * @param processId - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTriggerRestsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['url'] !== undefined) {
    queryParameters['url'] = parameters['url']
  }
  if (parameters['method'] !== undefined) {
    queryParameters['method'] = parameters['method']
  }
  if (parameters['applicationName'] !== undefined) {
    queryParameters['applicationName'] = parameters['applicationName']
  }
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['isAutoGenerated'] !== undefined) {
    queryParameters['isAutoGenerated'] = parameters['isAutoGenerated']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerRestsUsingGET_RAW_URL = function() {
  return '/trigger-rest'
}
export const getTriggerRestsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerRestsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest'
  if (parameters['url'] !== undefined) {
    queryParameters['url'] = parameters['url']
  }
  if (parameters['method'] !== undefined) {
    queryParameters['method'] = parameters['method']
  }
  if (parameters['applicationName'] !== undefined) {
    queryParameters['applicationName'] = parameters['applicationName']
  }
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['isAutoGenerated'] !== undefined) {
    queryParameters['isAutoGenerated'] = parameters['isAutoGenerated']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTriggerRestUsingPOST
 * url: createTriggerRestUsingPOSTURL
 * method: createTriggerRestUsingPOST_TYPE
 * raw_url: createTriggerRestUsingPOST_RAW_URL
 * @param body - 
 */
export const createTriggerRestUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTriggerRestUsingPOST_RAW_URL = function() {
  return '/trigger-rest'
}
export const createTriggerRestUsingPOST_TYPE = function() {
  return 'post'
}
export const createTriggerRestUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerMessagingsUsingGET
 * url: getTriggerMessagingsUsingGETURL
 * method: getTriggerMessagingsUsingGET_TYPE
 * raw_url: getTriggerMessagingsUsingGET_RAW_URL
 * @param service - 
 * @param processId - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTriggerMessagingsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['service'] !== undefined) {
    queryParameters['service'] = parameters['service']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerMessagingsUsingGET_RAW_URL = function() {
  return '/trigger-messaging'
}
export const getTriggerMessagingsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerMessagingsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging'
  if (parameters['service'] !== undefined) {
    queryParameters['service'] = parameters['service']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTriggerMessagingUsingPOST
 * url: createTriggerMessagingUsingPOSTURL
 * method: createTriggerMessagingUsingPOST_TYPE
 * raw_url: createTriggerMessagingUsingPOST_RAW_URL
 * @param body - 
 */
export const createTriggerMessagingUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTriggerMessagingUsingPOST_RAW_URL = function() {
  return '/trigger-messaging'
}
export const createTriggerMessagingUsingPOST_TYPE = function() {
  return 'post'
}
export const createTriggerMessagingUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerMcpsUsingGET
 * url: getTriggerMcpsUsingGETURL
 * method: getTriggerMcpsUsingGET_TYPE
 * raw_url: getTriggerMcpsUsingGET_RAW_URL
 * @param url - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTriggerMcpsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['url'] !== undefined) {
    queryParameters['url'] = parameters['url']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerMcpsUsingGET_RAW_URL = function() {
  return '/trigger-mcp'
}
export const getTriggerMcpsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerMcpsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp'
  if (parameters['url'] !== undefined) {
    queryParameters['url'] = parameters['url']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTriggerMcpUsingPOST
 * url: createTriggerMcpUsingPOSTURL
 * method: createTriggerMcpUsingPOST_TYPE
 * raw_url: createTriggerMcpUsingPOST_RAW_URL
 * @param body - 
 */
export const createTriggerMcpUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTriggerMcpUsingPOST_RAW_URL = function() {
  return '/trigger-mcp'
}
export const createTriggerMcpUsingPOST_TYPE = function() {
  return 'post'
}
export const createTriggerMcpUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerEventHandlersUsingGET
 * url: getTriggerEventHandlersUsingGETURL
 * method: getTriggerEventHandlersUsingGET_TYPE
 * raw_url: getTriggerEventHandlersUsingGET_RAW_URL
 * @param listenType - 
 * @param listenStatus - 
 * @param listenProcessId - 
 * @param listenAllProcesses - 
 * @param processId - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTriggerEventHandlersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['listenType'] !== undefined) {
    queryParameters['listenType'] = parameters['listenType']
  }
  if (parameters['listenStatus'] !== undefined) {
    queryParameters['listenStatus'] = parameters['listenStatus']
  }
  if (parameters['listenProcessId'] !== undefined) {
    queryParameters['listenProcessId'] = parameters['listenProcessId']
  }
  if (parameters['listenAllProcesses'] !== undefined) {
    queryParameters['listenAllProcesses'] = parameters['listenAllProcesses']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerEventHandlersUsingGET_RAW_URL = function() {
  return '/trigger-event-handler'
}
export const getTriggerEventHandlersUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerEventHandlersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler'
  if (parameters['listenType'] !== undefined) {
    queryParameters['listenType'] = parameters['listenType']
  }
  if (parameters['listenStatus'] !== undefined) {
    queryParameters['listenStatus'] = parameters['listenStatus']
  }
  if (parameters['listenProcessId'] !== undefined) {
    queryParameters['listenProcessId'] = parameters['listenProcessId']
  }
  if (parameters['listenAllProcesses'] !== undefined) {
    queryParameters['listenAllProcesses'] = parameters['listenAllProcesses']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTriggerEventHandlerUsingPOST
 * url: createTriggerEventHandlerUsingPOSTURL
 * method: createTriggerEventHandlerUsingPOST_TYPE
 * raw_url: createTriggerEventHandlerUsingPOST_RAW_URL
 * @param body - 
 */
export const createTriggerEventHandlerUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTriggerEventHandlerUsingPOST_RAW_URL = function() {
  return '/trigger-event-handler'
}
export const createTriggerEventHandlerUsingPOST_TYPE = function() {
  return 'post'
}
export const createTriggerEventHandlerUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerCronsUsingGET
 * url: getTriggerCronsUsingGETURL
 * method: getTriggerCronsUsingGET_TYPE
 * raw_url: getTriggerCronsUsingGET_RAW_URL
 * @param processId - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTriggerCronsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerCronsUsingGET_RAW_URL = function() {
  return '/trigger-cron'
}
export const getTriggerCronsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerCronsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron'
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTriggerCronUsingPOST
 * url: createTriggerCronUsingPOSTURL
 * method: createTriggerCronUsingPOST_TYPE
 * raw_url: createTriggerCronUsingPOST_RAW_URL
 * @param body - 
 */
export const createTriggerCronUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTriggerCronUsingPOST_RAW_URL = function() {
  return '/trigger-cron'
}
export const createTriggerCronUsingPOST_TYPE = function() {
  return 'post'
}
export const createTriggerCronUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTranslationsUsingGET
 * url: getTranslationsUsingGETURL
 * method: getTranslationsUsingGET_TYPE
 * raw_url: getTranslationsUsingGET_RAW_URL
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTranslationsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/translation'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTranslationsUsingGET_RAW_URL = function() {
  return '/translation'
}
export const getTranslationsUsingGET_TYPE = function() {
  return 'get'
}
export const getTranslationsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/translation'
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTranslationUsingPOST
 * url: createTranslationUsingPOSTURL
 * method: createTranslationUsingPOST_TYPE
 * raw_url: createTranslationUsingPOST_RAW_URL
 * @param body - 
 */
export const createTranslationUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/translation'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTranslationUsingPOST_RAW_URL = function() {
  return '/translation'
}
export const createTranslationUsingPOST_TYPE = function() {
  return 'post'
}
export const createTranslationUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/translation'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTextTemplatesUsingGET
 * url: getTextTemplatesUsingGETURL
 * method: getTextTemplatesUsingGET_TYPE
 * raw_url: getTextTemplatesUsingGET_RAW_URL
 * @param isSystem - 
 * @param engines - 
 * @param type - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTextTemplatesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['engines'] !== undefined) {
    queryParameters['engines'] = parameters['engines']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTextTemplatesUsingGET_RAW_URL = function() {
  return '/text-template'
}
export const getTextTemplatesUsingGET_TYPE = function() {
  return 'get'
}
export const getTextTemplatesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template'
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['engines'] !== undefined) {
    queryParameters['engines'] = parameters['engines']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTextTemplateUsingPOST
 * url: createTextTemplateUsingPOSTURL
 * method: createTextTemplateUsingPOST_TYPE
 * raw_url: createTextTemplateUsingPOST_RAW_URL
 * @param body - 
 */
export const createTextTemplateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTextTemplateUsingPOST_RAW_URL = function() {
  return '/text-template'
}
export const createTextTemplateUsingPOST_TYPE = function() {
  return 'post'
}
export const createTextTemplateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTextTemplateTranslationsUsingGET
 * url: getTextTemplateTranslationsUsingGETURL
 * method: getTextTemplateTranslationsUsingGET_TYPE
 * raw_url: getTextTemplateTranslationsUsingGET_RAW_URL
 * @param templateId - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTextTemplateTranslationsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}/translation'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTextTemplateTranslationsUsingGET_RAW_URL = function() {
  return '/text-template/{templateId}/translation'
}
export const getTextTemplateTranslationsUsingGET_TYPE = function() {
  return 'get'
}
export const getTextTemplateTranslationsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}/translation'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTextTemplateTranslationUsingPOST
 * url: createTextTemplateTranslationUsingPOSTURL
 * method: createTextTemplateTranslationUsingPOST_TYPE
 * raw_url: createTextTemplateTranslationUsingPOST_RAW_URL
 * @param templateId - 
 * @param body - 
 */
export const createTextTemplateTranslationUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}/translation'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTextTemplateTranslationUsingPOST_RAW_URL = function() {
  return '/text-template/{templateId}/translation'
}
export const createTextTemplateTranslationUsingPOST_TYPE = function() {
  return 'post'
}
export const createTextTemplateTranslationUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}/translation'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createPdfUsingPOST
 * url: createPdfUsingPOSTURL
 * method: createPdfUsingPOST_TYPE
 * raw_url: createPdfUsingPOST_RAW_URL
 * @param body - 
 */
export const createPdfUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/pdf'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createPdfUsingPOST_RAW_URL = function() {
  return '/text-template/pdf'
}
export const createPdfUsingPOST_TYPE = function() {
  return 'post'
}
export const createPdfUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/pdf'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createHtmlUsingPOST
 * url: createHtmlUsingPOSTURL
 * method: createHtmlUsingPOST_TYPE
 * raw_url: createHtmlUsingPOST_RAW_URL
 * @param body - 
 */
export const createHtmlUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/html'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createHtmlUsingPOST_RAW_URL = function() {
  return '/text-template/html'
}
export const createHtmlUsingPOST_TYPE = function() {
  return 'post'
}
export const createHtmlUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/html'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getAllTenantsUsingGET
 * url: getAllTenantsUsingGETURL
 * method: getAllTenantsUsingGET_TYPE
 * raw_url: getAllTenantsUsingGET_RAW_URL
 * @param name - 
 * @param tenantId - 
 * @param databaseUrl - 
 * @param status - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getAllTenantsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['tenantId'] !== undefined) {
    queryParameters['tenantId'] = parameters['tenantId']
  }
  if (parameters['databaseUrl'] !== undefined) {
    queryParameters['databaseUrl'] = parameters['databaseUrl']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllTenantsUsingGET_RAW_URL = function() {
  return '/tenant'
}
export const getAllTenantsUsingGET_TYPE = function() {
  return 'get'
}
export const getAllTenantsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['tenantId'] !== undefined) {
    queryParameters['tenantId'] = parameters['tenantId']
  }
  if (parameters['databaseUrl'] !== undefined) {
    queryParameters['databaseUrl'] = parameters['databaseUrl']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTenantUsingPOST
 * url: createTenantUsingPOSTURL
 * method: createTenantUsingPOST_TYPE
 * raw_url: createTenantUsingPOST_RAW_URL
 * @param body - 
 */
export const createTenantUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTenantUsingPOST_RAW_URL = function() {
  return '/tenant'
}
export const createTenantUsingPOST_TYPE = function() {
  return 'post'
}
export const createTenantUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: listTenantUsersUsingGET
 * url: listTenantUsersUsingGETURL
 * method: listTenantUsersUsingGET_TYPE
 * raw_url: listTenantUsersUsingGET_RAW_URL
 * @param tenantId - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const listTenantUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{tenantId}/user'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters['tenantId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tenantId'))
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const listTenantUsersUsingGET_RAW_URL = function() {
  return '/tenant/{tenantId}/user'
}
export const listTenantUsersUsingGET_TYPE = function() {
  return 'get'
}
export const listTenantUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{tenantId}/user'
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTenantUserUsingPOST
 * url: createTenantUserUsingPOSTURL
 * method: createTenantUserUsingPOST_TYPE
 * raw_url: createTenantUserUsingPOST_RAW_URL
 * @param tenantId - 
 * @param body - 
 */
export const createTenantUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{tenantId}/user'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters['tenantId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tenantId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTenantUserUsingPOST_RAW_URL = function() {
  return '/tenant/{tenantId}/user'
}
export const createTenantUserUsingPOST_TYPE = function() {
  return 'post'
}
export const createTenantUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{tenantId}/user'
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: resendRegisterTokenForTenantUserUsingPOST
 * url: resendRegisterTokenForTenantUserUsingPOSTURL
 * method: resendRegisterTokenForTenantUserUsingPOST_TYPE
 * raw_url: resendRegisterTokenForTenantUserUsingPOST_RAW_URL
 * @param tenantId - 
 * @param id - 
 */
export const resendRegisterTokenForTenantUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{tenantId}/user/{id}/resend-register-token'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters['tenantId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tenantId'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const resendRegisterTokenForTenantUserUsingPOST_RAW_URL = function() {
  return '/tenant/{tenantId}/user/{id}/resend-register-token'
}
export const resendRegisterTokenForTenantUserUsingPOST_TYPE = function() {
  return 'post'
}
export const resendRegisterTokenForTenantUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{tenantId}/user/{id}/resend-register-token'
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testConnectionUsingPOST
 * url: testConnectionUsingPOSTURL
 * method: testConnectionUsingPOST_TYPE
 * raw_url: testConnectionUsingPOST_RAW_URL
 * @param id - 
 */
export const testConnectionUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{id}/test-connection'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testConnectionUsingPOST_RAW_URL = function() {
  return '/tenant/{id}/test-connection'
}
export const testConnectionUsingPOST_TYPE = function() {
  return 'post'
}
export const testConnectionUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{id}/test-connection'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTagsUsingGET
 * url: getTagsUsingGETURL
 * method: getTagsUsingGET_TYPE
 * raw_url: getTagsUsingGET_RAW_URL
 * @param name - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tag'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTagsUsingGET_RAW_URL = function() {
  return '/tag'
}
export const getTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tag'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTagUsingPOST
 * url: createTagUsingPOSTURL
 * method: createTagUsingPOST_TYPE
 * raw_url: createTagUsingPOST_RAW_URL
 * @param body - 
 */
export const createTagUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tag'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTagUsingPOST_RAW_URL = function() {
  return '/tag'
}
export const createTagUsingPOST_TYPE = function() {
  return 'post'
}
export const createTagUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tag'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getStoragesUsingGET
 * url: getStoragesUsingGETURL
 * method: getStoragesUsingGET_TYPE
 * raw_url: getStoragesUsingGET_RAW_URL
 * @param processId - 
 * @param key - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getStoragesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/storage'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['key'] !== undefined) {
    queryParameters['key'] = parameters['key']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStoragesUsingGET_RAW_URL = function() {
  return '/storage'
}
export const getStoragesUsingGET_TYPE = function() {
  return 'get'
}
export const getStoragesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/storage'
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['key'] !== undefined) {
    queryParameters['key'] = parameters['key']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createStorageUsingPOST
 * url: createStorageUsingPOSTURL
 * method: createStorageUsingPOST_TYPE
 * raw_url: createStorageUsingPOST_RAW_URL
 * @param body - 
 */
export const createStorageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/storage'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createStorageUsingPOST_RAW_URL = function() {
  return '/storage'
}
export const createStorageUsingPOST_TYPE = function() {
  return 'post'
}
export const createStorageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/storage'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getStaticResourcesUsingGET
 * url: getStaticResourcesUsingGETURL
 * method: getStaticResourcesUsingGET_TYPE
 * raw_url: getStaticResourcesUsingGET_RAW_URL
 * @param type - 
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getStaticResourcesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStaticResourcesUsingGET_RAW_URL = function() {
  return '/static-resource'
}
export const getStaticResourcesUsingGET_TYPE = function() {
  return 'get'
}
export const getStaticResourcesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource'
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createStaticResourceUsingPOST
 * url: createStaticResourceUsingPOSTURL
 * method: createStaticResourceUsingPOST_TYPE
 * raw_url: createStaticResourceUsingPOST_RAW_URL
 * @param body - 
 */
export const createStaticResourceUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createStaticResourceUsingPOST_RAW_URL = function() {
  return '/static-resource'
}
export const createStaticResourceUsingPOST_TYPE = function() {
  return 'post'
}
export const createStaticResourceUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: uploadStaticResourceFileUsingPOST
 * url: uploadStaticResourceFileUsingPOSTURL
 * method: uploadStaticResourceFileUsingPOST_TYPE
 * raw_url: uploadStaticResourceFileUsingPOST_RAW_URL
 * @param id - 
 * @param file - 
 */
export const uploadStaticResourceFileUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/upload'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadStaticResourceFileUsingPOST_RAW_URL = function() {
  return '/static-resource/{id}/upload'
}
export const uploadStaticResourceFileUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadStaticResourceFileUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/upload'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: refreshSkillsUsingPOST
 * url: refreshSkillsUsingPOSTURL
 * method: refreshSkillsUsingPOST_TYPE
 * raw_url: refreshSkillsUsingPOST_RAW_URL
 * @param id - 
 */
export const refreshSkillsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/skills/refresh'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const refreshSkillsUsingPOST_RAW_URL = function() {
  return '/static-resource/{id}/skills/refresh'
}
export const refreshSkillsUsingPOST_TYPE = function() {
  return 'post'
}
export const refreshSkillsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/skills/refresh'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createProcessSettingUsingPOST
 * url: createProcessSettingUsingPOSTURL
 * method: createProcessSettingUsingPOST_TYPE
 * raw_url: createProcessSettingUsingPOST_RAW_URL
 * @param body - 
 */
export const createProcessSettingUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/process'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createProcessSettingUsingPOST_RAW_URL = function() {
  return '/setting/process'
}
export const createProcessSettingUsingPOST_TYPE = function() {
  return 'post'
}
export const createProcessSettingUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/process'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createPluginSettingUsingPOST
 * url: createPluginSettingUsingPOSTURL
 * method: createPluginSettingUsingPOST_TYPE
 * raw_url: createPluginSettingUsingPOST_RAW_URL
 * @param body - 
 */
export const createPluginSettingUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/plugin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createPluginSettingUsingPOST_RAW_URL = function() {
  return '/setting/plugin'
}
export const createPluginSettingUsingPOST_TYPE = function() {
  return 'post'
}
export const createPluginSettingUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/plugin'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createInstanceProcessingSettingUsingPOST
 * url: createInstanceProcessingSettingUsingPOSTURL
 * method: createInstanceProcessingSettingUsingPOST_TYPE
 * raw_url: createInstanceProcessingSettingUsingPOST_RAW_URL
 * @param body - 
 */
export const createInstanceProcessingSettingUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/instance-processing'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createInstanceProcessingSettingUsingPOST_RAW_URL = function() {
  return '/setting/instance-processing'
}
export const createInstanceProcessingSettingUsingPOST_TYPE = function() {
  return 'post'
}
export const createInstanceProcessingSettingUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/instance-processing'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createInstanceAdminSettingUsingPOST
 * url: createInstanceAdminSettingUsingPOSTURL
 * method: createInstanceAdminSettingUsingPOST_TYPE
 * raw_url: createInstanceAdminSettingUsingPOST_RAW_URL
 * @param body - 
 */
export const createInstanceAdminSettingUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/instance-admin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createInstanceAdminSettingUsingPOST_RAW_URL = function() {
  return '/setting/instance-admin'
}
export const createInstanceAdminSettingUsingPOST_TYPE = function() {
  return 'post'
}
export const createInstanceAdminSettingUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/instance-admin'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: setUserPasswordUsingPOST
 * url: setUserPasswordUsingPOSTURL
 * method: setUserPasswordUsingPOST_TYPE
 * raw_url: setUserPasswordUsingPOST_RAW_URL
 * @param body - 
 */
export const setUserPasswordUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/set-password'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setUserPasswordUsingPOST_RAW_URL = function() {
  return '/set-password'
}
export const setUserPasswordUsingPOST_TYPE = function() {
  return 'post'
}
export const setUserPasswordUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/set-password'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getScreensUsingGET
 * url: getScreensUsingGETURL
 * method: getScreensUsingGET_TYPE
 * raw_url: getScreensUsingGET_RAW_URL
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getScreensUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getScreensUsingGET_RAW_URL = function() {
  return '/screen'
}
export const getScreensUsingGET_TYPE = function() {
  return 'get'
}
export const getScreensUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen'
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createScreenUsingPOST
 * url: createScreenUsingPOSTURL
 * method: createScreenUsingPOST_TYPE
 * raw_url: createScreenUsingPOST_RAW_URL
 * @param body - 
 */
export const createScreenUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createScreenUsingPOST_RAW_URL = function() {
  return '/screen'
}
export const createScreenUsingPOST_TYPE = function() {
  return 'post'
}
export const createScreenUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getRolesUsingGET
 * url: getRolesUsingGETURL
 * method: getRolesUsingGET_TYPE
 * raw_url: getRolesUsingGET_RAW_URL
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getRolesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/role'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRolesUsingGET_RAW_URL = function() {
  return '/role'
}
export const getRolesUsingGET_TYPE = function() {
  return 'get'
}
export const getRolesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/role'
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createRoleUsingPOST
 * url: createRoleUsingPOSTURL
 * method: createRoleUsingPOST_TYPE
 * raw_url: createRoleUsingPOST_RAW_URL
 * @param body - 
 */
export const createRoleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/role'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createRoleUsingPOST_RAW_URL = function() {
  return '/role'
}
export const createRoleUsingPOST_TYPE = function() {
  return 'post'
}
export const createRoleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/role'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: regexTestUsingPOST
 * url: regexTestUsingPOSTURL
 * method: regexTestUsingPOST_TYPE
 * raw_url: regexTestUsingPOST_RAW_URL
 * @param body - 
 */
export const regexTestUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/regex/test'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const regexTestUsingPOST_RAW_URL = function() {
  return '/regex/test'
}
export const regexTestUsingPOST_TYPE = function() {
  return 'post'
}
export const regexTestUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/regex/test'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessesUsingGET
 * url: getProcessesUsingGETURL
 * method: getProcessesUsingGET_TYPE
 * raw_url: getProcessesUsingGET_RAW_URL
 * @param isSystem - 
 * @param isAutoGenerated - 
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getProcessesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['isAutoGenerated'] !== undefined) {
    queryParameters['isAutoGenerated'] = parameters['isAutoGenerated']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessesUsingGET_RAW_URL = function() {
  return '/process'
}
export const getProcessesUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process'
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['isAutoGenerated'] !== undefined) {
    queryParameters['isAutoGenerated'] = parameters['isAutoGenerated']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createProcessUsingPOST
 * url: createProcessUsingPOSTURL
 * method: createProcessUsingPOST_TYPE
 * raw_url: createProcessUsingPOST_RAW_URL
 * @param body - 
 */
export const createProcessUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createProcessUsingPOST_RAW_URL = function() {
  return '/process'
}
export const createProcessUsingPOST_TYPE = function() {
  return 'post'
}
export const createProcessUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: listSkillsUsingGET
 * url: listSkillsUsingGETURL
 * method: listSkillsUsingGET_TYPE
 * raw_url: listSkillsUsingGET_RAW_URL
 * @param id - 
 */
export const listSkillsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/skills'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const listSkillsUsingGET_RAW_URL = function() {
  return '/process-credential/{id}/skills'
}
export const listSkillsUsingGET_TYPE = function() {
  return 'get'
}
export const listSkillsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/skills'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: addSkillUsingPOST
 * url: addSkillUsingPOSTURL
 * method: addSkillUsingPOST_TYPE
 * raw_url: addSkillUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const addSkillUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/skills'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addSkillUsingPOST_RAW_URL = function() {
  return '/process-credential/{id}/skills'
}
export const addSkillUsingPOST_TYPE = function() {
  return 'post'
}
export const addSkillUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/skills'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: refreshSkillsUsingPOST_1
 * url: refreshSkillsUsingPOST_1URL
 * method: refreshSkillsUsingPOST_1_TYPE
 * raw_url: refreshSkillsUsingPOST_1_RAW_URL
 * @param id - 
 * @param body - 
 */
export const refreshSkillsUsingPOST_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/skills/refresh'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const refreshSkillsUsingPOST_1_RAW_URL = function() {
  return '/process-credential/{id}/skills/refresh'
}
export const refreshSkillsUsingPOST_1_TYPE = function() {
  return 'post'
}
export const refreshSkillsUsingPOST_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/skills/refresh'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createWhatsAppProcessCredentialUsingPOST
 * url: createWhatsAppProcessCredentialUsingPOSTURL
 * method: createWhatsAppProcessCredentialUsingPOST_TYPE
 * raw_url: createWhatsAppProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createWhatsAppProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/whatsapp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createWhatsAppProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/whatsapp'
}
export const createWhatsAppProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createWhatsAppProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/whatsapp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createTwilioProcessCredentialUsingPOST
 * url: createTwilioProcessCredentialUsingPOSTURL
 * method: createTwilioProcessCredentialUsingPOST_TYPE
 * raw_url: createTwilioProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createTwilioProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/twilio'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createTwilioProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/twilio'
}
export const createTwilioProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createTwilioProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/twilio'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testTwilioProcessCredentialUsingPOST
 * url: testTwilioProcessCredentialUsingPOSTURL
 * method: testTwilioProcessCredentialUsingPOST_TYPE
 * raw_url: testTwilioProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testTwilioProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/twilio'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testTwilioProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/twilio'
}
export const testTwilioProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testTwilioProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/twilio'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testSshCredentialUsingPOST
 * url: testSshCredentialUsingPOSTURL
 * method: testSshCredentialUsingPOST_TYPE
 * raw_url: testSshCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testSshCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/ssh'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testSshCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/ssh'
}
export const testSshCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testSshCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/ssh'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testSshKeyCredentialUsingPOST
 * url: testSshKeyCredentialUsingPOSTURL
 * method: testSshKeyCredentialUsingPOST_TYPE
 * raw_url: testSshKeyCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testSshKeyCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/ssh-key'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testSshKeyCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/ssh-key'
}
export const testSshKeyCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testSshKeyCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/ssh-key'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testSmtpProcessCredentialUsingPOST
 * url: testSmtpProcessCredentialUsingPOSTURL
 * method: testSmtpProcessCredentialUsingPOST_TYPE
 * raw_url: testSmtpProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testSmtpProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/smtp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testSmtpProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/smtp'
}
export const testSmtpProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testSmtpProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/smtp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: sendSmtpTestEmailUsingPOST
 * url: sendSmtpTestEmailUsingPOSTURL
 * method: sendSmtpTestEmailUsingPOST_TYPE
 * raw_url: sendSmtpTestEmailUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const sendSmtpTestEmailUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/smtp/{id}/send-email'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const sendSmtpTestEmailUsingPOST_RAW_URL = function() {
  return '/process-credential/test/smtp/{id}/send-email'
}
export const sendSmtpTestEmailUsingPOST_TYPE = function() {
  return 'post'
}
export const sendSmtpTestEmailUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/smtp/{id}/send-email'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testSlackProcessCredentialUsingPOST
 * url: testSlackProcessCredentialUsingPOSTURL
 * method: testSlackProcessCredentialUsingPOST_TYPE
 * raw_url: testSlackProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testSlackProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/slack'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testSlackProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/slack'
}
export const testSlackProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testSlackProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/slack'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testSftpProcessCredentialUsingPOST
 * url: testSftpProcessCredentialUsingPOSTURL
 * method: testSftpProcessCredentialUsingPOST_TYPE
 * raw_url: testSftpProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testSftpProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/sftp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testSftpProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/sftp'
}
export const testSftpProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testSftpProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/sftp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testRabbitmqCredentialUsingPOST
 * url: testRabbitmqCredentialUsingPOSTURL
 * method: testRabbitmqCredentialUsingPOST_TYPE
 * raw_url: testRabbitmqCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testRabbitmqCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/rabbitmq'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testRabbitmqCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/rabbitmq'
}
export const testRabbitmqCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testRabbitmqCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/rabbitmq'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testPaymentSensePacCredentialUsingPOST
 * url: testPaymentSensePacCredentialUsingPOSTURL
 * method: testPaymentSensePacCredentialUsingPOST_TYPE
 * raw_url: testPaymentSensePacCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testPaymentSensePacCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/payment-sense-pac'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testPaymentSensePacCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/payment-sense-pac'
}
export const testPaymentSensePacCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testPaymentSensePacCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/payment-sense-pac'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testPaymentSenseConnectECredentialUsingPOST
 * url: testPaymentSenseConnectECredentialUsingPOSTURL
 * method: testPaymentSenseConnectECredentialUsingPOST_TYPE
 * raw_url: testPaymentSenseConnectECredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testPaymentSenseConnectECredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/payment-sense-connect-e'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testPaymentSenseConnectECredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/payment-sense-connect-e'
}
export const testPaymentSenseConnectECredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testPaymentSenseConnectECredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/payment-sense-connect-e'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testOpenAICredentialUsingPOST
 * url: testOpenAICredentialUsingPOSTURL
 * method: testOpenAICredentialUsingPOST_TYPE
 * raw_url: testOpenAICredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testOpenAICredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/open-ai'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testOpenAICredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/open-ai'
}
export const testOpenAICredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testOpenAICredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/open-ai'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testMsGraphApiCredentialUsingPOST
 * url: testMsGraphApiCredentialUsingPOSTURL
 * method: testMsGraphApiCredentialUsingPOST_TYPE
 * raw_url: testMsGraphApiCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testMsGraphApiCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/ms-graph-api'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testMsGraphApiCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/ms-graph-api'
}
export const testMsGraphApiCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testMsGraphApiCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/ms-graph-api'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testMqttCredentialUsingPOST
 * url: testMqttCredentialUsingPOSTURL
 * method: testMqttCredentialUsingPOST_TYPE
 * raw_url: testMqttCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testMqttCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/mqtt'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testMqttCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/mqtt'
}
export const testMqttCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testMqttCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/mqtt'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testMongodbProcessCredentialUsingPOST
 * url: testMongodbProcessCredentialUsingPOSTURL
 * method: testMongodbProcessCredentialUsingPOST_TYPE
 * raw_url: testMongodbProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testMongodbProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/mongodb'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testMongodbProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/mongodb'
}
export const testMongodbProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testMongodbProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/mongodb'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testMcpStdioProcessCredentialUsingPOST
 * url: testMcpStdioProcessCredentialUsingPOSTURL
 * method: testMcpStdioProcessCredentialUsingPOST_TYPE
 * raw_url: testMcpStdioProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testMcpStdioProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/mcp-stdio'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testMcpStdioProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/mcp-stdio'
}
export const testMcpStdioProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testMcpStdioProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/mcp-stdio'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testMcpSseProcessCredentialUsingPOST
 * url: testMcpSseProcessCredentialUsingPOSTURL
 * method: testMcpSseProcessCredentialUsingPOST_TYPE
 * raw_url: testMcpSseProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testMcpSseProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/mcp-sse'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testMcpSseProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/mcp-sse'
}
export const testMcpSseProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testMcpSseProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/mcp-sse'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testMcpSseHttpProcessCredentialUsingPOST
 * url: testMcpSseHttpProcessCredentialUsingPOSTURL
 * method: testMcpSseHttpProcessCredentialUsingPOST_TYPE
 * raw_url: testMcpSseHttpProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testMcpSseHttpProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/mcp-http'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testMcpSseHttpProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/mcp-http'
}
export const testMcpSseHttpProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testMcpSseHttpProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/mcp-http'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testLdapCredentialUsingPOST
 * url: testLdapCredentialUsingPOSTURL
 * method: testLdapCredentialUsingPOST_TYPE
 * raw_url: testLdapCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testLdapCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/ldap'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testLdapCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/ldap'
}
export const testLdapCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testLdapCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/ldap'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testKafkaCredentialUsingPOST
 * url: testKafkaCredentialUsingPOSTURL
 * method: testKafkaCredentialUsingPOST_TYPE
 * raw_url: testKafkaCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testKafkaCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/kafka'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testKafkaCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/kafka'
}
export const testKafkaCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testKafkaCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/kafka'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testJwtProcessCredentialUsingPOST
 * url: testJwtProcessCredentialUsingPOSTURL
 * method: testJwtProcessCredentialUsingPOST_TYPE
 * raw_url: testJwtProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testJwtProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/jwt'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testJwtProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/jwt'
}
export const testJwtProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testJwtProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/jwt'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testJmsCredentialUsingPOST
 * url: testJmsCredentialUsingPOSTURL
 * method: testJmsCredentialUsingPOST_TYPE
 * raw_url: testJmsCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testJmsCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/jms'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testJmsCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/jms'
}
export const testJmsCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testJmsCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/jms'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testJiraCredentialUsingPOST
 * url: testJiraCredentialUsingPOSTURL
 * method: testJiraCredentialUsingPOST_TYPE
 * raw_url: testJiraCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testJiraCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/jira'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testJiraCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/jira'
}
export const testJiraCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testJiraCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/jira'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testJdbcProcessCredentialUsingPOST
 * url: testJdbcProcessCredentialUsingPOSTURL
 * method: testJdbcProcessCredentialUsingPOST_TYPE
 * raw_url: testJdbcProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testJdbcProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/jdbc'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testJdbcProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/jdbc'
}
export const testJdbcProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testJdbcProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/jdbc'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testImapProcessCredentialUsingPOST
 * url: testImapProcessCredentialUsingPOSTURL
 * method: testImapProcessCredentialUsingPOST_TYPE
 * raw_url: testImapProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testImapProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/imap'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testImapProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/imap'
}
export const testImapProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testImapProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/imap'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testGotenbergCredentialUsingPOST
 * url: testGotenbergCredentialUsingPOSTURL
 * method: testGotenbergCredentialUsingPOST_TYPE
 * raw_url: testGotenbergCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testGotenbergCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/gotenberg'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testGotenbergCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/gotenberg'
}
export const testGotenbergCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testGotenbergCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/gotenberg'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testFtpProcessCredentialUsingPOST
 * url: testFtpProcessCredentialUsingPOSTURL
 * method: testFtpProcessCredentialUsingPOST_TYPE
 * raw_url: testFtpProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testFtpProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/ftp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testFtpProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/ftp'
}
export const testFtpProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testFtpProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/ftp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testFlowyCredentialUsingPOST
 * url: testFlowyCredentialUsingPOSTURL
 * method: testFlowyCredentialUsingPOST_TYPE
 * raw_url: testFlowyCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testFlowyCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/flowy'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testFlowyCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/flowy'
}
export const testFlowyCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testFlowyCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/flowy'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testDeepSeekCredentialUsingPOST
 * url: testDeepSeekCredentialUsingPOSTURL
 * method: testDeepSeekCredentialUsingPOST_TYPE
 * raw_url: testDeepSeekCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testDeepSeekCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/deep-seek'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testDeepSeekCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/deep-seek'
}
export const testDeepSeekCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testDeepSeekCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/deep-seek'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testAwsCredentialUsingPOST
 * url: testAwsCredentialUsingPOSTURL
 * method: testAwsCredentialUsingPOST_TYPE
 * raw_url: testAwsCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testAwsCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/aws'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testAwsCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/aws'
}
export const testAwsCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testAwsCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/aws'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: testAnthropicCredentialUsingPOST
 * url: testAnthropicCredentialUsingPOSTURL
 * method: testAnthropicCredentialUsingPOST_TYPE
 * raw_url: testAnthropicCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const testAnthropicCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/test/anthropic'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const testAnthropicCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/test/anthropic'
}
export const testAnthropicCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const testAnthropicCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/test/anthropic'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createStripeConnectProcessCredentialUsingPOST
 * url: createStripeConnectProcessCredentialUsingPOSTURL
 * method: createStripeConnectProcessCredentialUsingPOST_TYPE
 * raw_url: createStripeConnectProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createStripeConnectProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/stripe-connect'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createStripeConnectProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/stripe-connect'
}
export const createStripeConnectProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createStripeConnectProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/stripe-connect'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createSshCredentialUsingPOST
 * url: createSshCredentialUsingPOSTURL
 * method: createSshCredentialUsingPOST_TYPE
 * raw_url: createSshCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createSshCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ssh'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createSshCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/ssh'
}
export const createSshCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createSshCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ssh'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createSshKeyCredentialUsingPOST
 * url: createSshKeyCredentialUsingPOSTURL
 * method: createSshKeyCredentialUsingPOST_TYPE
 * raw_url: createSshKeyCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createSshKeyCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ssh-key'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createSshKeyCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/ssh-key'
}
export const createSshKeyCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createSshKeyCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ssh-key'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createSoapCredentialUsingPOST
 * url: createSoapCredentialUsingPOSTURL
 * method: createSoapCredentialUsingPOST_TYPE
 * raw_url: createSoapCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createSoapCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/soap'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createSoapCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/soap'
}
export const createSoapCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createSoapCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/soap'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createSmtpProcessCredentialUsingPOST
 * url: createSmtpProcessCredentialUsingPOSTURL
 * method: createSmtpProcessCredentialUsingPOST_TYPE
 * raw_url: createSmtpProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createSmtpProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/smtp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createSmtpProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/smtp'
}
export const createSmtpProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createSmtpProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/smtp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createSlackProcessCredentialUsingPOST
 * url: createSlackProcessCredentialUsingPOSTURL
 * method: createSlackProcessCredentialUsingPOST_TYPE
 * raw_url: createSlackProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createSlackProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/slack'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createSlackProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/slack'
}
export const createSlackProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createSlackProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/slack'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createSftpProcessCredentialUsingPOST
 * url: createSftpProcessCredentialUsingPOSTURL
 * method: createSftpProcessCredentialUsingPOST_TYPE
 * raw_url: createSftpProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createSftpProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/sftp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createSftpProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/sftp'
}
export const createSftpProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createSftpProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/sftp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createSecurityCredentialUsingPOST
 * url: createSecurityCredentialUsingPOSTURL
 * method: createSecurityCredentialUsingPOST_TYPE
 * raw_url: createSecurityCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createSecurityCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/security'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createSecurityCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/security'
}
export const createSecurityCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createSecurityCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/security'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createScriptCredentialUsingPOST
 * url: createScriptCredentialUsingPOSTURL
 * method: createScriptCredentialUsingPOST_TYPE
 * raw_url: createScriptCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createScriptCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/script'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createScriptCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/script'
}
export const createScriptCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createScriptCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/script'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createRestCredentialUsingPOST
 * url: createRestCredentialUsingPOSTURL
 * method: createRestCredentialUsingPOST_TYPE
 * raw_url: createRestCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createRestCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/rest'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createRestCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/rest'
}
export const createRestCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createRestCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/rest'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createRestBearerCredentialUsingPOST
 * url: createRestBearerCredentialUsingPOSTURL
 * method: createRestBearerCredentialUsingPOST_TYPE
 * raw_url: createRestBearerCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createRestBearerCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/rest-bearer'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createRestBearerCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/rest-bearer'
}
export const createRestBearerCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createRestBearerCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/rest-bearer'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createRestBasicCredentialUsingPOST
 * url: createRestBasicCredentialUsingPOSTURL
 * method: createRestBasicCredentialUsingPOST_TYPE
 * raw_url: createRestBasicCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createRestBasicCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/rest-basic'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createRestBasicCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/rest-basic'
}
export const createRestBasicCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createRestBasicCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/rest-basic'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createRabbitmqCredentialUsingPOST
 * url: createRabbitmqCredentialUsingPOSTURL
 * method: createRabbitmqCredentialUsingPOST_TYPE
 * raw_url: createRabbitmqCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createRabbitmqCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/rabbitmq'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createRabbitmqCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/rabbitmq'
}
export const createRabbitmqCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createRabbitmqCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/rabbitmq'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createPluginCredentialUsingPOST
 * url: createPluginCredentialUsingPOSTURL
 * method: createPluginCredentialUsingPOST_TYPE
 * raw_url: createPluginCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createPluginCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/plugin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createPluginCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/plugin'
}
export const createPluginCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createPluginCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/plugin'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createPaymentSensePacCredentialUsingPOST
 * url: createPaymentSensePacCredentialUsingPOSTURL
 * method: createPaymentSensePacCredentialUsingPOST_TYPE
 * raw_url: createPaymentSensePacCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createPaymentSensePacCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/payment-sense-pac'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createPaymentSensePacCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/payment-sense-pac'
}
export const createPaymentSensePacCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createPaymentSensePacCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/payment-sense-pac'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createPaymentSenseConnectECredentialUsingPOST
 * url: createPaymentSenseConnectECredentialUsingPOSTURL
 * method: createPaymentSenseConnectECredentialUsingPOST_TYPE
 * raw_url: createPaymentSenseConnectECredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createPaymentSenseConnectECredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/payment-sense-connect-e'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createPaymentSenseConnectECredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/payment-sense-connect-e'
}
export const createPaymentSenseConnectECredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createPaymentSenseConnectECredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/payment-sense-connect-e'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createOpenAIProcessCredentialUsingPOST
 * url: createOpenAIProcessCredentialUsingPOSTURL
 * method: createOpenAIProcessCredentialUsingPOST_TYPE
 * raw_url: createOpenAIProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createOpenAIProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/open-ai'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOpenAIProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/open-ai'
}
export const createOpenAIProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createOpenAIProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/open-ai'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createNeo4jCredentialUsingPOST
 * url: createNeo4jCredentialUsingPOSTURL
 * method: createNeo4jCredentialUsingPOST_TYPE
 * raw_url: createNeo4jCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createNeo4jCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/neo4j'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createNeo4jCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/neo4j'
}
export const createNeo4jCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createNeo4jCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/neo4j'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createMsGraphApiProcessCredentialUsingPOST
 * url: createMsGraphApiProcessCredentialUsingPOSTURL
 * method: createMsGraphApiProcessCredentialUsingPOST_TYPE
 * raw_url: createMsGraphApiProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createMsGraphApiProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ms-graph-api'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createMsGraphApiProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/ms-graph-api'
}
export const createMsGraphApiProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createMsGraphApiProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ms-graph-api'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createMqttCredentialUsingPOST
 * url: createMqttCredentialUsingPOSTURL
 * method: createMqttCredentialUsingPOST_TYPE
 * raw_url: createMqttCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createMqttCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mqtt'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createMqttCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/mqtt'
}
export const createMqttCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createMqttCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mqtt'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createMongodbProcessCredentialUsingPOST
 * url: createMongodbProcessCredentialUsingPOSTURL
 * method: createMongodbProcessCredentialUsingPOST_TYPE
 * raw_url: createMongodbProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createMongodbProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mongodb'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createMongodbProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/mongodb'
}
export const createMongodbProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createMongodbProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mongodb'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: executeMongodbScriptUsingPOST
 * url: executeMongodbScriptUsingPOSTURL
 * method: executeMongodbScriptUsingPOST_TYPE
 * raw_url: executeMongodbScriptUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const executeMongodbScriptUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mongodb/{id}/execute-script'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const executeMongodbScriptUsingPOST_RAW_URL = function() {
  return '/process-credential/mongodb/{id}/execute-script'
}
export const executeMongodbScriptUsingPOST_TYPE = function() {
  return 'post'
}
export const executeMongodbScriptUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mongodb/{id}/execute-script'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createMcpStdioProcessCredentialUsingPOST
 * url: createMcpStdioProcessCredentialUsingPOSTURL
 * method: createMcpStdioProcessCredentialUsingPOST_TYPE
 * raw_url: createMcpStdioProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createMcpStdioProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mcp-stdio'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createMcpStdioProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/mcp-stdio'
}
export const createMcpStdioProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createMcpStdioProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mcp-stdio'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createMcpSseProcessCredentialUsingPOST
 * url: createMcpSseProcessCredentialUsingPOSTURL
 * method: createMcpSseProcessCredentialUsingPOST_TYPE
 * raw_url: createMcpSseProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createMcpSseProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mcp-sse'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createMcpSseProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/mcp-sse'
}
export const createMcpSseProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createMcpSseProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mcp-sse'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createMcpOpenaiConnectorProcessCredentialUsingPOST
 * url: createMcpOpenaiConnectorProcessCredentialUsingPOSTURL
 * method: createMcpOpenaiConnectorProcessCredentialUsingPOST_TYPE
 * raw_url: createMcpOpenaiConnectorProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createMcpOpenaiConnectorProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mcp-openai-connector'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createMcpOpenaiConnectorProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/mcp-openai-connector'
}
export const createMcpOpenaiConnectorProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createMcpOpenaiConnectorProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mcp-openai-connector'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createMcpHttpProcessCredentialUsingPOST
 * url: createMcpHttpProcessCredentialUsingPOSTURL
 * method: createMcpHttpProcessCredentialUsingPOST_TYPE
 * raw_url: createMcpHttpProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createMcpHttpProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/mcp-http'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createMcpHttpProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/mcp-http'
}
export const createMcpHttpProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createMcpHttpProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/mcp-http'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createLdapCredentialUsingPOST
 * url: createLdapCredentialUsingPOSTURL
 * method: createLdapCredentialUsingPOST_TYPE
 * raw_url: createLdapCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createLdapCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ldap'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createLdapCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/ldap'
}
export const createLdapCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createLdapCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ldap'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createKafkaCredentialUsingPOST
 * url: createKafkaCredentialUsingPOSTURL
 * method: createKafkaCredentialUsingPOST_TYPE
 * raw_url: createKafkaCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createKafkaCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/kafka'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createKafkaCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/kafka'
}
export const createKafkaCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createKafkaCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/kafka'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createJwtProcessCredentialUsingPOST
 * url: createJwtProcessCredentialUsingPOSTURL
 * method: createJwtProcessCredentialUsingPOST_TYPE
 * raw_url: createJwtProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createJwtProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jwt'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createJwtProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/jwt'
}
export const createJwtProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createJwtProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jwt'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createJmsCredentialUsingPOST
 * url: createJmsCredentialUsingPOSTURL
 * method: createJmsCredentialUsingPOST_TYPE
 * raw_url: createJmsCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createJmsCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jms'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createJmsCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/jms'
}
export const createJmsCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createJmsCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jms'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createJiraCredentialUsingPOST
 * url: createJiraCredentialUsingPOSTURL
 * method: createJiraCredentialUsingPOST_TYPE
 * raw_url: createJiraCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createJiraCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jira'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createJiraCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/jira'
}
export const createJiraCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createJiraCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jira'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createJdbcProcessCredentialUsingPOST
 * url: createJdbcProcessCredentialUsingPOSTURL
 * method: createJdbcProcessCredentialUsingPOST_TYPE
 * raw_url: createJdbcProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createJdbcProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jdbc'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createJdbcProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/jdbc'
}
export const createJdbcProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createJdbcProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jdbc'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: executeJdbcScriptUsingPOST
 * url: executeJdbcScriptUsingPOSTURL
 * method: executeJdbcScriptUsingPOST_TYPE
 * raw_url: executeJdbcScriptUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const executeJdbcScriptUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jdbc/{id}/execute-script'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const executeJdbcScriptUsingPOST_RAW_URL = function() {
  return '/process-credential/jdbc/{id}/execute-script'
}
export const executeJdbcScriptUsingPOST_TYPE = function() {
  return 'post'
}
export const executeJdbcScriptUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jdbc/{id}/execute-script'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createImapProcessCredentialUsingPOST
 * url: createImapProcessCredentialUsingPOSTURL
 * method: createImapProcessCredentialUsingPOST_TYPE
 * raw_url: createImapProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createImapProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/imap'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createImapProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/imap'
}
export const createImapProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createImapProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/imap'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createGotenbergCredentialUsingPOST
 * url: createGotenbergCredentialUsingPOSTURL
 * method: createGotenbergCredentialUsingPOST_TYPE
 * raw_url: createGotenbergCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createGotenbergCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/gotenberg'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createGotenbergCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/gotenberg'
}
export const createGotenbergCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createGotenbergCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/gotenberg'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createGitCredentialUsingPOST
 * url: createGitCredentialUsingPOSTURL
 * method: createGitCredentialUsingPOST_TYPE
 * raw_url: createGitCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createGitCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/git'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createGitCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/git'
}
export const createGitCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createGitCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/git'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createFtpProcessCredentialUsingPOST
 * url: createFtpProcessCredentialUsingPOSTURL
 * method: createFtpProcessCredentialUsingPOST_TYPE
 * raw_url: createFtpProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createFtpProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/ftp'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createFtpProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/ftp'
}
export const createFtpProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createFtpProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/ftp'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createFlowyCredentialUsingPOST
 * url: createFlowyCredentialUsingPOSTURL
 * method: createFlowyCredentialUsingPOST_TYPE
 * raw_url: createFlowyCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createFlowyCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/flowy'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createFlowyCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/flowy'
}
export const createFlowyCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createFlowyCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/flowy'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createDeepSeekProcessCredentialUsingPOST
 * url: createDeepSeekProcessCredentialUsingPOSTURL
 * method: createDeepSeekProcessCredentialUsingPOST_TYPE
 * raw_url: createDeepSeekProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createDeepSeekProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/deep-seek'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createDeepSeekProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/deep-seek'
}
export const createDeepSeekProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createDeepSeekProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/deep-seek'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createAwsCredentialUsingPOST
 * url: createAwsCredentialUsingPOSTURL
 * method: createAwsCredentialUsingPOST_TYPE
 * raw_url: createAwsCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createAwsCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/aws'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createAwsCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/aws'
}
export const createAwsCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createAwsCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/aws'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createAnthropicProcessCredentialUsingPOST
 * url: createAnthropicProcessCredentialUsingPOSTURL
 * method: createAnthropicProcessCredentialUsingPOST_TYPE
 * raw_url: createAnthropicProcessCredentialUsingPOST_RAW_URL
 * @param body - 
 */
export const createAnthropicProcessCredentialUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/anthropic'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createAnthropicProcessCredentialUsingPOST_RAW_URL = function() {
  return '/process-credential/anthropic'
}
export const createAnthropicProcessCredentialUsingPOST_TYPE = function() {
  return 'post'
}
export const createAnthropicProcessCredentialUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/anthropic'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getPluginsUsingGET
 * url: getPluginsUsingGETURL
 * method: getPluginsUsingGET_TYPE
 * raw_url: getPluginsUsingGET_RAW_URL
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getPluginsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPluginsUsingGET_RAW_URL = function() {
  return '/plugin'
}
export const getPluginsUsingGET_TYPE = function() {
  return 'get'
}
export const getPluginsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin'
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createPluginUsingPOST
 * url: createPluginUsingPOSTURL
 * method: createPluginUsingPOST_TYPE
 * raw_url: createPluginUsingPOST_RAW_URL
 * @param body - 
 */
export const createPluginUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createPluginUsingPOST_RAW_URL = function() {
  return '/plugin'
}
export const createPluginUsingPOST_TYPE = function() {
  return 'post'
}
export const createPluginUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: uploadPluginJarUsingPOST
 * url: uploadPluginJarUsingPOSTURL
 * method: uploadPluginJarUsingPOST_TYPE
 * raw_url: uploadPluginJarUsingPOST_RAW_URL
 * @param pluginId - 
 * @param file - 
 */
export const uploadPluginJarUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{pluginId}/jar'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{pluginId}', `${parameters['pluginId']}`)
  if (parameters['pluginId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: pluginId'))
  }
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadPluginJarUsingPOST_RAW_URL = function() {
  return '/plugin/{pluginId}/jar'
}
export const uploadPluginJarUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadPluginJarUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{pluginId}/jar'
  path = path.replace('{pluginId}', `${parameters['pluginId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getModulesUsingGET
 * url: getModulesUsingGETURL
 * method: getModulesUsingGET_TYPE
 * raw_url: getModulesUsingGET_RAW_URL
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getModulesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModulesUsingGET_RAW_URL = function() {
  return '/module'
}
export const getModulesUsingGET_TYPE = function() {
  return 'get'
}
export const getModulesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module'
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createModuleUsingPOST
 * url: createModuleUsingPOSTURL
 * method: createModuleUsingPOST_TYPE
 * raw_url: createModuleUsingPOST_RAW_URL
 * @param body - 
 */
export const createModuleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createModuleUsingPOST_RAW_URL = function() {
  return '/module'
}
export const createModuleUsingPOST_TYPE = function() {
  return 'post'
}
export const createModuleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: validateUsingPOST
 * url: validateUsingPOSTURL
 * method: validateUsingPOST_TYPE
 * raw_url: validateUsingPOST_RAW_URL
 * @param withGeneratedResources - 
 * @param file - JSON file with resources to import. Please follow ModuleImport model
 */
export const validateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/validate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['withGeneratedResources'] !== undefined) {
    queryParameters['withGeneratedResources'] = parameters['withGeneratedResources']
  }
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const validateUsingPOST_RAW_URL = function() {
  return '/module/validate'
}
export const validateUsingPOST_TYPE = function() {
  return 'post'
}
export const validateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/validate'
  if (parameters['withGeneratedResources'] !== undefined) {
    queryParameters['withGeneratedResources'] = parameters['withGeneratedResources']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getAllModuleImportsUsingGET
 * url: getAllModuleImportsUsingGETURL
 * method: getAllModuleImportsUsingGET_TYPE
 * raw_url: getAllModuleImportsUsingGET_RAW_URL
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getAllModuleImportsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/import'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllModuleImportsUsingGET_RAW_URL = function() {
  return '/module/import'
}
export const getAllModuleImportsUsingGET_TYPE = function() {
  return 'get'
}
export const getAllModuleImportsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/import'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: importModuleUsingPOST
 * url: importModuleUsingPOSTURL
 * method: importModuleUsingPOST_TYPE
 * raw_url: importModuleUsingPOST_RAW_URL
 * @param withGeneratedResources - 
 * @param file - JSON file with resources to import. Please follow ModuleImport model
 */
export const importModuleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/import'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['withGeneratedResources'] !== undefined) {
    queryParameters['withGeneratedResources'] = parameters['withGeneratedResources']
  }
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const importModuleUsingPOST_RAW_URL = function() {
  return '/module/import'
}
export const importModuleUsingPOST_TYPE = function() {
  return 'post'
}
export const importModuleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/import'
  if (parameters['withGeneratedResources'] !== undefined) {
    queryParameters['withGeneratedResources'] = parameters['withGeneratedResources']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteModuleResourcesUsingPOST
 * url: deleteModuleResourcesUsingPOSTURL
 * method: deleteModuleResourcesUsingPOST_TYPE
 * raw_url: deleteModuleResourcesUsingPOST_RAW_URL
 * @param forceDelete - 
 * @param file - JSON file with resources to delete. Please follow ModuleImport model
 */
export const deleteModuleResourcesUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['forceDelete'] !== undefined) {
    queryParameters['forceDelete'] = parameters['forceDelete']
  }
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const deleteModuleResourcesUsingPOST_RAW_URL = function() {
  return '/module/delete'
}
export const deleteModuleResourcesUsingPOST_TYPE = function() {
  return 'post'
}
export const deleteModuleResourcesUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/delete'
  if (parameters['forceDelete'] !== undefined) {
    queryParameters['forceDelete'] = parameters['forceDelete']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: loginUsingPOST
 * url: loginUsingPOSTURL
 * method: loginUsingPOST_TYPE
 * raw_url: loginUsingPOST_RAW_URL
 * @param body - 
 */
export const loginUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/login'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const loginUsingPOST_RAW_URL = function() {
  return '/login'
}
export const loginUsingPOST_TYPE = function() {
  return 'post'
}
export const loginUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/login'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: handleCallbackUsingPOST
 * url: handleCallbackUsingPOSTURL
 * method: handleCallbackUsingPOST_TYPE
 * raw_url: handleCallbackUsingPOST_RAW_URL
 * @param body - 
 */
export const handleCallbackUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/login/oauth2/code'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const handleCallbackUsingPOST_RAW_URL = function() {
  return '/login/oauth2/code'
}
export const handleCallbackUsingPOST_TYPE = function() {
  return 'post'
}
export const handleCallbackUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/login/oauth2/code'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getLibrariesUsingGET
 * url: getLibrariesUsingGETURL
 * method: getLibrariesUsingGET_TYPE
 * raw_url: getLibrariesUsingGET_RAW_URL
 * @param type - 
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getLibrariesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getLibrariesUsingGET_RAW_URL = function() {
  return '/library'
}
export const getLibrariesUsingGET_TYPE = function() {
  return 'get'
}
export const getLibrariesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library'
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createLibraryUsingPOST
 * url: createLibraryUsingPOSTURL
 * method: createLibraryUsingPOST_TYPE
 * raw_url: createLibraryUsingPOST_RAW_URL
 * @param body - 
 */
export const createLibraryUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createLibraryUsingPOST_RAW_URL = function() {
  return '/library'
}
export const createLibraryUsingPOST_TYPE = function() {
  return 'post'
}
export const createLibraryUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: uploadLibraryUsingPOST
 * url: uploadLibraryUsingPOSTURL
 * method: uploadLibraryUsingPOST_TYPE
 * raw_url: uploadLibraryUsingPOST_RAW_URL
 * @param id - 
 * @param file - 
 */
export const uploadLibraryUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}/upload'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadLibraryUsingPOST_RAW_URL = function() {
  return '/library/{id}/upload'
}
export const uploadLibraryUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadLibraryUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}/upload'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: reviewSearchUsingGET
 * url: reviewSearchUsingGETURL
 * method: reviewSearchUsingGET_TYPE
 * raw_url: reviewSearchUsingGET_RAW_URL
 * @param moduleHubId - 
 * @param size - 
 * @param page - 
 */
export const reviewSearchUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/review'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['moduleHubId'] !== undefined) {
    queryParameters['moduleHubId'] = parameters['moduleHubId']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const reviewSearchUsingGET_RAW_URL = function() {
  return '/hub/review'
}
export const reviewSearchUsingGET_TYPE = function() {
  return 'get'
}
export const reviewSearchUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/review'
  if (parameters['moduleHubId'] !== undefined) {
    queryParameters['moduleHubId'] = parameters['moduleHubId']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createReviewUsingPOST
 * url: createReviewUsingPOSTURL
 * method: createReviewUsingPOST_TYPE
 * raw_url: createReviewUsingPOST_RAW_URL
 * @param body - 
 */
export const createReviewUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/review'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createReviewUsingPOST_RAW_URL = function() {
  return '/hub/review'
}
export const createReviewUsingPOST_TYPE = function() {
  return 'post'
}
export const createReviewUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/review'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: moduleValidateUsingPOST
 * url: moduleValidateUsingPOSTURL
 * method: moduleValidateUsingPOST_TYPE
 * raw_url: moduleValidateUsingPOST_RAW_URL
 * @param id - 
 * @param withGeneratedResources - 
 */
export const moduleValidateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/module/validate/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['withGeneratedResources'] !== undefined) {
    queryParameters['withGeneratedResources'] = parameters['withGeneratedResources']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const moduleValidateUsingPOST_RAW_URL = function() {
  return '/hub/module/validate/{id}'
}
export const moduleValidateUsingPOST_TYPE = function() {
  return 'post'
}
export const moduleValidateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/module/validate/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['withGeneratedResources'] !== undefined) {
    queryParameters['withGeneratedResources'] = parameters['withGeneratedResources']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: uploadModuleUsingPOST
 * url: uploadModuleUsingPOSTURL
 * method: uploadModuleUsingPOST_TYPE
 * raw_url: uploadModuleUsingPOST_RAW_URL
 * @param body - 
 */
export const uploadModuleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/module/upload'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadModuleUsingPOST_RAW_URL = function() {
  return '/hub/module/upload'
}
export const uploadModuleUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadModuleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/module/upload'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: moduleApplyUsingPOST
 * url: moduleApplyUsingPOSTURL
 * method: moduleApplyUsingPOST_TYPE
 * raw_url: moduleApplyUsingPOST_RAW_URL
 * @param id - 
 * @param withGeneratedResources - 
 */
export const moduleApplyUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/module/apply/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['withGeneratedResources'] !== undefined) {
    queryParameters['withGeneratedResources'] = parameters['withGeneratedResources']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const moduleApplyUsingPOST_RAW_URL = function() {
  return '/hub/module/apply/{id}'
}
export const moduleApplyUsingPOST_TYPE = function() {
  return 'post'
}
export const moduleApplyUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/module/apply/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['withGeneratedResources'] !== undefined) {
    queryParameters['withGeneratedResources'] = parameters['withGeneratedResources']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: forgotPasswordUsingPOST
 * url: forgotPasswordUsingPOSTURL
 * method: forgotPasswordUsingPOST_TYPE
 * raw_url: forgotPasswordUsingPOST_RAW_URL
 * @param body - 
 */
export const forgotPasswordUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/forgot-password'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const forgotPasswordUsingPOST_RAW_URL = function() {
  return '/forgot-password'
}
export const forgotPasswordUsingPOST_TYPE = function() {
  return 'post'
}
export const forgotPasswordUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/forgot-password'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getFlowsUsingGET
 * url: getFlowsUsingGETURL
 * method: getFlowsUsingGET_TYPE
 * raw_url: getFlowsUsingGET_RAW_URL
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getFlowsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFlowsUsingGET_RAW_URL = function() {
  return '/flow'
}
export const getFlowsUsingGET_TYPE = function() {
  return 'get'
}
export const getFlowsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow'
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createFlowUsingPOST
 * url: createFlowUsingPOSTURL
 * method: createFlowUsingPOST_TYPE
 * raw_url: createFlowUsingPOST_RAW_URL
 * @param body - 
 */
export const createFlowUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createFlowUsingPOST_RAW_URL = function() {
  return '/flow'
}
export const createFlowUsingPOST_TYPE = function() {
  return 'post'
}
export const createFlowUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: rerunEventByIdUsingPOST
 * url: rerunEventByIdUsingPOSTURL
 * method: rerunEventByIdUsingPOST_TYPE
 * raw_url: rerunEventByIdUsingPOST_RAW_URL
 * @param id - 
 */
export const rerunEventByIdUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/{id}/re-run'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const rerunEventByIdUsingPOST_RAW_URL = function() {
  return '/event/{id}/re-run'
}
export const rerunEventByIdUsingPOST_TYPE = function() {
  return 'post'
}
export const rerunEventByIdUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/{id}/re-run'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: interruptEventsByProcessIdUsingPOST
 * url: interruptEventsByProcessIdUsingPOSTURL
 * method: interruptEventsByProcessIdUsingPOST_TYPE
 * raw_url: interruptEventsByProcessIdUsingPOST_RAW_URL
 * @param processId - 
 */
export const interruptEventsByProcessIdUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/interrupt/{processId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{processId}', `${parameters['processId']}`)
  if (parameters['processId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const interruptEventsByProcessIdUsingPOST_RAW_URL = function() {
  return '/event/interrupt/{processId}'
}
export const interruptEventsByProcessIdUsingPOST_TYPE = function() {
  return 'post'
}
export const interruptEventsByProcessIdUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/interrupt/{processId}'
  path = path.replace('{processId}', `${parameters['processId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEntitiesUsingGET
 * url: getEntitiesUsingGETURL
 * method: getEntitiesUsingGET_TYPE
 * raw_url: getEntitiesUsingGET_RAW_URL
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getEntitiesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEntitiesUsingGET_RAW_URL = function() {
  return '/entity'
}
export const getEntitiesUsingGET_TYPE = function() {
  return 'get'
}
export const getEntitiesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity'
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createEntityUsingPOST
 * url: createEntityUsingPOSTURL
 * method: createEntityUsingPOST_TYPE
 * raw_url: createEntityUsingPOST_RAW_URL
 * @param body - 
 */
export const createEntityUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createEntityUsingPOST_RAW_URL = function() {
  return '/entity'
}
export const createEntityUsingPOST_TYPE = function() {
  return 'post'
}
export const createEntityUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: entityResourcesValidateUsingPOST
 * url: entityResourcesValidateUsingPOSTURL
 * method: entityResourcesValidateUsingPOST_TYPE
 * raw_url: entityResourcesValidateUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const entityResourcesValidateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/resources/validate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const entityResourcesValidateUsingPOST_RAW_URL = function() {
  return '/entity/{id}/resources/validate'
}
export const entityResourcesValidateUsingPOST_TYPE = function() {
  return 'post'
}
export const entityResourcesValidateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/resources/validate'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: entityResourcesGenerateUsingPOST
 * url: entityResourcesGenerateUsingPOSTURL
 * method: entityResourcesGenerateUsingPOST_TYPE
 * raw_url: entityResourcesGenerateUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const entityResourcesGenerateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/resources/generate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const entityResourcesGenerateUsingPOST_RAW_URL = function() {
  return '/entity/{id}/resources/generate'
}
export const entityResourcesGenerateUsingPOST_TYPE = function() {
  return 'post'
}
export const entityResourcesGenerateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/resources/generate'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: entityPersistenceGenerateUsingPOST
 * url: entityPersistenceGenerateUsingPOSTURL
 * method: entityPersistenceGenerateUsingPOST_TYPE
 * raw_url: entityPersistenceGenerateUsingPOST_RAW_URL
 * @param id - 
 */
export const entityPersistenceGenerateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/persistence/generate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const entityPersistenceGenerateUsingPOST_RAW_URL = function() {
  return '/entity/{id}/persistence/generate'
}
export const entityPersistenceGenerateUsingPOST_TYPE = function() {
  return 'post'
}
export const entityPersistenceGenerateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/persistence/generate'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: generateEntityFromPersistenceUsingPOST
 * url: generateEntityFromPersistenceUsingPOSTURL
 * method: generateEntityFromPersistenceUsingPOST_TYPE
 * raw_url: generateEntityFromPersistenceUsingPOST_RAW_URL
 * @param body - 
 */
export const generateEntityFromPersistenceUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/from-persistence/generate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const generateEntityFromPersistenceUsingPOST_RAW_URL = function() {
  return '/entity/from-persistence/generate'
}
export const generateEntityFromPersistenceUsingPOST_TYPE = function() {
  return 'post'
}
export const generateEntityFromPersistenceUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/from-persistence/generate'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: upsertEditSessionUsingPOST
 * url: upsertEditSessionUsingPOSTURL
 * method: upsertEditSessionUsingPOST_TYPE
 * raw_url: upsertEditSessionUsingPOST_RAW_URL
 * @param body - 
 */
export const upsertEditSessionUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/edit-session'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const upsertEditSessionUsingPOST_RAW_URL = function() {
  return '/edit-session'
}
export const upsertEditSessionUsingPOST_TYPE = function() {
  return 'post'
}
export const upsertEditSessionUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/edit-session'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteEditSessionUsingDELETE
 * url: deleteEditSessionUsingDELETEURL
 * method: deleteEditSessionUsingDELETE_TYPE
 * raw_url: deleteEditSessionUsingDELETE_RAW_URL
 * @param resourceId - 
 * @param resourceType - 
 */
export const deleteEditSessionUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/edit-session'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['resourceId'] !== undefined) {
    queryParameters['resourceId'] = parameters['resourceId']
  }
  if (parameters['resourceType'] !== undefined) {
    queryParameters['resourceType'] = parameters['resourceType']
  }
  if (parameters['resourceType'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: resourceType'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteEditSessionUsingDELETE_RAW_URL = function() {
  return '/edit-session'
}
export const deleteEditSessionUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteEditSessionUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/edit-session'
  if (parameters['resourceId'] !== undefined) {
    queryParameters['resourceId'] = parameters['resourceId']
  }
  if (parameters['resourceType'] !== undefined) {
    queryParameters['resourceType'] = parameters['resourceType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: captchaCreateUsingPOST
 * url: captchaCreateUsingPOSTURL
 * method: captchaCreateUsingPOST_TYPE
 * raw_url: captchaCreateUsingPOST_RAW_URL
 * @param body - 
 */
export const captchaCreateUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/captcha/create'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const captchaCreateUsingPOST_RAW_URL = function() {
  return '/captcha/create'
}
export const captchaCreateUsingPOST_TYPE = function() {
  return 'post'
}
export const captchaCreateUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/captcha/create'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: rebuildCacheUsingPOST
 * url: rebuildCacheUsingPOSTURL
 * method: rebuildCacheUsingPOST_TYPE
 * raw_url: rebuildCacheUsingPOST_RAW_URL
 * @param cacheType - 
 */
export const rebuildCacheUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/cache/rebuild'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cacheType'] !== undefined) {
    queryParameters['cacheType'] = parameters['cacheType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const rebuildCacheUsingPOST_RAW_URL = function() {
  return '/cache/rebuild'
}
export const rebuildCacheUsingPOST_TYPE = function() {
  return 'post'
}
export const rebuildCacheUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/cache/rebuild'
  if (parameters['cacheType'] !== undefined) {
    queryParameters['cacheType'] = parameters['cacheType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationsUsingGET
 * url: getApplicationsUsingGETURL
 * method: getApplicationsUsingGET_TYPE
 * raw_url: getApplicationsUsingGET_RAW_URL
 * @param type - 
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getApplicationsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationsUsingGET_RAW_URL = function() {
  return '/application'
}
export const getApplicationsUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application'
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createApplicationUsingPOST
 * url: createApplicationUsingPOSTURL
 * method: createApplicationUsingPOST_TYPE
 * raw_url: createApplicationUsingPOST_RAW_URL
 * @param body - 
 */
export const createApplicationUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createApplicationUsingPOST_RAW_URL = function() {
  return '/application'
}
export const createApplicationUsingPOST_TYPE = function() {
  return 'post'
}
export const createApplicationUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: triggerUploadUsingPOST
 * url: triggerUploadUsingPOSTURL
 * method: triggerUploadUsingPOST_TYPE
 * raw_url: triggerUploadUsingPOST_RAW_URL
 * @param id - 
 */
export const triggerUploadUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/upload'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const triggerUploadUsingPOST_RAW_URL = function() {
  return '/application/{id}/upload'
}
export const triggerUploadUsingPOST_TYPE = function() {
  return 'post'
}
export const triggerUploadUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/upload'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: generateApplicationTriggerRestUsingPOST
 * url: generateApplicationTriggerRestUsingPOSTURL
 * method: generateApplicationTriggerRestUsingPOST_TYPE
 * raw_url: generateApplicationTriggerRestUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const generateApplicationTriggerRestUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/trigger-rest/generate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const generateApplicationTriggerRestUsingPOST_RAW_URL = function() {
  return '/application/{id}/trigger-rest/generate'
}
export const generateApplicationTriggerRestUsingPOST_TYPE = function() {
  return 'post'
}
export const generateApplicationTriggerRestUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/trigger-rest/generate'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: stopApplicationLifecycleUsingPOST
 * url: stopApplicationLifecycleUsingPOSTURL
 * method: stopApplicationLifecycleUsingPOST_TYPE
 * raw_url: stopApplicationLifecycleUsingPOST_RAW_URL
 * @param id - 
 */
export const stopApplicationLifecycleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/lifecycle/stop'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const stopApplicationLifecycleUsingPOST_RAW_URL = function() {
  return '/application/{id}/lifecycle/stop'
}
export const stopApplicationLifecycleUsingPOST_TYPE = function() {
  return 'post'
}
export const stopApplicationLifecycleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/lifecycle/stop'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: runApplicationLifecycleUsingPOST
 * url: runApplicationLifecycleUsingPOSTURL
 * method: runApplicationLifecycleUsingPOST_TYPE
 * raw_url: runApplicationLifecycleUsingPOST_RAW_URL
 * @param id - 
 */
export const runApplicationLifecycleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/lifecycle/run'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const runApplicationLifecycleUsingPOST_RAW_URL = function() {
  return '/application/{id}/lifecycle/run'
}
export const runApplicationLifecycleUsingPOST_TYPE = function() {
  return 'post'
}
export const runApplicationLifecycleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/lifecycle/run'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: buildApplicationLifecycleUsingPOST
 * url: buildApplicationLifecycleUsingPOSTURL
 * method: buildApplicationLifecycleUsingPOST_TYPE
 * raw_url: buildApplicationLifecycleUsingPOST_RAW_URL
 * @param id - 
 */
export const buildApplicationLifecycleUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/lifecycle/build'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const buildApplicationLifecycleUsingPOST_RAW_URL = function() {
  return '/application/{id}/lifecycle/build'
}
export const buildApplicationLifecycleUsingPOST_TYPE = function() {
  return 'post'
}
export const buildApplicationLifecycleUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/lifecycle/build'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: unstageApplicationGitPathsUsingPOST
 * url: unstageApplicationGitPathsUsingPOSTURL
 * method: unstageApplicationGitPathsUsingPOST_TYPE
 * raw_url: unstageApplicationGitPathsUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const unstageApplicationGitPathsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/unstage'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const unstageApplicationGitPathsUsingPOST_RAW_URL = function() {
  return '/application/{id}/git/unstage'
}
export const unstageApplicationGitPathsUsingPOST_TYPE = function() {
  return 'post'
}
export const unstageApplicationGitPathsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/unstage'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: pushApplicationGitUsingPOST
 * url: pushApplicationGitUsingPOSTURL
 * method: pushApplicationGitUsingPOST_TYPE
 * raw_url: pushApplicationGitUsingPOST_RAW_URL
 * @param id - 
 */
export const pushApplicationGitUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/push'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const pushApplicationGitUsingPOST_RAW_URL = function() {
  return '/application/{id}/git/push'
}
export const pushApplicationGitUsingPOST_TYPE = function() {
  return 'post'
}
export const pushApplicationGitUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/push'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: pullApplicationGitUsingPOST
 * url: pullApplicationGitUsingPOSTURL
 * method: pullApplicationGitUsingPOST_TYPE
 * raw_url: pullApplicationGitUsingPOST_RAW_URL
 * @param id - 
 */
export const pullApplicationGitUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/pull'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const pullApplicationGitUsingPOST_RAW_URL = function() {
  return '/application/{id}/git/pull'
}
export const pullApplicationGitUsingPOST_TYPE = function() {
  return 'post'
}
export const pullApplicationGitUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/pull'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: commitApplicationGitUsingPOST
 * url: commitApplicationGitUsingPOSTURL
 * method: commitApplicationGitUsingPOST_TYPE
 * raw_url: commitApplicationGitUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const commitApplicationGitUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/commit'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const commitApplicationGitUsingPOST_RAW_URL = function() {
  return '/application/{id}/git/commit'
}
export const commitApplicationGitUsingPOST_TYPE = function() {
  return 'post'
}
export const commitApplicationGitUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/commit'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: cloneApplicationGitRepositoryUsingPOST
 * url: cloneApplicationGitRepositoryUsingPOSTURL
 * method: cloneApplicationGitRepositoryUsingPOST_TYPE
 * raw_url: cloneApplicationGitRepositoryUsingPOST_RAW_URL
 * @param id - 
 */
export const cloneApplicationGitRepositoryUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/clone'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const cloneApplicationGitRepositoryUsingPOST_RAW_URL = function() {
  return '/application/{id}/git/clone'
}
export const cloneApplicationGitRepositoryUsingPOST_TYPE = function() {
  return 'post'
}
export const cloneApplicationGitRepositoryUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/clone'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: checkoutApplicationGitBranchUsingPOST
 * url: checkoutApplicationGitBranchUsingPOSTURL
 * method: checkoutApplicationGitBranchUsingPOST_TYPE
 * raw_url: checkoutApplicationGitBranchUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const checkoutApplicationGitBranchUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/checkout'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const checkoutApplicationGitBranchUsingPOST_RAW_URL = function() {
  return '/application/{id}/git/checkout'
}
export const checkoutApplicationGitBranchUsingPOST_TYPE = function() {
  return 'post'
}
export const checkoutApplicationGitBranchUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/checkout'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: addApplicationGitPathsUsingPOST
 * url: addApplicationGitPathsUsingPOSTURL
 * method: addApplicationGitPathsUsingPOST_TYPE
 * raw_url: addApplicationGitPathsUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const addApplicationGitPathsUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/add'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addApplicationGitPathsUsingPOST_RAW_URL = function() {
  return '/application/{id}/git/add'
}
export const addApplicationGitPathsUsingPOST_TYPE = function() {
  return 'post'
}
export const addApplicationGitPathsUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/add'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: listFilesUsingGET
 * url: listFilesUsingGETURL
 * method: listFilesUsingGET_TYPE
 * raw_url: listFilesUsingGET_RAW_URL
 * @param id - 
 * @param path - 
 */
export const listFilesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/files'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const listFilesUsingGET_RAW_URL = function() {
  return '/application/{id}/files'
}
export const listFilesUsingGET_TYPE = function() {
  return 'get'
}
export const listFilesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/files'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: uploadFileUsingPOST
 * url: uploadFileUsingPOSTURL
 * method: uploadFileUsingPOST_TYPE
 * raw_url: uploadFileUsingPOST_RAW_URL
 * @param id - 
 * @param path - 
 * @param file - 
 */
export const uploadFileUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/files'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters['path'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: path'))
  }
  if (parameters['file'] !== undefined) {
    form['file'] = parameters['file']
  }
  if (parameters['file'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: file'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadFileUsingPOST_RAW_URL = function() {
  return '/application/{id}/files'
}
export const uploadFileUsingPOST_TYPE = function() {
  return 'post'
}
export const uploadFileUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/files'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteFileUsingDELETE
 * url: deleteFileUsingDELETEURL
 * method: deleteFileUsingDELETE_TYPE
 * raw_url: deleteFileUsingDELETE_RAW_URL
 * @param id - 
 * @param path - 
 */
export const deleteFileUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/files'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters['path'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: path'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteFileUsingDELETE_RAW_URL = function() {
  return '/application/{id}/files'
}
export const deleteFileUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteFileUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/files'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: stopApplicationContainerUsingPOST
 * url: stopApplicationContainerUsingPOSTURL
 * method: stopApplicationContainerUsingPOST_TYPE
 * raw_url: stopApplicationContainerUsingPOST_RAW_URL
 * @param id - 
 */
export const stopApplicationContainerUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/container/stop'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const stopApplicationContainerUsingPOST_RAW_URL = function() {
  return '/application/{id}/container/stop'
}
export const stopApplicationContainerUsingPOST_TYPE = function() {
  return 'post'
}
export const stopApplicationContainerUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/container/stop'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: startApplicationContainerUsingPOST
 * url: startApplicationContainerUsingPOSTURL
 * method: startApplicationContainerUsingPOST_TYPE
 * raw_url: startApplicationContainerUsingPOST_RAW_URL
 * @param id - 
 */
export const startApplicationContainerUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/container/start'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const startApplicationContainerUsingPOST_RAW_URL = function() {
  return '/application/{id}/container/start'
}
export const startApplicationContainerUsingPOST_TYPE = function() {
  return 'post'
}
export const startApplicationContainerUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/container/start'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: pauseApplicationContainerUsingPOST
 * url: pauseApplicationContainerUsingPOSTURL
 * method: pauseApplicationContainerUsingPOST_TYPE
 * raw_url: pauseApplicationContainerUsingPOST_RAW_URL
 * @param id - 
 */
export const pauseApplicationContainerUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/container/pause'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const pauseApplicationContainerUsingPOST_RAW_URL = function() {
  return '/application/{id}/container/pause'
}
export const pauseApplicationContainerUsingPOST_TYPE = function() {
  return 'post'
}
export const pauseApplicationContainerUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/container/pause'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: triggerCdnRefreshUsingPOST
 * url: triggerCdnRefreshUsingPOSTURL
 * method: triggerCdnRefreshUsingPOST_TYPE
 * raw_url: triggerCdnRefreshUsingPOST_RAW_URL
 * @param id - 
 */
export const triggerCdnRefreshUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/cdn-refresh'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const triggerCdnRefreshUsingPOST_RAW_URL = function() {
  return '/application/{id}/cdn-refresh'
}
export const triggerCdnRefreshUsingPOST_TYPE = function() {
  return 'post'
}
export const triggerCdnRefreshUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/cdn-refresh'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getAiAgentsUsingGET
 * url: getAiAgentsUsingGETURL
 * method: getAiAgentsUsingGET_TYPE
 * raw_url: getAiAgentsUsingGET_RAW_URL
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getAiAgentsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAiAgentsUsingGET_RAW_URL = function() {
  return '/ai-agent'
}
export const getAiAgentsUsingGET_TYPE = function() {
  return 'get'
}
export const getAiAgentsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent'
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createAiAgentUsingPOST
 * url: createAiAgentUsingPOSTURL
 * method: createAiAgentUsingPOST_TYPE
 * raw_url: createAiAgentUsingPOST_RAW_URL
 * @param body - 
 */
export const createAiAgentUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createAiAgentUsingPOST_RAW_URL = function() {
  return '/ai-agent'
}
export const createAiAgentUsingPOST_TYPE = function() {
  return 'post'
}
export const createAiAgentUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: listChatsUsingGET
 * url: listChatsUsingGETURL
 * method: listChatsUsingGET_TYPE
 * raw_url: listChatsUsingGET_RAW_URL
 * @param id - 
 */
export const listChatsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/chat'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const listChatsUsingGET_RAW_URL = function() {
  return '/ai-agent/{id}/chat'
}
export const listChatsUsingGET_TYPE = function() {
  return 'get'
}
export const listChatsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/chat'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: createChatUsingPOST
 * url: createChatUsingPOSTURL
 * method: createChatUsingPOST_TYPE
 * raw_url: createChatUsingPOST_RAW_URL
 * @param id - 
 * @param body - 
 */
export const createChatUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/chat'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createChatUsingPOST_RAW_URL = function() {
  return '/ai-agent/{id}/chat'
}
export const createChatUsingPOST_TYPE = function() {
  return 'post'
}
export const createChatUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/chat'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getChatMessageStatusUsingGET
 * url: getChatMessageStatusUsingGETURL
 * method: getChatMessageStatusUsingGET_TYPE
 * raw_url: getChatMessageStatusUsingGET_RAW_URL
 * @param id - 
 * @param chatId - 
 * @param eventId - 
 */
export const getChatMessageStatusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/chat/{chatId}/messages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{chatId}', `${parameters['chatId']}`)
  if (parameters['chatId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chatId'))
  }
  if (parameters['eventId'] !== undefined) {
    queryParameters['eventId'] = parameters['eventId']
  }
  if (parameters['eventId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: eventId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getChatMessageStatusUsingGET_RAW_URL = function() {
  return '/ai-agent/{id}/chat/{chatId}/messages'
}
export const getChatMessageStatusUsingGET_TYPE = function() {
  return 'get'
}
export const getChatMessageStatusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/chat/{chatId}/messages'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{chatId}', `${parameters['chatId']}`)
  if (parameters['eventId'] !== undefined) {
    queryParameters['eventId'] = parameters['eventId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: sendChatMessageUsingPOST
 * url: sendChatMessageUsingPOSTURL
 * method: sendChatMessageUsingPOST_TYPE
 * raw_url: sendChatMessageUsingPOST_RAW_URL
 * @param id - 
 * @param chatId - 
 * @param body - 
 */
export const sendChatMessageUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/chat/{chatId}/messages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{chatId}', `${parameters['chatId']}`)
  if (parameters['chatId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chatId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const sendChatMessageUsingPOST_RAW_URL = function() {
  return '/ai-agent/{id}/chat/{chatId}/messages'
}
export const sendChatMessageUsingPOST_TYPE = function() {
  return 'post'
}
export const sendChatMessageUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/chat/{chatId}/messages'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{chatId}', `${parameters['chatId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getValidationRuleUsagesByIdUsingGET
 * url: getValidationRuleUsagesByIdUsingGETURL
 * method: getValidationRuleUsagesByIdUsingGET_TYPE
 * raw_url: getValidationRuleUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getValidationRuleUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/validation-rule/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getValidationRuleUsagesByIdUsingGET_RAW_URL = function() {
  return '/validation-rule/{id}/usages'
}
export const getValidationRuleUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getValidationRuleUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/validation-rule/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getValidationRuleTagsUsingGET
 * url: getValidationRuleTagsUsingGETURL
 * method: getValidationRuleTagsUsingGET_TYPE
 * raw_url: getValidationRuleTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getValidationRuleTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/validation-rule/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getValidationRuleTagsUsingGET_RAW_URL = function() {
  return '/validation-rule/{id}/tags'
}
export const getValidationRuleTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getValidationRuleTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/validation-rule/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getUserNameUsingGET
 * url: getUserNameUsingGETURL
 * method: getUserNameUsingGET_TYPE
 * raw_url: getUserNameUsingGET_RAW_URL
 * @param id - 
 */
export const getUserNameUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/name'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserNameUsingGET_RAW_URL = function() {
  return '/user/{id}/name'
}
export const getUserNameUsingGET_TYPE = function() {
  return 'get'
}
export const getUserNameUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/name'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableUserUsingGET
 * url: enableUserUsingGETURL
 * method: enableUserUsingGET_TYPE
 * raw_url: enableUserUsingGET_RAW_URL
 * @param id - 
 */
export const enableUserUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableUserUsingGET_RAW_URL = function() {
  return '/user/{id}/enable'
}
export const enableUserUsingGET_TYPE = function() {
  return 'get'
}
export const enableUserUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableUserUsingGET
 * url: disableUserUsingGETURL
 * method: disableUserUsingGET_TYPE
 * raw_url: disableUserUsingGET_RAW_URL
 * @param id - 
 */
export const disableUserUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableUserUsingGET_RAW_URL = function() {
  return '/user/{id}/disable'
}
export const disableUserUsingGET_TYPE = function() {
  return 'get'
}
export const disableUserUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getCurrentUserInfoUsingGET
 * url: getCurrentUserInfoUsingGETURL
 * method: getCurrentUserInfoUsingGET_TYPE
 * raw_url: getCurrentUserInfoUsingGET_RAW_URL
 */
export const getCurrentUserInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/me'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCurrentUserInfoUsingGET_RAW_URL = function() {
  return '/user/me'
}
export const getCurrentUserInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getCurrentUserInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/me'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getUsersByRoleUsingGET
 * url: getUsersByRoleUsingGETURL
 * method: getUsersByRoleUsingGET_TYPE
 * raw_url: getUsersByRoleUsingGET_RAW_URL
 * @param roleId - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getUsersByRoleUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/by-role'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['roleId'] !== undefined) {
    queryParameters['roleId'] = parameters['roleId']
  }
  if (parameters['roleId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: roleId'))
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUsersByRoleUsingGET_RAW_URL = function() {
  return '/user/by-role'
}
export const getUsersByRoleUsingGET_TYPE = function() {
  return 'get'
}
export const getUsersByRoleUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/by-role'
  if (parameters['roleId'] !== undefined) {
    queryParameters['roleId'] = parameters['roleId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getUserSettingUsingGET
 * url: getUserSettingUsingGETURL
 * method: getUserSettingUsingGET_TYPE
 * raw_url: getUserSettingUsingGET_RAW_URL
 * @param key - 
 */
export const getUserSettingUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user-setting/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserSettingUsingGET_RAW_URL = function() {
  return '/user-setting/{key}'
}
export const getUserSettingUsingGET_TYPE = function() {
  return 'get'
}
export const getUserSettingUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user-setting/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getUserHistoriesUsingGET
 * url: getUserHistoriesUsingGETURL
 * method: getUserHistoriesUsingGET_TYPE
 * raw_url: getUserHistoriesUsingGET_RAW_URL
 * @param subjectUserId - 
 * @param actorUserId - 
 * @param actions - 
 * @param subjectEmail - 
 * @param dateFrom - 
 * @param dateTill - 
 * @param size - 
 * @param page - 
 */
export const getUserHistoriesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user-history'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['subjectUserId'] !== undefined) {
    queryParameters['subjectUserId'] = parameters['subjectUserId']
  }
  if (parameters['actorUserId'] !== undefined) {
    queryParameters['actorUserId'] = parameters['actorUserId']
  }
  if (parameters['actions'] !== undefined) {
    queryParameters['actions'] = parameters['actions']
  }
  if (parameters['subjectEmail'] !== undefined) {
    queryParameters['subjectEmail'] = parameters['subjectEmail']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserHistoriesUsingGET_RAW_URL = function() {
  return '/user-history'
}
export const getUserHistoriesUsingGET_TYPE = function() {
  return 'get'
}
export const getUserHistoriesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user-history'
  if (parameters['subjectUserId'] !== undefined) {
    queryParameters['subjectUserId'] = parameters['subjectUserId']
  }
  if (parameters['actorUserId'] !== undefined) {
    queryParameters['actorUserId'] = parameters['actorUserId']
  }
  if (parameters['actions'] !== undefined) {
    queryParameters['actions'] = parameters['actions']
  }
  if (parameters['subjectEmail'] !== undefined) {
    queryParameters['subjectEmail'] = parameters['subjectEmail']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getUserHistoryByIdUsingGET
 * url: getUserHistoryByIdUsingGETURL
 * method: getUserHistoryByIdUsingGET_TYPE
 * raw_url: getUserHistoryByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getUserHistoryByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user-history/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserHistoryByIdUsingGET_RAW_URL = function() {
  return '/user-history/{id}'
}
export const getUserHistoryByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getUserHistoryByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user-history/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerWhatsAppTagsUsingGET
 * url: getTriggerWhatsAppTagsUsingGETURL
 * method: getTriggerWhatsAppTagsUsingGET_TYPE
 * raw_url: getTriggerWhatsAppTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerWhatsAppTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerWhatsAppTagsUsingGET_RAW_URL = function() {
  return '/trigger-whatsapp/{id}/tags'
}
export const getTriggerWhatsAppTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerWhatsAppTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTriggerWhatsAppUsingGET
 * url: enableTriggerWhatsAppUsingGETURL
 * method: enableTriggerWhatsAppUsingGET_TYPE
 * raw_url: enableTriggerWhatsAppUsingGET_RAW_URL
 * @param id - 
 */
export const enableTriggerWhatsAppUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableTriggerWhatsAppUsingGET_RAW_URL = function() {
  return '/trigger-whatsapp/{id}/enable'
}
export const enableTriggerWhatsAppUsingGET_TYPE = function() {
  return 'get'
}
export const enableTriggerWhatsAppUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTriggerWhatsAppUsingGET
 * url: disableTriggerWhatsAppUsingGETURL
 * method: disableTriggerWhatsAppUsingGET_TYPE
 * raw_url: disableTriggerWhatsAppUsingGET_RAW_URL
 * @param id - 
 */
export const disableTriggerWhatsAppUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-whatsapp/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableTriggerWhatsAppUsingGET_RAW_URL = function() {
  return '/trigger-whatsapp/{id}/disable'
}
export const disableTriggerWhatsAppUsingGET_TYPE = function() {
  return 'get'
}
export const disableTriggerWhatsAppUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-whatsapp/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerUiUsagesByIdUsingGET
 * url: getTriggerUiUsagesByIdUsingGETURL
 * method: getTriggerUiUsagesByIdUsingGET_TYPE
 * raw_url: getTriggerUiUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getTriggerUiUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerUiUsagesByIdUsingGET_RAW_URL = function() {
  return '/trigger-ui/{id}/usages'
}
export const getTriggerUiUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerUiUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerUiTagsUsingGET
 * url: getTriggerUiTagsUsingGETURL
 * method: getTriggerUiTagsUsingGET_TYPE
 * raw_url: getTriggerUiTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerUiTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerUiTagsUsingGET_RAW_URL = function() {
  return '/trigger-ui/{id}/tags'
}
export const getTriggerUiTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerUiTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTriggerUiUsingGET
 * url: enableTriggerUiUsingGETURL
 * method: enableTriggerUiUsingGET_TYPE
 * raw_url: enableTriggerUiUsingGET_RAW_URL
 * @param id - 
 */
export const enableTriggerUiUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableTriggerUiUsingGET_RAW_URL = function() {
  return '/trigger-ui/{id}/enable'
}
export const enableTriggerUiUsingGET_TYPE = function() {
  return 'get'
}
export const enableTriggerUiUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTriggerUiUsingGET
 * url: disableTriggerUiUsingGETURL
 * method: disableTriggerUiUsingGET_TYPE
 * raw_url: disableTriggerUiUsingGET_RAW_URL
 * @param id - 
 */
export const disableTriggerUiUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-ui/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableTriggerUiUsingGET_RAW_URL = function() {
  return '/trigger-ui/{id}/disable'
}
export const disableTriggerUiUsingGET_TYPE = function() {
  return 'get'
}
export const disableTriggerUiUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-ui/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerRestUsagesByIdUsingGET
 * url: getTriggerRestUsagesByIdUsingGETURL
 * method: getTriggerRestUsagesByIdUsingGET_TYPE
 * raw_url: getTriggerRestUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getTriggerRestUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerRestUsagesByIdUsingGET_RAW_URL = function() {
  return '/trigger-rest/{id}/usages'
}
export const getTriggerRestUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerRestUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerRestTagsUsingGET
 * url: getTriggerRestTagsUsingGETURL
 * method: getTriggerRestTagsUsingGET_TYPE
 * raw_url: getTriggerRestTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerRestTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerRestTagsUsingGET_RAW_URL = function() {
  return '/trigger-rest/{id}/tags'
}
export const getTriggerRestTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerRestTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTriggerRestUsingGET
 * url: enableTriggerRestUsingGETURL
 * method: enableTriggerRestUsingGET_TYPE
 * raw_url: enableTriggerRestUsingGET_RAW_URL
 * @param id - 
 */
export const enableTriggerRestUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableTriggerRestUsingGET_RAW_URL = function() {
  return '/trigger-rest/{id}/enable'
}
export const enableTriggerRestUsingGET_TYPE = function() {
  return 'get'
}
export const enableTriggerRestUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTriggerRestUsingGET
 * url: disableTriggerRestUsingGETURL
 * method: disableTriggerRestUsingGET_TYPE
 * raw_url: disableTriggerRestUsingGET_RAW_URL
 * @param id - 
 */
export const disableTriggerRestUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableTriggerRestUsingGET_RAW_URL = function() {
  return '/trigger-rest/{id}/disable'
}
export const disableTriggerRestUsingGET_TYPE = function() {
  return 'get'
}
export const disableTriggerRestUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: triggerRestCheckUsingGET
 * url: triggerRestCheckUsingGETURL
 * method: triggerRestCheckUsingGET_TYPE
 * raw_url: triggerRestCheckUsingGET_RAW_URL
 * @param method - 
 * @param url - 
 */
export const triggerRestCheckUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-rest/check'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['method'] !== undefined) {
    queryParameters['method'] = parameters['method']
  }
  if (parameters['method'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: method'))
  }
  if (parameters['url'] !== undefined) {
    queryParameters['url'] = parameters['url']
  }
  if (parameters['url'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: url'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const triggerRestCheckUsingGET_RAW_URL = function() {
  return '/trigger-rest/check'
}
export const triggerRestCheckUsingGET_TYPE = function() {
  return 'get'
}
export const triggerRestCheckUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-rest/check'
  if (parameters['method'] !== undefined) {
    queryParameters['method'] = parameters['method']
  }
  if (parameters['url'] !== undefined) {
    queryParameters['url'] = parameters['url']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerMessagingUsagesByIdUsingGET
 * url: getTriggerMessagingUsagesByIdUsingGETURL
 * method: getTriggerMessagingUsagesByIdUsingGET_TYPE
 * raw_url: getTriggerMessagingUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getTriggerMessagingUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerMessagingUsagesByIdUsingGET_RAW_URL = function() {
  return '/trigger-messaging/{id}/usages'
}
export const getTriggerMessagingUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerMessagingUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerMessagingTagsUsingGET
 * url: getTriggerMessagingTagsUsingGETURL
 * method: getTriggerMessagingTagsUsingGET_TYPE
 * raw_url: getTriggerMessagingTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerMessagingTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerMessagingTagsUsingGET_RAW_URL = function() {
  return '/trigger-messaging/{id}/tags'
}
export const getTriggerMessagingTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerMessagingTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTriggerMessagingUsingGET
 * url: enableTriggerMessagingUsingGETURL
 * method: enableTriggerMessagingUsingGET_TYPE
 * raw_url: enableTriggerMessagingUsingGET_RAW_URL
 * @param id - 
 */
export const enableTriggerMessagingUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableTriggerMessagingUsingGET_RAW_URL = function() {
  return '/trigger-messaging/{id}/enable'
}
export const enableTriggerMessagingUsingGET_TYPE = function() {
  return 'get'
}
export const enableTriggerMessagingUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTriggerMessagingUsingGET
 * url: disableTriggerMessagingUsingGETURL
 * method: disableTriggerMessagingUsingGET_TYPE
 * raw_url: disableTriggerMessagingUsingGET_RAW_URL
 * @param id - 
 */
export const disableTriggerMessagingUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableTriggerMessagingUsingGET_RAW_URL = function() {
  return '/trigger-messaging/{id}/disable'
}
export const disableTriggerMessagingUsingGET_TYPE = function() {
  return 'get'
}
export const disableTriggerMessagingUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerMessagingServicesUsingGET
 * url: getTriggerMessagingServicesUsingGETURL
 * method: getTriggerMessagingServicesUsingGET_TYPE
 * raw_url: getTriggerMessagingServicesUsingGET_RAW_URL
 */
export const getTriggerMessagingServicesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-messaging/services'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerMessagingServicesUsingGET_RAW_URL = function() {
  return '/trigger-messaging/services'
}
export const getTriggerMessagingServicesUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerMessagingServicesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-messaging/services'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerMcpTagsUsingGET
 * url: getTriggerMcpTagsUsingGETURL
 * method: getTriggerMcpTagsUsingGET_TYPE
 * raw_url: getTriggerMcpTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerMcpTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerMcpTagsUsingGET_RAW_URL = function() {
  return '/trigger-mcp/{id}/tags'
}
export const getTriggerMcpTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerMcpTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTriggerMcpUsingGET
 * url: enableTriggerMcpUsingGETURL
 * method: enableTriggerMcpUsingGET_TYPE
 * raw_url: enableTriggerMcpUsingGET_RAW_URL
 * @param id - 
 */
export const enableTriggerMcpUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableTriggerMcpUsingGET_RAW_URL = function() {
  return '/trigger-mcp/{id}/enable'
}
export const enableTriggerMcpUsingGET_TYPE = function() {
  return 'get'
}
export const enableTriggerMcpUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTriggerMcpUsingGET
 * url: disableTriggerMcpUsingGETURL
 * method: disableTriggerMcpUsingGET_TYPE
 * raw_url: disableTriggerMcpUsingGET_RAW_URL
 * @param id - 
 */
export const disableTriggerMcpUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-mcp/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableTriggerMcpUsingGET_RAW_URL = function() {
  return '/trigger-mcp/{id}/disable'
}
export const disableTriggerMcpUsingGET_TYPE = function() {
  return 'get'
}
export const disableTriggerMcpUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-mcp/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerEventHandlerTagsUsingGET
 * url: getTriggerEventHandlerTagsUsingGETURL
 * method: getTriggerEventHandlerTagsUsingGET_TYPE
 * raw_url: getTriggerEventHandlerTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerEventHandlerTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerEventHandlerTagsUsingGET_RAW_URL = function() {
  return '/trigger-event-handler/{id}/tags'
}
export const getTriggerEventHandlerTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerEventHandlerTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTriggerEventHandlerUsingGET
 * url: enableTriggerEventHandlerUsingGETURL
 * method: enableTriggerEventHandlerUsingGET_TYPE
 * raw_url: enableTriggerEventHandlerUsingGET_RAW_URL
 * @param id - 
 */
export const enableTriggerEventHandlerUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableTriggerEventHandlerUsingGET_RAW_URL = function() {
  return '/trigger-event-handler/{id}/enable'
}
export const enableTriggerEventHandlerUsingGET_TYPE = function() {
  return 'get'
}
export const enableTriggerEventHandlerUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTriggerEventHandlerUsingGET
 * url: disableTriggerEventHandlerUsingGETURL
 * method: disableTriggerEventHandlerUsingGET_TYPE
 * raw_url: disableTriggerEventHandlerUsingGET_RAW_URL
 * @param id - 
 */
export const disableTriggerEventHandlerUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-event-handler/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableTriggerEventHandlerUsingGET_RAW_URL = function() {
  return '/trigger-event-handler/{id}/disable'
}
export const disableTriggerEventHandlerUsingGET_TYPE = function() {
  return 'get'
}
export const disableTriggerEventHandlerUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-event-handler/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerCronUsagesByIdUsingGET
 * url: getTriggerCronUsagesByIdUsingGETURL
 * method: getTriggerCronUsagesByIdUsingGET_TYPE
 * raw_url: getTriggerCronUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getTriggerCronUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerCronUsagesByIdUsingGET_RAW_URL = function() {
  return '/trigger-cron/{id}/usages'
}
export const getTriggerCronUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerCronUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggerCronTagsUsingGET
 * url: getTriggerCronTagsUsingGETURL
 * method: getTriggerCronTagsUsingGET_TYPE
 * raw_url: getTriggerCronTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTriggerCronTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggerCronTagsUsingGET_RAW_URL = function() {
  return '/trigger-cron/{id}/tags'
}
export const getTriggerCronTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggerCronTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: executeUsingGET
 * url: executeUsingGETURL
 * method: executeUsingGET_TYPE
 * raw_url: executeUsingGET_RAW_URL
 * @param id - 
 */
export const executeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}/execute'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const executeUsingGET_RAW_URL = function() {
  return '/trigger-cron/{id}/execute'
}
export const executeUsingGET_TYPE = function() {
  return 'get'
}
export const executeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}/execute'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTriggerCronUsingGET
 * url: enableTriggerCronUsingGETURL
 * method: enableTriggerCronUsingGET_TYPE
 * raw_url: enableTriggerCronUsingGET_RAW_URL
 * @param id - 
 */
export const enableTriggerCronUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableTriggerCronUsingGET_RAW_URL = function() {
  return '/trigger-cron/{id}/enable'
}
export const enableTriggerCronUsingGET_TYPE = function() {
  return 'get'
}
export const enableTriggerCronUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTriggerCronUsingGET
 * url: disableTriggerCronUsingGETURL
 * method: disableTriggerCronUsingGET_TYPE
 * raw_url: disableTriggerCronUsingGET_RAW_URL
 * @param id - 
 */
export const disableTriggerCronUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/trigger-cron/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableTriggerCronUsingGET_RAW_URL = function() {
  return '/trigger-cron/{id}/disable'
}
export const disableTriggerCronUsingGET_TYPE = function() {
  return 'get'
}
export const disableTriggerCronUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/trigger-cron/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTranslationUsingGET
 * url: getTranslationUsingGETURL
 * method: getTranslationUsingGET_TYPE
 * raw_url: getTranslationUsingGET_RAW_URL
 * @param id - 
 */
export const getTranslationUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/translation/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTranslationUsingGET_RAW_URL = function() {
  return '/translation/{id}'
}
export const getTranslationUsingGET_TYPE = function() {
  return 'get'
}
export const getTranslationUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/translation/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTranslationTagsUsingGET
 * url: getTranslationTagsUsingGETURL
 * method: getTranslationTagsUsingGET_TYPE
 * raw_url: getTranslationTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTranslationTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/translation/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTranslationTagsUsingGET_RAW_URL = function() {
  return '/translation/{id}/tags'
}
export const getTranslationTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTranslationTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/translation/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTextTemplateUsagesByIdUsingGET
 * url: getTextTemplateUsagesByIdUsingGETURL
 * method: getTextTemplateUsagesByIdUsingGET_TYPE
 * raw_url: getTextTemplateUsagesByIdUsingGET_RAW_URL
 * @param templateId - 
 * @param request - 
 */
export const getTextTemplateUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{templateId}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['templateId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: templateId'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTextTemplateUsagesByIdUsingGET_RAW_URL = function() {
  return '/text-template/{templateId}/usages'
}
export const getTextTemplateUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTextTemplateUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{templateId}/usages'
  path = path.replace('{templateId}', `${parameters['templateId']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTextTemplateTagsUsingGET
 * url: getTextTemplateTagsUsingGETURL
 * method: getTextTemplateTagsUsingGET_TYPE
 * raw_url: getTextTemplateTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getTextTemplateTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/text-template/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTextTemplateTagsUsingGET_RAW_URL = function() {
  return '/text-template/{id}/tags'
}
export const getTextTemplateTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getTextTemplateTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/text-template/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: listTenantRolesUsingGET
 * url: listTenantRolesUsingGETURL
 * method: listTenantRolesUsingGET_TYPE
 * raw_url: listTenantRolesUsingGET_RAW_URL
 * @param tenantId - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const listTenantRolesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{tenantId}/role'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters['tenantId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: tenantId'))
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const listTenantRolesUsingGET_RAW_URL = function() {
  return '/tenant/{tenantId}/role'
}
export const listTenantRolesUsingGET_TYPE = function() {
  return 'get'
}
export const listTenantRolesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{tenantId}/role'
  path = path.replace('{tenantId}', `${parameters['tenantId']}`)
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getCurrentHarborContainersUsingGET
 * url: getCurrentHarborContainersUsingGETURL
 * method: getCurrentHarborContainersUsingGET_TYPE
 * raw_url: getCurrentHarborContainersUsingGET_RAW_URL
 * @param id - 
 */
export const getCurrentHarborContainersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{id}/harbor/containers'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCurrentHarborContainersUsingGET_RAW_URL = function() {
  return '/tenant/{id}/harbor/containers'
}
export const getCurrentHarborContainersUsingGET_TYPE = function() {
  return 'get'
}
export const getCurrentHarborContainersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{id}/harbor/containers'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableTenantUsingGET
 * url: enableTenantUsingGETURL
 * method: enableTenantUsingGET_TYPE
 * raw_url: enableTenantUsingGET_RAW_URL
 * @param id - 
 */
export const enableTenantUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableTenantUsingGET_RAW_URL = function() {
  return '/tenant/{id}/enable'
}
export const enableTenantUsingGET_TYPE = function() {
  return 'get'
}
export const enableTenantUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableTenantUsingGET
 * url: disableTenantUsingGETURL
 * method: disableTenantUsingGET_TYPE
 * raw_url: disableTenantUsingGET_RAW_URL
 * @param id - 
 */
export const disableTenantUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableTenantUsingGET_RAW_URL = function() {
  return '/tenant/{id}/disable'
}
export const disableTenantUsingGET_TYPE = function() {
  return 'get'
}
export const disableTenantUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getActiveTenantsUsingGET
 * url: getActiveTenantsUsingGETURL
 * method: getActiveTenantsUsingGET_TYPE
 * raw_url: getActiveTenantsUsingGET_RAW_URL
 */
export const getActiveTenantsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tenant/active'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getActiveTenantsUsingGET_RAW_URL = function() {
  return '/tenant/active'
}
export const getActiveTenantsUsingGET_TYPE = function() {
  return 'get'
}
export const getActiveTenantsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tenant/active'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryTriggerUsingGET
 * url: getTelemetryTriggerUsingGETURL
 * method: getTelemetryTriggerUsingGET_TYPE
 * raw_url: getTelemetryTriggerUsingGET_RAW_URL
 * @param dateFrom - 
 * @param dateTill - 
 * @param size - 
 * @param page - 
 */
export const getTelemetryTriggerUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/trigger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryTriggerUsingGET_RAW_URL = function() {
  return '/telemetry/trigger'
}
export const getTelemetryTriggerUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryTriggerUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/trigger'
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryTriggerYearlyUsingGET
 * url: getTelemetryTriggerYearlyUsingGETURL
 * method: getTelemetryTriggerYearlyUsingGET_TYPE
 * raw_url: getTelemetryTriggerYearlyUsingGET_RAW_URL
 * @param year - 
 * @param size - 
 * @param page - 
 */
export const getTelemetryTriggerYearlyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/trigger/yearly'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters['year'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: year'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryTriggerYearlyUsingGET_RAW_URL = function() {
  return '/telemetry/trigger/yearly'
}
export const getTelemetryTriggerYearlyUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryTriggerYearlyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/trigger/yearly'
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryTriggerYearlyCountUsingGET
 * url: getTelemetryTriggerYearlyCountUsingGETURL
 * method: getTelemetryTriggerYearlyCountUsingGET_TYPE
 * raw_url: getTelemetryTriggerYearlyCountUsingGET_RAW_URL
 * @param year - 
 */
export const getTelemetryTriggerYearlyCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/trigger/yearly/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters['year'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: year'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryTriggerYearlyCountUsingGET_RAW_URL = function() {
  return '/telemetry/trigger/yearly/count'
}
export const getTelemetryTriggerYearlyCountUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryTriggerYearlyCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/trigger/yearly/count'
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryTriggerMonthlyUsingGET
 * url: getTelemetryTriggerMonthlyUsingGETURL
 * method: getTelemetryTriggerMonthlyUsingGET_TYPE
 * raw_url: getTelemetryTriggerMonthlyUsingGET_RAW_URL
 * @param month - 
 * @param size - 
 * @param page - 
 */
export const getTelemetryTriggerMonthlyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/trigger/monthly'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryTriggerMonthlyUsingGET_RAW_URL = function() {
  return '/telemetry/trigger/monthly'
}
export const getTelemetryTriggerMonthlyUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryTriggerMonthlyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/trigger/monthly'
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryTriggerMonthlyCountUsingGET
 * url: getTelemetryTriggerMonthlyCountUsingGETURL
 * method: getTelemetryTriggerMonthlyCountUsingGET_TYPE
 * raw_url: getTelemetryTriggerMonthlyCountUsingGET_RAW_URL
 * @param month - 
 */
export const getTelemetryTriggerMonthlyCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/trigger/monthly/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryTriggerMonthlyCountUsingGET_RAW_URL = function() {
  return '/telemetry/trigger/monthly/count'
}
export const getTelemetryTriggerMonthlyCountUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryTriggerMonthlyCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/trigger/monthly/count'
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryTriggerDailyUsingGET
 * url: getTelemetryTriggerDailyUsingGETURL
 * method: getTelemetryTriggerDailyUsingGET_TYPE
 * raw_url: getTelemetryTriggerDailyUsingGET_RAW_URL
 * @param day - 
 * @param size - 
 * @param page - 
 */
export const getTelemetryTriggerDailyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/trigger/daily'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['day'] !== undefined) {
    queryParameters['day'] = parameters['day']
  }
  if (parameters['day'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: day'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryTriggerDailyUsingGET_RAW_URL = function() {
  return '/telemetry/trigger/daily'
}
export const getTelemetryTriggerDailyUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryTriggerDailyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/trigger/daily'
  if (parameters['day'] !== undefined) {
    queryParameters['day'] = parameters['day']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryTriggerDailyUsingGET_1
 * url: getTelemetryTriggerDailyUsingGET_1URL
 * method: getTelemetryTriggerDailyUsingGET_1_TYPE
 * raw_url: getTelemetryTriggerDailyUsingGET_1_RAW_URL
 * @param day - 
 */
export const getTelemetryTriggerDailyUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/trigger/daily/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['day'] !== undefined) {
    queryParameters['day'] = parameters['day']
  }
  if (parameters['day'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: day'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryTriggerDailyUsingGET_1_RAW_URL = function() {
  return '/telemetry/trigger/daily/count'
}
export const getTelemetryTriggerDailyUsingGET_1_TYPE = function() {
  return 'get'
}
export const getTelemetryTriggerDailyUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/trigger/daily/count'
  if (parameters['day'] !== undefined) {
    queryParameters['day'] = parameters['day']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryTriggerCountUsingGET
 * url: getTelemetryTriggerCountUsingGETURL
 * method: getTelemetryTriggerCountUsingGET_TYPE
 * raw_url: getTelemetryTriggerCountUsingGET_RAW_URL
 * @param dateFrom - 
 * @param dateTill - 
 */
export const getTelemetryTriggerCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/trigger/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryTriggerCountUsingGET_RAW_URL = function() {
  return '/telemetry/trigger/count'
}
export const getTelemetryTriggerCountUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryTriggerCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/trigger/count'
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryProcessUsingGET
 * url: getTelemetryProcessUsingGETURL
 * method: getTelemetryProcessUsingGET_TYPE
 * raw_url: getTelemetryProcessUsingGET_RAW_URL
 * @param dateFrom - 
 * @param dateTill - 
 * @param size - 
 * @param page - 
 */
export const getTelemetryProcessUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/process'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryProcessUsingGET_RAW_URL = function() {
  return '/telemetry/process'
}
export const getTelemetryProcessUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryProcessUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/process'
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryProcessYearlyUsingGET
 * url: getTelemetryProcessYearlyUsingGETURL
 * method: getTelemetryProcessYearlyUsingGET_TYPE
 * raw_url: getTelemetryProcessYearlyUsingGET_RAW_URL
 * @param year - 
 * @param size - 
 * @param page - 
 */
export const getTelemetryProcessYearlyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/process/yearly'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters['year'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: year'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryProcessYearlyUsingGET_RAW_URL = function() {
  return '/telemetry/process/yearly'
}
export const getTelemetryProcessYearlyUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryProcessYearlyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/process/yearly'
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryProcessYearlyCountUsingGET
 * url: getTelemetryProcessYearlyCountUsingGETURL
 * method: getTelemetryProcessYearlyCountUsingGET_TYPE
 * raw_url: getTelemetryProcessYearlyCountUsingGET_RAW_URL
 * @param year - 
 */
export const getTelemetryProcessYearlyCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/process/yearly/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters['year'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: year'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryProcessYearlyCountUsingGET_RAW_URL = function() {
  return '/telemetry/process/yearly/count'
}
export const getTelemetryProcessYearlyCountUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryProcessYearlyCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/process/yearly/count'
  if (parameters['year'] !== undefined) {
    queryParameters['year'] = parameters['year']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryProcessMonthlyUsingGET
 * url: getTelemetryProcessMonthlyUsingGETURL
 * method: getTelemetryProcessMonthlyUsingGET_TYPE
 * raw_url: getTelemetryProcessMonthlyUsingGET_RAW_URL
 * @param month - 
 * @param size - 
 * @param page - 
 */
export const getTelemetryProcessMonthlyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/process/monthly'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryProcessMonthlyUsingGET_RAW_URL = function() {
  return '/telemetry/process/monthly'
}
export const getTelemetryProcessMonthlyUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryProcessMonthlyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/process/monthly'
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryProcessMonthlyCountUsingGET
 * url: getTelemetryProcessMonthlyCountUsingGETURL
 * method: getTelemetryProcessMonthlyCountUsingGET_TYPE
 * raw_url: getTelemetryProcessMonthlyCountUsingGET_RAW_URL
 * @param month - 
 */
export const getTelemetryProcessMonthlyCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/process/monthly/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters['month'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: month'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryProcessMonthlyCountUsingGET_RAW_URL = function() {
  return '/telemetry/process/monthly/count'
}
export const getTelemetryProcessMonthlyCountUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryProcessMonthlyCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/process/monthly/count'
  if (parameters['month'] !== undefined) {
    queryParameters['month'] = parameters['month']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryProcessDailyUsingGET
 * url: getTelemetryProcessDailyUsingGETURL
 * method: getTelemetryProcessDailyUsingGET_TYPE
 * raw_url: getTelemetryProcessDailyUsingGET_RAW_URL
 * @param day - 
 * @param size - 
 * @param page - 
 */
export const getTelemetryProcessDailyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/process/daily'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['day'] !== undefined) {
    queryParameters['day'] = parameters['day']
  }
  if (parameters['day'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: day'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryProcessDailyUsingGET_RAW_URL = function() {
  return '/telemetry/process/daily'
}
export const getTelemetryProcessDailyUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryProcessDailyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/process/daily'
  if (parameters['day'] !== undefined) {
    queryParameters['day'] = parameters['day']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryProcessDailyCountUsingGET
 * url: getTelemetryProcessDailyCountUsingGETURL
 * method: getTelemetryProcessDailyCountUsingGET_TYPE
 * raw_url: getTelemetryProcessDailyCountUsingGET_RAW_URL
 * @param day - 
 */
export const getTelemetryProcessDailyCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/process/daily/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['day'] !== undefined) {
    queryParameters['day'] = parameters['day']
  }
  if (parameters['day'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: day'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryProcessDailyCountUsingGET_RAW_URL = function() {
  return '/telemetry/process/daily/count'
}
export const getTelemetryProcessDailyCountUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryProcessDailyCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/process/daily/count'
  if (parameters['day'] !== undefined) {
    queryParameters['day'] = parameters['day']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTelemetryProcessCountUsingGET
 * url: getTelemetryProcessCountUsingGETURL
 * method: getTelemetryProcessCountUsingGET_TYPE
 * raw_url: getTelemetryProcessCountUsingGET_RAW_URL
 * @param dateFrom - 
 * @param dateTill - 
 */
export const getTelemetryProcessCountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/telemetry/process/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTelemetryProcessCountUsingGET_RAW_URL = function() {
  return '/telemetry/process/count'
}
export const getTelemetryProcessCountUsingGET_TYPE = function() {
  return 'get'
}
export const getTelemetryProcessCountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/telemetry/process/count'
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTagUsagesUsingGET
 * url: getTagUsagesUsingGETURL
 * method: getTagUsagesUsingGET_TYPE
 * raw_url: getTagUsagesUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getTagUsagesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/tag/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTagUsagesUsingGET_RAW_URL = function() {
  return '/tag/{id}/usages'
}
export const getTagUsagesUsingGET_TYPE = function() {
  return 'get'
}
export const getTagUsagesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/tag/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getStaticResourceUsagesByIdUsingGET
 * url: getStaticResourceUsagesByIdUsingGETURL
 * method: getStaticResourceUsagesByIdUsingGET_TYPE
 * raw_url: getStaticResourceUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getStaticResourceUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStaticResourceUsagesByIdUsingGET_RAW_URL = function() {
  return '/static-resource/{id}/usages'
}
export const getStaticResourceUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getStaticResourceUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getStaticResourceTagsUsingGET
 * url: getStaticResourceTagsUsingGETURL
 * method: getStaticResourceTagsUsingGET_TYPE
 * raw_url: getStaticResourceTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getStaticResourceTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStaticResourceTagsUsingGET_RAW_URL = function() {
  return '/static-resource/{id}/tags'
}
export const getStaticResourceTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getStaticResourceTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getPictureContentUsingGET
 * url: getPictureContentUsingGETURL
 * method: getPictureContentUsingGET_TYPE
 * raw_url: getPictureContentUsingGET_RAW_URL
 * @param id - 
 */
export const getPictureContentUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/picture'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPictureContentUsingGET_RAW_URL = function() {
  return '/static-resource/{id}/picture'
}
export const getPictureContentUsingGET_TYPE = function() {
  return 'get'
}
export const getPictureContentUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/picture'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableStaticResourceUsingGET
 * url: enableStaticResourceUsingGETURL
 * method: enableStaticResourceUsingGET_TYPE
 * raw_url: enableStaticResourceUsingGET_RAW_URL
 * @param id - 
 */
export const enableStaticResourceUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableStaticResourceUsingGET_RAW_URL = function() {
  return '/static-resource/{id}/enable'
}
export const enableStaticResourceUsingGET_TYPE = function() {
  return 'get'
}
export const enableStaticResourceUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: downloadStaticResourceFileUsingGET
 * url: downloadStaticResourceFileUsingGETURL
 * method: downloadStaticResourceFileUsingGET_TYPE
 * raw_url: downloadStaticResourceFileUsingGET_RAW_URL
 * @param id - 
 */
export const downloadStaticResourceFileUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/download'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadStaticResourceFileUsingGET_RAW_URL = function() {
  return '/static-resource/{id}/download'
}
export const downloadStaticResourceFileUsingGET_TYPE = function() {
  return 'get'
}
export const downloadStaticResourceFileUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/download'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableStaticResourceUsingGET
 * url: disableStaticResourceUsingGETURL
 * method: disableStaticResourceUsingGET_TYPE
 * raw_url: disableStaticResourceUsingGET_RAW_URL
 * @param id - 
 */
export const disableStaticResourceUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableStaticResourceUsingGET_RAW_URL = function() {
  return '/static-resource/{id}/disable'
}
export const disableStaticResourceUsingGET_TYPE = function() {
  return 'get'
}
export const disableStaticResourceUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getCssContentUsingGET
 * url: getCssContentUsingGETURL
 * method: getCssContentUsingGET_TYPE
 * raw_url: getCssContentUsingGET_RAW_URL
 * @param id - 
 */
export const getCssContentUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/static-resource/{id}/content'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCssContentUsingGET_RAW_URL = function() {
  return '/static-resource/{id}/content'
}
export const getCssContentUsingGET_TYPE = function() {
  return 'get'
}
export const getCssContentUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/static-resource/{id}/content'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getSettingsUsingGET
 * url: getSettingsUsingGETURL
 * method: getSettingsUsingGET_TYPE
 * raw_url: getSettingsUsingGET_RAW_URL
 * @param type - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getSettingsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSettingsUsingGET_RAW_URL = function() {
  return '/setting'
}
export const getSettingsUsingGET_TYPE = function() {
  return 'get'
}
export const getSettingsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting'
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getSettingByIdUsingGET
 * url: getSettingByIdUsingGETURL
 * method: getSettingByIdUsingGET_TYPE
 * raw_url: getSettingByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getSettingByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSettingByIdUsingGET_RAW_URL = function() {
  return '/setting/{id}'
}
export const getSettingByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getSettingByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteSettingUsingDELETE
 * url: deleteSettingUsingDELETEURL
 * method: deleteSettingUsingDELETE_TYPE
 * raw_url: deleteSettingUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteSettingUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSettingUsingDELETE_RAW_URL = function() {
  return '/setting/{id}'
}
export const deleteSettingUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteSettingUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getSettingUsagesByIdUsingGET
 * url: getSettingUsagesByIdUsingGETURL
 * method: getSettingUsagesByIdUsingGET_TYPE
 * raw_url: getSettingUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getSettingUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSettingUsagesByIdUsingGET_RAW_URL = function() {
  return '/setting/{id}/usages'
}
export const getSettingUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getSettingUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getSettingTagsUsingGET
 * url: getSettingTagsUsingGETURL
 * method: getSettingTagsUsingGET_TYPE
 * raw_url: getSettingTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getSettingTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSettingTagsUsingGET_RAW_URL = function() {
  return '/setting/{id}/tags'
}
export const getSettingTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getSettingTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableSettingUsingGET
 * url: enableSettingUsingGETURL
 * method: enableSettingUsingGET_TYPE
 * raw_url: enableSettingUsingGET_RAW_URL
 * @param id - 
 */
export const enableSettingUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableSettingUsingGET_RAW_URL = function() {
  return '/setting/{id}/enable'
}
export const enableSettingUsingGET_TYPE = function() {
  return 'get'
}
export const enableSettingUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableSettingUsingGET
 * url: disableSettingUsingGETURL
 * method: disableSettingUsingGET_TYPE
 * raw_url: disableSettingUsingGET_RAW_URL
 * @param id - 
 */
export const disableSettingUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/setting/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableSettingUsingGET_RAW_URL = function() {
  return '/setting/{id}/disable'
}
export const disableSettingUsingGET_TYPE = function() {
  return 'get'
}
export const disableSettingUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/setting/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getScreenUsagesByIdUsingGET
 * url: getScreenUsagesByIdUsingGETURL
 * method: getScreenUsagesByIdUsingGET_TYPE
 * raw_url: getScreenUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getScreenUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getScreenUsagesByIdUsingGET_RAW_URL = function() {
  return '/screen/{id}/usages'
}
export const getScreenUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getScreenUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getScreenTagsUsingGET
 * url: getScreenTagsUsingGETURL
 * method: getScreenTagsUsingGET_TYPE
 * raw_url: getScreenTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getScreenTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getScreenTagsUsingGET_RAW_URL = function() {
  return '/screen/{id}/tags'
}
export const getScreenTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getScreenTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableScreenUsingGET
 * url: enableScreenUsingGETURL
 * method: enableScreenUsingGET_TYPE
 * raw_url: enableScreenUsingGET_RAW_URL
 * @param id - 
 */
export const enableScreenUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableScreenUsingGET_RAW_URL = function() {
  return '/screen/{id}/enable'
}
export const enableScreenUsingGET_TYPE = function() {
  return 'get'
}
export const enableScreenUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEditorContextUsingGET
 * url: getEditorContextUsingGETURL
 * method: getEditorContextUsingGET_TYPE
 * raw_url: getEditorContextUsingGET_RAW_URL
 * @param id - 
 */
export const getEditorContextUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}/editor-context'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEditorContextUsingGET_RAW_URL = function() {
  return '/screen/{id}/editor-context'
}
export const getEditorContextUsingGET_TYPE = function() {
  return 'get'
}
export const getEditorContextUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}/editor-context'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableScreenUsingGET
 * url: disableScreenUsingGETURL
 * method: disableScreenUsingGET_TYPE
 * raw_url: disableScreenUsingGET_RAW_URL
 * @param id - 
 */
export const disableScreenUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/screen/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableScreenUsingGET_RAW_URL = function() {
  return '/screen/{id}/disable'
}
export const disableScreenUsingGET_TYPE = function() {
  return 'get'
}
export const disableScreenUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/screen/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getRoleUsagesUsingGET
 * url: getRoleUsagesUsingGETURL
 * method: getRoleUsagesUsingGET_TYPE
 * raw_url: getRoleUsagesUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getRoleUsagesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/role/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoleUsagesUsingGET_RAW_URL = function() {
  return '/role/{id}/usages'
}
export const getRoleUsagesUsingGET_TYPE = function() {
  return 'get'
}
export const getRoleUsagesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/role/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessUsagesByIdUsingGET
 * url: getProcessUsagesByIdUsingGETURL
 * method: getProcessUsagesByIdUsingGET_TYPE
 * raw_url: getProcessUsagesByIdUsingGET_RAW_URL
 * @param request - 
 * @param id - 
 */
export const getProcessUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessUsagesByIdUsingGET_RAW_URL = function() {
  return '/process/{id}/usages'
}
export const getProcessUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}/usages'
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTriggersByProcessIdUsingGET
 * url: getTriggersByProcessIdUsingGETURL
 * method: getTriggersByProcessIdUsingGET_TYPE
 * raw_url: getTriggersByProcessIdUsingGET_RAW_URL
 * @param status - 
 * @param size - 
 * @param page - 
 * @param id - 
 */
export const getTriggersByProcessIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}/trigger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTriggersByProcessIdUsingGET_RAW_URL = function() {
  return '/process/{id}/trigger'
}
export const getTriggersByProcessIdUsingGET_TYPE = function() {
  return 'get'
}
export const getTriggersByProcessIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}/trigger'
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessTagsUsingGET
 * url: getProcessTagsUsingGETURL
 * method: getProcessTagsUsingGET_TYPE
 * raw_url: getProcessTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getProcessTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessTagsUsingGET_RAW_URL = function() {
  return '/process/{id}/tags'
}
export const getProcessTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessStatisticsUsingGET
 * url: getProcessStatisticsUsingGETURL
 * method: getProcessStatisticsUsingGET_TYPE
 * raw_url: getProcessStatisticsUsingGET_RAW_URL
 * @param id - 
 */
export const getProcessStatisticsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}/statistics'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessStatisticsUsingGET_RAW_URL = function() {
  return '/process/{id}/statistics'
}
export const getProcessStatisticsUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessStatisticsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}/statistics'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableProcessUsingGET
 * url: enableProcessUsingGETURL
 * method: enableProcessUsingGET_TYPE
 * raw_url: enableProcessUsingGET_RAW_URL
 * @param id - 
 */
export const enableProcessUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableProcessUsingGET_RAW_URL = function() {
  return '/process/{id}/enable'
}
export const enableProcessUsingGET_TYPE = function() {
  return 'get'
}
export const enableProcessUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableProcessUsingGET
 * url: disableProcessUsingGETURL
 * method: disableProcessUsingGET_TYPE
 * raw_url: disableProcessUsingGET_RAW_URL
 * @param id - 
 */
export const disableProcessUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableProcessUsingGET_RAW_URL = function() {
  return '/process/{id}/disable'
}
export const disableProcessUsingGET_TYPE = function() {
  return 'get'
}
export const disableProcessUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessStepLogsUsingGET
 * url: getProcessStepLogsUsingGETURL
 * method: getProcessStepLogsUsingGET_TYPE
 * raw_url: getProcessStepLogsUsingGET_RAW_URL
 * @param processId - 
 * @param eventId - 
 * @param stepType - 
 * @param stepId - 
 * @param status - 
 * @param dateFrom - 
 * @param dateTill - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getProcessStepLogsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-step-log'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['eventId'] !== undefined) {
    queryParameters['eventId'] = parameters['eventId']
  }
  if (parameters['stepType'] !== undefined) {
    queryParameters['stepType'] = parameters['stepType']
  }
  if (parameters['stepId'] !== undefined) {
    queryParameters['stepId'] = parameters['stepId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessStepLogsUsingGET_RAW_URL = function() {
  return '/process-step-log'
}
export const getProcessStepLogsUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessStepLogsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-step-log'
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['eventId'] !== undefined) {
    queryParameters['eventId'] = parameters['eventId']
  }
  if (parameters['stepType'] !== undefined) {
    queryParameters['stepType'] = parameters['stepType']
  }
  if (parameters['stepId'] !== undefined) {
    queryParameters['stepId'] = parameters['stepId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessExceptionUsingGET
 * url: getProcessExceptionUsingGETURL
 * method: getProcessExceptionUsingGET_TYPE
 * raw_url: getProcessExceptionUsingGET_RAW_URL
 * @param id - 
 */
export const getProcessExceptionUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-step-log/{id}/exception'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessExceptionUsingGET_RAW_URL = function() {
  return '/process-step-log/{id}/exception'
}
export const getProcessExceptionUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessExceptionUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-step-log/{id}/exception'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessStepLogDebugLogUsingGET
 * url: getProcessStepLogDebugLogUsingGETURL
 * method: getProcessStepLogDebugLogUsingGET_TYPE
 * raw_url: getProcessStepLogDebugLogUsingGET_RAW_URL
 * @param id - 
 */
export const getProcessStepLogDebugLogUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-step-log/{id}/debug-log'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessStepLogDebugLogUsingGET_RAW_URL = function() {
  return '/process-step-log/{id}/debug-log'
}
export const getProcessStepLogDebugLogUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessStepLogDebugLogUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-step-log/{id}/debug-log'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessStepLogCacheUsingGET
 * url: getProcessStepLogCacheUsingGETURL
 * method: getProcessStepLogCacheUsingGET_TYPE
 * raw_url: getProcessStepLogCacheUsingGET_RAW_URL
 * @param id - 
 */
export const getProcessStepLogCacheUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-step-log/{id}/cache'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessStepLogCacheUsingGET_RAW_URL = function() {
  return '/process-step-log/{id}/cache'
}
export const getProcessStepLogCacheUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessStepLogCacheUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-step-log/{id}/cache'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessStepFailuresUsingGET
 * url: getProcessStepFailuresUsingGETURL
 * method: getProcessStepFailuresUsingGET_TYPE
 * raw_url: getProcessStepFailuresUsingGET_RAW_URL
 * @param dateFrom - 
 * @param dateTill - 
 * @param size - 
 * @param page - 
 */
export const getProcessStepFailuresUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-step-log/failures'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateFrom'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dateFrom'))
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['dateTill'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dateTill'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessStepFailuresUsingGET_RAW_URL = function() {
  return '/process-step-log/failures'
}
export const getProcessStepFailuresUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessStepFailuresUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-step-log/failures'
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessCredentialsUsingGET
 * url: getProcessCredentialsUsingGETURL
 * method: getProcessCredentialsUsingGET_TYPE
 * raw_url: getProcessCredentialsUsingGET_RAW_URL
 * @param type - 
 * @param isSystem - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getProcessCredentialsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessCredentialsUsingGET_RAW_URL = function() {
  return '/process-credential'
}
export const getProcessCredentialsUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessCredentialsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential'
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['isSystem'] !== undefined) {
    queryParameters['isSystem'] = parameters['isSystem']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessCredentialByIdUsingGET
 * url: getProcessCredentialByIdUsingGETURL
 * method: getProcessCredentialByIdUsingGET_TYPE
 * raw_url: getProcessCredentialByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getProcessCredentialByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessCredentialByIdUsingGET_RAW_URL = function() {
  return '/process-credential/{id}'
}
export const getProcessCredentialByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessCredentialByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteProcessCredentialUsingDELETE
 * url: deleteProcessCredentialUsingDELETEURL
 * method: deleteProcessCredentialUsingDELETE_TYPE
 * raw_url: deleteProcessCredentialUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteProcessCredentialUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteProcessCredentialUsingDELETE_RAW_URL = function() {
  return '/process-credential/{id}'
}
export const deleteProcessCredentialUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteProcessCredentialUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessCredentialUsagesByIdUsingGET
 * url: getProcessCredentialUsagesByIdUsingGETURL
 * method: getProcessCredentialUsagesByIdUsingGET_TYPE
 * raw_url: getProcessCredentialUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getProcessCredentialUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessCredentialUsagesByIdUsingGET_RAW_URL = function() {
  return '/process-credential/{id}/usages'
}
export const getProcessCredentialUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessCredentialUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessCredentialTagsUsingGET
 * url: getProcessCredentialTagsUsingGETURL
 * method: getProcessCredentialTagsUsingGET_TYPE
 * raw_url: getProcessCredentialTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getProcessCredentialTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessCredentialTagsUsingGET_RAW_URL = function() {
  return '/process-credential/{id}/tags'
}
export const getProcessCredentialTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessCredentialTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableProcessCredentialUsingGET
 * url: enableProcessCredentialUsingGETURL
 * method: enableProcessCredentialUsingGET_TYPE
 * raw_url: enableProcessCredentialUsingGET_RAW_URL
 * @param id - 
 */
export const enableProcessCredentialUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableProcessCredentialUsingGET_RAW_URL = function() {
  return '/process-credential/{id}/enable'
}
export const enableProcessCredentialUsingGET_TYPE = function() {
  return 'get'
}
export const enableProcessCredentialUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableProcessCredentialUsingGET
 * url: disableProcessCredentialUsingGETURL
 * method: disableProcessCredentialUsingGET_TYPE
 * raw_url: disableProcessCredentialUsingGET_RAW_URL
 * @param id - 
 */
export const disableProcessCredentialUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableProcessCredentialUsingGET_RAW_URL = function() {
  return '/process-credential/{id}/disable'
}
export const disableProcessCredentialUsingGET_TYPE = function() {
  return 'get'
}
export const disableProcessCredentialUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTablesUsingGET
 * url: getTablesUsingGETURL
 * method: getTablesUsingGET_TYPE
 * raw_url: getTablesUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getTablesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jdbc/{id}/browse/tables'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTablesUsingGET_RAW_URL = function() {
  return '/process-credential/jdbc/{id}/browse/tables'
}
export const getTablesUsingGET_TYPE = function() {
  return 'get'
}
export const getTablesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jdbc/{id}/browse/tables'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getSequencesUsingGET
 * url: getSequencesUsingGETURL
 * method: getSequencesUsingGET_TYPE
 * raw_url: getSequencesUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getSequencesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jdbc/{id}/browse/sequences'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSequencesUsingGET_RAW_URL = function() {
  return '/process-credential/jdbc/{id}/browse/sequences'
}
export const getSequencesUsingGET_TYPE = function() {
  return 'get'
}
export const getSequencesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jdbc/{id}/browse/sequences'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getIndexesUsingGET
 * url: getIndexesUsingGETURL
 * method: getIndexesUsingGET_TYPE
 * raw_url: getIndexesUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getIndexesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jdbc/{id}/browse/indexes'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getIndexesUsingGET_RAW_URL = function() {
  return '/process-credential/jdbc/{id}/browse/indexes'
}
export const getIndexesUsingGET_TYPE = function() {
  return 'get'
}
export const getIndexesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jdbc/{id}/browse/indexes'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getDataUsingGET
 * url: getDataUsingGETURL
 * method: getDataUsingGET_TYPE
 * raw_url: getDataUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getDataUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jdbc/{id}/browse/data'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDataUsingGET_RAW_URL = function() {
  return '/process-credential/jdbc/{id}/browse/data'
}
export const getDataUsingGET_TYPE = function() {
  return 'get'
}
export const getDataUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jdbc/{id}/browse/data'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getColumnsUsingGET
 * url: getColumnsUsingGETURL
 * method: getColumnsUsingGET_TYPE
 * raw_url: getColumnsUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getColumnsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/jdbc/{id}/browse/columns'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getColumnsUsingGET_RAW_URL = function() {
  return '/process-credential/jdbc/{id}/browse/columns'
}
export const getColumnsUsingGET_TYPE = function() {
  return 'get'
}
export const getColumnsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/jdbc/{id}/browse/columns'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getPluginUsagesByIdUsingGET
 * url: getPluginUsagesByIdUsingGETURL
 * method: getPluginUsagesByIdUsingGET_TYPE
 * raw_url: getPluginUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getPluginUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPluginUsagesByIdUsingGET_RAW_URL = function() {
  return '/plugin/{id}/usages'
}
export const getPluginUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getPluginUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getPluginTagsUsingGET
 * url: getPluginTagsUsingGETURL
 * method: getPluginTagsUsingGET_TYPE
 * raw_url: getPluginTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getPluginTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPluginTagsUsingGET_RAW_URL = function() {
  return '/plugin/{id}/tags'
}
export const getPluginTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getPluginTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: downloadPluginJarUsingGET
 * url: downloadPluginJarUsingGETURL
 * method: downloadPluginJarUsingGET_TYPE
 * raw_url: downloadPluginJarUsingGET_RAW_URL
 * @param id - 
 */
export const downloadPluginJarUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}/jar'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadPluginJarUsingGET_RAW_URL = function() {
  return '/plugin/{id}/jar'
}
export const downloadPluginJarUsingGET_TYPE = function() {
  return 'get'
}
export const downloadPluginJarUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}/jar'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enablePluginUsingGET
 * url: enablePluginUsingGETURL
 * method: enablePluginUsingGET_TYPE
 * raw_url: enablePluginUsingGET_RAW_URL
 * @param id - 
 */
export const enablePluginUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enablePluginUsingGET_RAW_URL = function() {
  return '/plugin/{id}/enable'
}
export const enablePluginUsingGET_TYPE = function() {
  return 'get'
}
export const enablePluginUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disablePluginUsingGET
 * url: disablePluginUsingGETURL
 * method: disablePluginUsingGET_TYPE
 * raw_url: disablePluginUsingGET_RAW_URL
 * @param id - 
 */
export const disablePluginUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/plugin/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disablePluginUsingGET_RAW_URL = function() {
  return '/plugin/{id}/disable'
}
export const disablePluginUsingGET_TYPE = function() {
  return 'get'
}
export const disablePluginUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/plugin/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: initiateLoginUsingGET
 * url: initiateLoginUsingGETURL
 * method: initiateLoginUsingGET_TYPE
 * raw_url: initiateLoginUsingGET_RAW_URL
 * @param state - 
 */
export const initiateLoginUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/oauth2/authorization/azure'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['state'] !== undefined) {
    queryParameters['state'] = parameters['state']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const initiateLoginUsingGET_RAW_URL = function() {
  return '/oauth2/authorization/azure'
}
export const initiateLoginUsingGET_TYPE = function() {
  return 'get'
}
export const initiateLoginUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/oauth2/authorization/azure'
  if (parameters['state'] !== undefined) {
    queryParameters['state'] = parameters['state']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getModuleTagsUsingGET
 * url: getModuleTagsUsingGETURL
 * method: getModuleTagsUsingGET_TYPE
 * raw_url: getModuleTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getModuleTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleTagsUsingGET_RAW_URL = function() {
  return '/module/{id}/tags'
}
export const getModuleTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: swaggerUsingGET
 * url: swaggerUsingGETURL
 * method: swaggerUsingGET_TYPE
 * raw_url: swaggerUsingGET_RAW_URL
 * @param id - 
 */
export const swaggerUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/{id}/swagger'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const swaggerUsingGET_RAW_URL = function() {
  return '/module/{id}/swagger'
}
export const swaggerUsingGET_TYPE = function() {
  return 'get'
}
export const swaggerUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/{id}/swagger'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: exportUsingGET
 * url: exportUsingGETURL
 * method: exportUsingGET_TYPE
 * raw_url: exportUsingGET_RAW_URL
 * @param id - 
 */
export const exportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/{id}/export'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const exportUsingGET_RAW_URL = function() {
  return '/module/{id}/export'
}
export const exportUsingGET_TYPE = function() {
  return 'get'
}
export const exportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/{id}/export'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getModuleImportByIdUsingGET
 * url: getModuleImportByIdUsingGETURL
 * method: getModuleImportByIdUsingGET_TYPE
 * raw_url: getModuleImportByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getModuleImportByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/import/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleImportByIdUsingGET_RAW_URL = function() {
  return '/module/import/{id}'
}
export const getModuleImportByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleImportByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/import/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getModuleDeletionByIdUsingGET
 * url: getModuleDeletionByIdUsingGETURL
 * method: getModuleDeletionByIdUsingGET_TYPE
 * raw_url: getModuleDeletionByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getModuleDeletionByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/module/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getModuleDeletionByIdUsingGET_RAW_URL = function() {
  return '/module/delete/{id}'
}
export const getModuleDeletionByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getModuleDeletionByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/module/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: logoutUsingGET
 * url: logoutUsingGETURL
 * method: logoutUsingGET_TYPE
 * raw_url: logoutUsingGET_RAW_URL
 */
export const logoutUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/logout'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const logoutUsingGET_RAW_URL = function() {
  return '/logout'
}
export const logoutUsingGET_TYPE = function() {
  return 'get'
}
export const logoutUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/logout'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getLibraryUsagesByIdUsingGET
 * url: getLibraryUsagesByIdUsingGETURL
 * method: getLibraryUsagesByIdUsingGET_TYPE
 * raw_url: getLibraryUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getLibraryUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getLibraryUsagesByIdUsingGET_RAW_URL = function() {
  return '/library/{id}/usages'
}
export const getLibraryUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getLibraryUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getLibraryTagsUsingGET
 * url: getLibraryTagsUsingGETURL
 * method: getLibraryTagsUsingGET_TYPE
 * raw_url: getLibraryTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getLibraryTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getLibraryTagsUsingGET_RAW_URL = function() {
  return '/library/{id}/tags'
}
export const getLibraryTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getLibraryTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableLibraryUsingGET
 * url: enableLibraryUsingGETURL
 * method: enableLibraryUsingGET_TYPE
 * raw_url: enableLibraryUsingGET_RAW_URL
 * @param id - 
 */
export const enableLibraryUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableLibraryUsingGET_RAW_URL = function() {
  return '/library/{id}/enable'
}
export const enableLibraryUsingGET_TYPE = function() {
  return 'get'
}
export const enableLibraryUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: downloadLibraryUsingGET
 * url: downloadLibraryUsingGETURL
 * method: downloadLibraryUsingGET_TYPE
 * raw_url: downloadLibraryUsingGET_RAW_URL
 * @param id - 
 */
export const downloadLibraryUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}/download'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadLibraryUsingGET_RAW_URL = function() {
  return '/library/{id}/download'
}
export const downloadLibraryUsingGET_TYPE = function() {
  return 'get'
}
export const downloadLibraryUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}/download'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableLibraryUsingGET
 * url: disableLibraryUsingGETURL
 * method: disableLibraryUsingGET_TYPE
 * raw_url: disableLibraryUsingGET_RAW_URL
 * @param id - 
 */
export const disableLibraryUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/library/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableLibraryUsingGET_RAW_URL = function() {
  return '/library/{id}/disable'
}
export const disableLibraryUsingGET_TYPE = function() {
  return 'get'
}
export const disableLibraryUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/library/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getInternalJobsUsingGET
 * url: getInternalJobsUsingGETURL
 * method: getInternalJobsUsingGET_TYPE
 * raw_url: getInternalJobsUsingGET_RAW_URL
 * @param instanceId - 
 * @param type - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getInternalJobsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/internal-job'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['instanceId'] !== undefined) {
    queryParameters['instanceId'] = parameters['instanceId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInternalJobsUsingGET_RAW_URL = function() {
  return '/internal-job'
}
export const getInternalJobsUsingGET_TYPE = function() {
  return 'get'
}
export const getInternalJobsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/internal-job'
  if (parameters['instanceId'] !== undefined) {
    queryParameters['instanceId'] = parameters['instanceId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getInternalJobByIdUsingGET
 * url: getInternalJobByIdUsingGETURL
 * method: getInternalJobByIdUsingGET_TYPE
 * raw_url: getInternalJobByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getInternalJobByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/internal-job/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInternalJobByIdUsingGET_RAW_URL = function() {
  return '/internal-job/{id}'
}
export const getInternalJobByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getInternalJobByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/internal-job/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getInstancesUsingGET
 * url: getInstancesUsingGETURL
 * method: getInstancesUsingGET_TYPE
 * raw_url: getInstancesUsingGET_RAW_URL
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getInstancesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/instance'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInstancesUsingGET_RAW_URL = function() {
  return '/instance'
}
export const getInstancesUsingGET_TYPE = function() {
  return 'get'
}
export const getInstancesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/instance'
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getInstanceByIdUsingGET
 * url: getInstanceByIdUsingGETURL
 * method: getInstanceByIdUsingGET_TYPE
 * raw_url: getInstanceByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getInstanceByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/instance/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInstanceByIdUsingGET_RAW_URL = function() {
  return '/instance/{id}'
}
export const getInstanceByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getInstanceByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/instance/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getInstancesUsingGET_1
 * url: getInstancesUsingGET_1URL
 * method: getInstancesUsingGET_1_TYPE
 * raw_url: getInstancesUsingGET_1_RAW_URL
 */
export const getInstancesUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/instance/lite'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInstancesUsingGET_1_RAW_URL = function() {
  return '/instance/lite'
}
export const getInstancesUsingGET_1_TYPE = function() {
  return 'get'
}
export const getInstancesUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/instance/lite'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getStatisticUsingGET
 * url: getStatisticUsingGETURL
 * method: getStatisticUsingGET_TYPE
 * raw_url: getStatisticUsingGET_RAW_URL
 * @param request - 
 */
export const getStatisticUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/instance-statistic'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStatisticUsingGET_RAW_URL = function() {
  return '/instance-statistic'
}
export const getStatisticUsingGET_TYPE = function() {
  return 'get'
}
export const getStatisticUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/instance-statistic'
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: remoteModuleSearchUsingGET
 * url: remoteModuleSearchUsingGETURL
 * method: remoteModuleSearchUsingGET_TYPE
 * raw_url: remoteModuleSearchUsingGET_RAW_URL
 * @param credentialId - 
 * @param name - 
 * @param size - 
 * @param page - 
 */
export const remoteModuleSearchUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/remote/module'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['credentialId'] !== undefined) {
    queryParameters['credentialId'] = parameters['credentialId']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const remoteModuleSearchUsingGET_RAW_URL = function() {
  return '/hub/remote/module'
}
export const remoteModuleSearchUsingGET_TYPE = function() {
  return 'get'
}
export const remoteModuleSearchUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/remote/module'
  if (parameters['credentialId'] !== undefined) {
    queryParameters['credentialId'] = parameters['credentialId']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: remoteModuleValidateUsingGET
 * url: remoteModuleValidateUsingGETURL
 * method: remoteModuleValidateUsingGET_TYPE
 * raw_url: remoteModuleValidateUsingGET_RAW_URL
 * @param id - 
 */
export const remoteModuleValidateUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/remote/module/{id}/validate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const remoteModuleValidateUsingGET_RAW_URL = function() {
  return '/hub/remote/module/{id}/validate'
}
export const remoteModuleValidateUsingGET_TYPE = function() {
  return 'get'
}
export const remoteModuleValidateUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/remote/module/{id}/validate'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: remoteModuleUploadUsingGET
 * url: remoteModuleUploadUsingGETURL
 * method: remoteModuleUploadUsingGET_TYPE
 * raw_url: remoteModuleUploadUsingGET_RAW_URL
 * @param id - 
 */
export const remoteModuleUploadUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/remote/module/{id}/upload'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const remoteModuleUploadUsingGET_RAW_URL = function() {
  return '/hub/remote/module/{id}/upload'
}
export const remoteModuleUploadUsingGET_TYPE = function() {
  return 'get'
}
export const remoteModuleUploadUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/remote/module/{id}/upload'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: remoteModuleDownloadUsingGET
 * url: remoteModuleDownloadUsingGETURL
 * method: remoteModuleDownloadUsingGET_TYPE
 * raw_url: remoteModuleDownloadUsingGET_RAW_URL
 * @param id - 
 */
export const remoteModuleDownloadUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/remote/module/{id}/download'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const remoteModuleDownloadUsingGET_RAW_URL = function() {
  return '/hub/remote/module/{id}/download'
}
export const remoteModuleDownloadUsingGET_TYPE = function() {
  return 'get'
}
export const remoteModuleDownloadUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/remote/module/{id}/download'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: remoteModuleApplyUsingGET
 * url: remoteModuleApplyUsingGETURL
 * method: remoteModuleApplyUsingGET_TYPE
 * raw_url: remoteModuleApplyUsingGET_RAW_URL
 * @param id - 
 */
export const remoteModuleApplyUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/remote/module/{id}/apply'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const remoteModuleApplyUsingGET_RAW_URL = function() {
  return '/hub/remote/module/{id}/apply'
}
export const remoteModuleApplyUsingGET_TYPE = function() {
  return 'get'
}
export const remoteModuleApplyUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/remote/module/{id}/apply'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: moduleSearchUsingGET
 * url: moduleSearchUsingGETURL
 * method: moduleSearchUsingGET_TYPE
 * raw_url: moduleSearchUsingGET_RAW_URL
 * @param name - 
 * @param size - 
 * @param page - 
 */
export const moduleSearchUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/module'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const moduleSearchUsingGET_RAW_URL = function() {
  return '/hub/module'
}
export const moduleSearchUsingGET_TYPE = function() {
  return 'get'
}
export const moduleSearchUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/module'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: uploadDownloadUsingGET
 * url: uploadDownloadUsingGETURL
 * method: uploadDownloadUsingGET_TYPE
 * raw_url: uploadDownloadUsingGET_RAW_URL
 * @param name - 
 */
export const uploadDownloadUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/module/download'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['name'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: name'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const uploadDownloadUsingGET_RAW_URL = function() {
  return '/hub/module/download'
}
export const uploadDownloadUsingGET_TYPE = function() {
  return 'get'
}
export const uploadDownloadUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/module/download'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getHistoriesUsingGET
 * url: getHistoriesUsingGETURL
 * method: getHistoriesUsingGET_TYPE
 * raw_url: getHistoriesUsingGET_RAW_URL
 * @param resourceId - 
 * @param resourceType - 
 * @param size - 
 * @param page - 
 */
export const getHistoriesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['resourceId'] !== undefined) {
    queryParameters['resourceId'] = parameters['resourceId']
  }
  if (parameters['resourceType'] !== undefined) {
    queryParameters['resourceType'] = parameters['resourceType']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHistoriesUsingGET_RAW_URL = function() {
  return '/history'
}
export const getHistoriesUsingGET_TYPE = function() {
  return 'get'
}
export const getHistoriesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history'
  if (parameters['resourceId'] !== undefined) {
    queryParameters['resourceId'] = parameters['resourceId']
  }
  if (parameters['resourceType'] !== undefined) {
    queryParameters['resourceType'] = parameters['resourceType']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getHistoryByIdUsingGET
 * url: getHistoryByIdUsingGETURL
 * method: getHistoryByIdUsingGET_TYPE
 * raw_url: getHistoryByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getHistoryByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHistoryByIdUsingGET_RAW_URL = function() {
  return '/history/{id}'
}
export const getHistoryByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getHistoryByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: downloadHistoryFileByIdUsingGET
 * url: downloadHistoryFileByIdUsingGETURL
 * method: downloadHistoryFileByIdUsingGET_TYPE
 * raw_url: downloadHistoryFileByIdUsingGET_RAW_URL
 * @param id - 
 */
export const downloadHistoryFileByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/download'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadHistoryFileByIdUsingGET_RAW_URL = function() {
  return '/history/{id}/download'
}
export const downloadHistoryFileByIdUsingGET_TYPE = function() {
  return 'get'
}
export const downloadHistoryFileByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/download'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getDeleteHistoriesUsingGET
 * url: getDeleteHistoriesUsingGETURL
 * method: getDeleteHistoriesUsingGET_TYPE
 * raw_url: getDeleteHistoriesUsingGET_RAW_URL
 * @param resourceName - 
 * @param resourceType - 
 * @param dateFrom - 
 * @param dateTill - 
 * @param size - 
 * @param page - 
 */
export const getDeleteHistoriesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/deletion'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['resourceName'] !== undefined) {
    queryParameters['resourceName'] = parameters['resourceName']
  }
  if (parameters['resourceType'] !== undefined) {
    queryParameters['resourceType'] = parameters['resourceType']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDeleteHistoriesUsingGET_RAW_URL = function() {
  return '/history/deletion'
}
export const getDeleteHistoriesUsingGET_TYPE = function() {
  return 'get'
}
export const getDeleteHistoriesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/deletion'
  if (parameters['resourceName'] !== undefined) {
    queryParameters['resourceName'] = parameters['resourceName']
  }
  if (parameters['resourceType'] !== undefined) {
    queryParameters['resourceType'] = parameters['resourceType']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getInfoUsingGET
 * url: getInfoUsingGETURL
 * method: getInfoUsingGET_TYPE
 * raw_url: getInfoUsingGET_RAW_URL
 */
export const getInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/harbor/info'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getInfoUsingGET_RAW_URL = function() {
  return '/harbor/info'
}
export const getInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/harbor/info'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getGlobalSettingsUsingGET
 * url: getGlobalSettingsUsingGETURL
 * method: getGlobalSettingsUsingGET_TYPE
 * raw_url: getGlobalSettingsUsingGET_RAW_URL
 * @param type - 
 */
export const getGlobalSettingsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/global-setting'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getGlobalSettingsUsingGET_RAW_URL = function() {
  return '/global-setting'
}
export const getGlobalSettingsUsingGET_TYPE = function() {
  return 'get'
}
export const getGlobalSettingsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/global-setting'
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getGlobalSettingByIdUsingGET
 * url: getGlobalSettingByIdUsingGETURL
 * method: getGlobalSettingByIdUsingGET_TYPE
 * raw_url: getGlobalSettingByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getGlobalSettingByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/global-setting/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getGlobalSettingByIdUsingGET_RAW_URL = function() {
  return '/global-setting/{id}'
}
export const getGlobalSettingByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getGlobalSettingByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/global-setting/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getGlobalSettingBasicUsingGET
 * url: getGlobalSettingBasicUsingGETURL
 * method: getGlobalSettingBasicUsingGET_TYPE
 * raw_url: getGlobalSettingBasicUsingGET_RAW_URL
 */
export const getGlobalSettingBasicUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/global-setting/basic'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getGlobalSettingBasicUsingGET_RAW_URL = function() {
  return '/global-setting/basic'
}
export const getGlobalSettingBasicUsingGET_TYPE = function() {
  return 'get'
}
export const getGlobalSettingBasicUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/global-setting/basic'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: triggerWhatsappsGdprReportUsingGET
 * url: triggerWhatsappsGdprReportUsingGETURL
 * method: triggerWhatsappsGdprReportUsingGET_TYPE
 * raw_url: triggerWhatsappsGdprReportUsingGET_RAW_URL
 */
export const triggerWhatsappsGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/triggerWhatsapps'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const triggerWhatsappsGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/triggerWhatsapps'
}
export const triggerWhatsappsGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const triggerWhatsappsGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/triggerWhatsapps'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: triggerUisGdprReportUsingGET
 * url: triggerUisGdprReportUsingGETURL
 * method: triggerUisGdprReportUsingGET_TYPE
 * raw_url: triggerUisGdprReportUsingGET_RAW_URL
 */
export const triggerUisGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/triggerUis'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const triggerUisGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/triggerUis'
}
export const triggerUisGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const triggerUisGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/triggerUis'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: screensGdprReportUsingGET
 * url: screensGdprReportUsingGETURL
 * method: screensGdprReportUsingGET_TYPE
 * raw_url: screensGdprReportUsingGET_RAW_URL
 */
export const screensGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/screens'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const screensGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/screens'
}
export const screensGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const screensGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/screens'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: restTriggersGdprReportUsingGET
 * url: restTriggersGdprReportUsingGETURL
 * method: restTriggersGdprReportUsingGET_TYPE
 * raw_url: restTriggersGdprReportUsingGET_RAW_URL
 */
export const restTriggersGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/rest-trigger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const restTriggersGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/rest-trigger'
}
export const restTriggersGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const restTriggersGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/rest-trigger'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: processesGdprReportUsingGET
 * url: processesGdprReportUsingGETURL
 * method: processesGdprReportUsingGET_TYPE
 * raw_url: processesGdprReportUsingGET_RAW_URL
 */
export const processesGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/processes'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const processesGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/processes'
}
export const processesGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const processesGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/processes'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: processCredentialsGdprReportUsingGET
 * url: processCredentialsGdprReportUsingGETURL
 * method: processCredentialsGdprReportUsingGET_TYPE
 * raw_url: processCredentialsGdprReportUsingGET_RAW_URL
 */
export const processCredentialsGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/process-credentials'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const processCredentialsGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/process-credentials'
}
export const processCredentialsGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const processCredentialsGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/process-credentials'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: modulesGdprReportUsingGET
 * url: modulesGdprReportUsingGETURL
 * method: modulesGdprReportUsingGET_TYPE
 * raw_url: modulesGdprReportUsingGET_RAW_URL
 */
export const modulesGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/modules'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const modulesGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/modules'
}
export const modulesGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const modulesGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/modules'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: messagingTriggersGdprReportUsingGET
 * url: messagingTriggersGdprReportUsingGETURL
 * method: messagingTriggersGdprReportUsingGET_TYPE
 * raw_url: messagingTriggersGdprReportUsingGET_RAW_URL
 */
export const messagingTriggersGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/messaging-trigger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const messagingTriggersGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/messaging-trigger'
}
export const messagingTriggersGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const messagingTriggersGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/messaging-trigger'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: mcpTriggersGdprReportUsingGET
 * url: mcpTriggersGdprReportUsingGETURL
 * method: mcpTriggersGdprReportUsingGET_TYPE
 * raw_url: mcpTriggersGdprReportUsingGET_RAW_URL
 */
export const mcpTriggersGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/mcp-trigger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const mcpTriggersGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/mcp-trigger'
}
export const mcpTriggersGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const mcpTriggersGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/mcp-trigger'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: librariesGdprReportUsingGET
 * url: librariesGdprReportUsingGETURL
 * method: librariesGdprReportUsingGET_TYPE
 * raw_url: librariesGdprReportUsingGET_RAW_URL
 */
export const librariesGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/libraries'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const librariesGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/libraries'
}
export const librariesGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const librariesGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/libraries'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: flowsGdprReportUsingGET
 * url: flowsGdprReportUsingGETURL
 * method: flowsGdprReportUsingGET_TYPE
 * raw_url: flowsGdprReportUsingGET_RAW_URL
 */
export const flowsGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/flows'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const flowsGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/flows'
}
export const flowsGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const flowsGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/flows'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: triggerEventHandlersGdprReportUsingGET
 * url: triggerEventHandlersGdprReportUsingGETURL
 * method: triggerEventHandlersGdprReportUsingGET_TYPE
 * raw_url: triggerEventHandlersGdprReportUsingGET_RAW_URL
 */
export const triggerEventHandlersGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/event-handler-trigger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const triggerEventHandlersGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/event-handler-trigger'
}
export const triggerEventHandlersGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const triggerEventHandlersGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/event-handler-trigger'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: entitiesGdprReportUsingGET
 * url: entitiesGdprReportUsingGETURL
 * method: entitiesGdprReportUsingGET_TYPE
 * raw_url: entitiesGdprReportUsingGET_RAW_URL
 */
export const entitiesGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/entities'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const entitiesGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/entities'
}
export const entitiesGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const entitiesGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/entities'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: cronTriggersGdprReportUsingGET
 * url: cronTriggersGdprReportUsingGETURL
 * method: cronTriggersGdprReportUsingGET_TYPE
 * raw_url: cronTriggersGdprReportUsingGET_RAW_URL
 */
export const cronTriggersGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/cron-trigger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const cronTriggersGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/cron-trigger'
}
export const cronTriggersGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const cronTriggersGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/cron-trigger'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: applicationsGdprReportUsingGET
 * url: applicationsGdprReportUsingGETURL
 * method: applicationsGdprReportUsingGET_TYPE
 * raw_url: applicationsGdprReportUsingGET_RAW_URL
 */
export const applicationsGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/applications'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const applicationsGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/applications'
}
export const applicationsGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const applicationsGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/applications'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: aiAgentsGdprReportUsingGET
 * url: aiAgentsGdprReportUsingGETURL
 * method: aiAgentsGdprReportUsingGET_TYPE
 * raw_url: aiAgentsGdprReportUsingGET_RAW_URL
 */
export const aiAgentsGdprReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gdpr/ai-agents'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const aiAgentsGdprReportUsingGET_RAW_URL = function() {
  return '/gdpr/ai-agents'
}
export const aiAgentsGdprReportUsingGET_TYPE = function() {
  return 'get'
}
export const aiAgentsGdprReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gdpr/ai-agents'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getScreenUsagesByIdUsingGET_1
 * url: getScreenUsagesByIdUsingGET_1URL
 * method: getScreenUsagesByIdUsingGET_1_TYPE
 * raw_url: getScreenUsagesByIdUsingGET_1_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getScreenUsagesByIdUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getScreenUsagesByIdUsingGET_1_RAW_URL = function() {
  return '/flow/{id}/usages'
}
export const getScreenUsagesByIdUsingGET_1_TYPE = function() {
  return 'get'
}
export const getScreenUsagesByIdUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getFlowTagsUsingGET
 * url: getFlowTagsUsingGETURL
 * method: getFlowTagsUsingGET_TYPE
 * raw_url: getFlowTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getFlowTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFlowTagsUsingGET_RAW_URL = function() {
  return '/flow/{id}/tags'
}
export const getFlowTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getFlowTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableFlowUsingGET
 * url: enableFlowUsingGETURL
 * method: enableFlowUsingGET_TYPE
 * raw_url: enableFlowUsingGET_RAW_URL
 * @param id - 
 */
export const enableFlowUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableFlowUsingGET_RAW_URL = function() {
  return '/flow/{id}/enable'
}
export const enableFlowUsingGET_TYPE = function() {
  return 'get'
}
export const enableFlowUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableFlowUsingGET
 * url: disableFlowUsingGETURL
 * method: disableFlowUsingGET_TYPE
 * raw_url: disableFlowUsingGET_RAW_URL
 * @param id - 
 */
export const disableFlowUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/flow/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableFlowUsingGET_RAW_URL = function() {
  return '/flow/{id}/disable'
}
export const disableFlowUsingGET_TYPE = function() {
  return 'get'
}
export const disableFlowUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/flow/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEventsUsingGET
 * url: getEventsUsingGETURL
 * method: getEventsUsingGET_TYPE
 * raw_url: getEventsUsingGET_RAW_URL
 * @param triggerId - 
 * @param processId - 
 * @param instanceId - 
 * @param type - 
 * @param status - 
 * @param dateFrom - 
 * @param dateTill - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getEventsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['instanceId'] !== undefined) {
    queryParameters['instanceId'] = parameters['instanceId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEventsUsingGET_RAW_URL = function() {
  return '/event'
}
export const getEventsUsingGET_TYPE = function() {
  return 'get'
}
export const getEventsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event'
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['instanceId'] !== undefined) {
    queryParameters['instanceId'] = parameters['instanceId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEventByIdUsingGET
 * url: getEventByIdUsingGETURL
 * method: getEventByIdUsingGET_TYPE
 * raw_url: getEventByIdUsingGET_RAW_URL
 * @param id - 
 */
export const getEventByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEventByIdUsingGET_RAW_URL = function() {
  return '/event/{id}'
}
export const getEventByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getEventByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEventsWithProcessesUsingGET
 * url: getEventsWithProcessesUsingGETURL
 * method: getEventsWithProcessesUsingGET_TYPE
 * raw_url: getEventsWithProcessesUsingGET_RAW_URL
 * @param processId - 
 * @param status - 
 * @param dateFrom - 
 * @param dateTill - 
 * @param size - 
 * @param page - 
 */
export const getEventsWithProcessesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/with-processes'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['status'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: status'))
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEventsWithProcessesUsingGET_RAW_URL = function() {
  return '/event/with-processes'
}
export const getEventsWithProcessesUsingGET_TYPE = function() {
  return 'get'
}
export const getEventsWithProcessesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/with-processes'
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getStatesReportUsingGET
 * url: getStatesReportUsingGETURL
 * method: getStatesReportUsingGET_TYPE
 * raw_url: getStatesReportUsingGET_RAW_URL
 * @param reportType - 
 * @param dateFrom - 
 * @param dateTill - 
 * @param processId - 
 * @param status - 
 * @param triggerId - 
 * @param type - 
 */
export const getStatesReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/states'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['reportType'] !== undefined) {
    queryParameters['reportType'] = parameters['reportType']
  }
  if (parameters['reportType'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: reportType'))
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateFrom'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dateFrom'))
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['dateTill'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dateTill'))
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStatesReportUsingGET_RAW_URL = function() {
  return '/event/states'
}
export const getStatesReportUsingGET_TYPE = function() {
  return 'get'
}
export const getStatesReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/states'
  if (parameters['reportType'] !== undefined) {
    queryParameters['reportType'] = parameters['reportType']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getTotalStatesReportUsingGET
 * url: getTotalStatesReportUsingGETURL
 * method: getTotalStatesReportUsingGET_TYPE
 * raw_url: getTotalStatesReportUsingGET_RAW_URL
 * @param dateFrom - 
 * @param dateTill - 
 * @param processId - 
 * @param status - 
 * @param triggerId - 
 * @param type - 
 */
export const getTotalStatesReportUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/states/total'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTotalStatesReportUsingGET_RAW_URL = function() {
  return '/event/states/total'
}
export const getTotalStatesReportUsingGET_TYPE = function() {
  return 'get'
}
export const getTotalStatesReportUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/states/total'
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getProcessesNamesUsingGET
 * url: getProcessesNamesUsingGETURL
 * method: getProcessesNamesUsingGET_TYPE
 * raw_url: getProcessesNamesUsingGET_RAW_URL
 * @param processName - 
 * @param status - 
 * @param dateFrom - 
 * @param dateTill - 
 * @param size - 
 * @param page - 
 */
export const getProcessesNamesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/processes-names'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['processName'] !== undefined) {
    queryParameters['processName'] = parameters['processName']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['status'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: status'))
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getProcessesNamesUsingGET_RAW_URL = function() {
  return '/event/processes-names'
}
export const getProcessesNamesUsingGET_TYPE = function() {
  return 'get'
}
export const getProcessesNamesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/processes-names'
  if (parameters['processName'] !== undefined) {
    queryParameters['processName'] = parameters['processName']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getPerInstanceUsingGET
 * url: getPerInstanceUsingGETURL
 * method: getPerInstanceUsingGET_TYPE
 * raw_url: getPerInstanceUsingGET_RAW_URL
 * @param dateFrom - 
 * @param dateTill - 
 * @param processId - 
 * @param status - 
 * @param triggerId - 
 * @param type - 
 */
export const getPerInstanceUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/per-instance'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateFrom'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dateFrom'))
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['dateTill'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dateTill'))
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPerInstanceUsingGET_RAW_URL = function() {
  return '/event/per-instance'
}
export const getPerInstanceUsingGET_TYPE = function() {
  return 'get'
}
export const getPerInstanceUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/per-instance'
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getMostRecentEventIdUsingGET
 * url: getMostRecentEventIdUsingGETURL
 * method: getMostRecentEventIdUsingGET_TYPE
 * raw_url: getMostRecentEventIdUsingGET_RAW_URL
 * @param processId - 
 */
export const getMostRecentEventIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/most-recent/{processId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{processId}', `${parameters['processId']}`)
  if (parameters['processId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: processId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMostRecentEventIdUsingGET_RAW_URL = function() {
  return '/event/most-recent/{processId}'
}
export const getMostRecentEventIdUsingGET_TYPE = function() {
  return 'get'
}
export const getMostRecentEventIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/most-recent/{processId}'
  path = path.replace('{processId}', `${parameters['processId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getDurationUsingGET
 * url: getDurationUsingGETURL
 * method: getDurationUsingGET_TYPE
 * raw_url: getDurationUsingGET_RAW_URL
 * @param dateFrom - 
 * @param dateTill - 
 * @param processId - 
 * @param status - 
 * @param triggerId - 
 * @param type - 
 */
export const getDurationUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event/duration'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateFrom'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dateFrom'))
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['dateTill'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: dateTill'))
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDurationUsingGET_RAW_URL = function() {
  return '/event/duration'
}
export const getDurationUsingGET_TYPE = function() {
  return 'get'
}
export const getDurationUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event/duration'
  if (parameters['dateFrom'] !== undefined) {
    queryParameters['dateFrom'] = parameters['dateFrom']
  }
  if (parameters['dateTill'] !== undefined) {
    queryParameters['dateTill'] = parameters['dateTill']
  }
  if (parameters['processId'] !== undefined) {
    queryParameters['processId'] = parameters['processId']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['triggerId'] !== undefined) {
    queryParameters['triggerId'] = parameters['triggerId']
  }
  if (parameters['type'] !== undefined) {
    queryParameters['type'] = parameters['type']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEntityResourcesUsingGET
 * url: getEntityResourcesUsingGETURL
 * method: getEntityResourcesUsingGET_TYPE
 * raw_url: getEntityResourcesUsingGET_RAW_URL
 * @param id - 
 */
export const getEntityResourcesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/resources'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEntityResourcesUsingGET_RAW_URL = function() {
  return '/entity/{id}/resources'
}
export const getEntityResourcesUsingGET_TYPE = function() {
  return 'get'
}
export const getEntityResourcesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/resources'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteEntityResourcesUsingDELETE
 * url: deleteEntityResourcesUsingDELETEURL
 * method: deleteEntityResourcesUsingDELETE_TYPE
 * raw_url: deleteEntityResourcesUsingDELETE_RAW_URL
 * @param id - 
 * @param force - 
 */
export const deleteEntityResourcesUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/resources'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters['force'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: force'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteEntityResourcesUsingDELETE_RAW_URL = function() {
  return '/entity/{id}/resources'
}
export const deleteEntityResourcesUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteEntityResourcesUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/resources'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['force'] !== undefined) {
    queryParameters['force'] = parameters['force']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: entityPersistenceValidateUsingGET
 * url: entityPersistenceValidateUsingGETURL
 * method: entityPersistenceValidateUsingGET_TYPE
 * raw_url: entityPersistenceValidateUsingGET_RAW_URL
 * @param id - 
 */
export const entityPersistenceValidateUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/persistence/validate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const entityPersistenceValidateUsingGET_RAW_URL = function() {
  return '/entity/{id}/persistence/validate'
}
export const entityPersistenceValidateUsingGET_TYPE = function() {
  return 'get'
}
export const entityPersistenceValidateUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/persistence/validate'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: entityPersistenceValidateUpdateUsingGET
 * url: entityPersistenceValidateUpdateUsingGETURL
 * method: entityPersistenceValidateUpdateUsingGET_TYPE
 * raw_url: entityPersistenceValidateUpdateUsingGET_RAW_URL
 * @param id - 
 */
export const entityPersistenceValidateUpdateUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/persistence/update/validate'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const entityPersistenceValidateUpdateUsingGET_RAW_URL = function() {
  return '/entity/{id}/persistence/update/validate'
}
export const entityPersistenceValidateUpdateUsingGET_TYPE = function() {
  return 'get'
}
export const entityPersistenceValidateUpdateUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/persistence/update/validate'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableEntityUsingGET
 * url: enableEntityUsingGETURL
 * method: enableEntityUsingGET_TYPE
 * raw_url: enableEntityUsingGET_RAW_URL
 * @param id - 
 */
export const enableEntityUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableEntityUsingGET_RAW_URL = function() {
  return '/entity/{id}/enable'
}
export const enableEntityUsingGET_TYPE = function() {
  return 'get'
}
export const enableEntityUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableEntityUsingGET
 * url: disableEntityUsingGETURL
 * method: disableEntityUsingGET_TYPE
 * raw_url: disableEntityUsingGET_RAW_URL
 * @param id - 
 */
export const disableEntityUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableEntityUsingGET_RAW_URL = function() {
  return '/entity/{id}/disable'
}
export const disableEntityUsingGET_TYPE = function() {
  return 'get'
}
export const disableEntityUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEntitiesWithSystemPermissionRolesUsingGET
 * url: getEntitiesWithSystemPermissionRolesUsingGETURL
 * method: getEntitiesWithSystemPermissionRolesUsingGET_TYPE
 * raw_url: getEntitiesWithSystemPermissionRolesUsingGET_RAW_URL
 * @param permissionType - 
 * @param status - 
 * @param tags - 
 * @param name - 
 * @param preciseName - 
 * @param orderField - 
 * @param orderDirection - 
 * @param size - 
 * @param page - 
 */
export const getEntitiesWithSystemPermissionRolesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/system-permission-roles'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEntitiesWithSystemPermissionRolesUsingGET_RAW_URL = function() {
  return '/entity/system-permission-roles'
}
export const getEntitiesWithSystemPermissionRolesUsingGET_TYPE = function() {
  return 'get'
}
export const getEntitiesWithSystemPermissionRolesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/system-permission-roles'
  if (parameters['permissionType'] !== undefined) {
    queryParameters['permissionType'] = parameters['permissionType']
  }
  if (parameters['status'] !== undefined) {
    queryParameters['status'] = parameters['status']
  }
  if (parameters['tags'] !== undefined) {
    queryParameters['tags'] = parameters['tags']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['preciseName'] !== undefined) {
    queryParameters['preciseName'] = parameters['preciseName']
  }
  if (parameters['orderField'] !== undefined) {
    queryParameters['orderField'] = parameters['orderField']
  }
  if (parameters['orderDirection'] !== undefined) {
    queryParameters['orderDirection'] = parameters['orderDirection']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: validateEntityFromPersistenceUsingGET
 * url: validateEntityFromPersistenceUsingGETURL
 * method: validateEntityFromPersistenceUsingGET_TYPE
 * raw_url: validateEntityFromPersistenceUsingGET_RAW_URL
 * @param credentialName - 
 * @param persistenceName - 
 */
export const validateEntityFromPersistenceUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/from-persistence/validate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['credentialName'] !== undefined) {
    queryParameters['credentialName'] = parameters['credentialName']
  }
  if (parameters['credentialName'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: credentialName'))
  }
  if (parameters['persistenceName'] !== undefined) {
    queryParameters['persistenceName'] = parameters['persistenceName']
  }
  if (parameters['persistenceName'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: persistenceName'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const validateEntityFromPersistenceUsingGET_RAW_URL = function() {
  return '/entity/from-persistence/validate'
}
export const validateEntityFromPersistenceUsingGET_TYPE = function() {
  return 'get'
}
export const validateEntityFromPersistenceUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/from-persistence/validate'
  if (parameters['credentialName'] !== undefined) {
    queryParameters['credentialName'] = parameters['credentialName']
  }
  if (parameters['persistenceName'] !== undefined) {
    queryParameters['persistenceName'] = parameters['persistenceName']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getEncodingTypesUsingGET
 * url: getEncodingTypesUsingGETURL
 * method: getEncodingTypesUsingGET_TYPE
 * raw_url: getEncodingTypesUsingGET_RAW_URL
 */
export const getEncodingTypesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/encoding-type'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEncodingTypesUsingGET_RAW_URL = function() {
  return '/encoding-type'
}
export const getEncodingTypesUsingGET_TYPE = function() {
  return 'get'
}
export const getEncodingTypesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/encoding-type'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getDatabaseStatisticUsingGET
 * url: getDatabaseStatisticUsingGETURL
 * method: getDatabaseStatisticUsingGET_TYPE
 * raw_url: getDatabaseStatisticUsingGET_RAW_URL
 */
export const getDatabaseStatisticUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/database-statistic'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDatabaseStatisticUsingGET_RAW_URL = function() {
  return '/database-statistic'
}
export const getDatabaseStatisticUsingGET_TYPE = function() {
  return 'get'
}
export const getDatabaseStatisticUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/database-statistic'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getCachesUsingGET
 * url: getCachesUsingGETURL
 * method: getCachesUsingGET_TYPE
 * raw_url: getCachesUsingGET_RAW_URL
 * @param cacheType - 
 * @param size - 
 * @param page - 
 */
export const getCachesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/cache'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cacheType'] !== undefined) {
    queryParameters['cacheType'] = parameters['cacheType']
  }
  if (parameters['cacheType'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cacheType'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCachesUsingGET_RAW_URL = function() {
  return '/cache'
}
export const getCachesUsingGET_TYPE = function() {
  return 'get'
}
export const getCachesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/cache'
  if (parameters['cacheType'] !== undefined) {
    queryParameters['cacheType'] = parameters['cacheType']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: downloadCacheFileUsingGET
 * url: downloadCacheFileUsingGETURL
 * method: downloadCacheFileUsingGET_TYPE
 * raw_url: downloadCacheFileUsingGET_RAW_URL
 * @param id - 
 */
export const downloadCacheFileUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/cache-file/{id}/download'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadCacheFileUsingGET_RAW_URL = function() {
  return '/cache-file/{id}/download'
}
export const downloadCacheFileUsingGET_TYPE = function() {
  return 'get'
}
export const downloadCacheFileUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/cache-file/{id}/download'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getBuildInfoUsingGET
 * url: getBuildInfoUsingGETURL
 * method: getBuildInfoUsingGET_TYPE
 * raw_url: getBuildInfoUsingGET_RAW_URL
 */
export const getBuildInfoUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/build-info'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBuildInfoUsingGET_RAW_URL = function() {
  return '/build-info'
}
export const getBuildInfoUsingGET_TYPE = function() {
  return 'get'
}
export const getBuildInfoUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/build-info'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationUsagesByIdUsingGET
 * url: getApplicationUsagesByIdUsingGETURL
 * method: getApplicationUsagesByIdUsingGET_TYPE
 * raw_url: getApplicationUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getApplicationUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationUsagesByIdUsingGET_RAW_URL = function() {
  return '/application/{id}/usages'
}
export const getApplicationUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getUploadStatusUsingGET
 * url: getUploadStatusUsingGETURL
 * method: getUploadStatusUsingGET_TYPE
 * raw_url: getUploadStatusUsingGET_RAW_URL
 * @param id - 
 * @param logId - 
 */
export const getUploadStatusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/upload/{logId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{logId}', `${parameters['logId']}`)
  if (parameters['logId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: logId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUploadStatusUsingGET_RAW_URL = function() {
  return '/application/{id}/upload/{logId}'
}
export const getUploadStatusUsingGET_TYPE = function() {
  return 'get'
}
export const getUploadStatusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/upload/{logId}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{logId}', `${parameters['logId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationTagsUsingGET
 * url: getApplicationTagsUsingGETURL
 * method: getApplicationTagsUsingGET_TYPE
 * raw_url: getApplicationTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getApplicationTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationTagsUsingGET_RAW_URL = function() {
  return '/application/{id}/tags'
}
export const getApplicationTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: publicSwaggerUsingGET
 * url: publicSwaggerUsingGETURL
 * method: publicSwaggerUsingGET_TYPE
 * raw_url: publicSwaggerUsingGET_RAW_URL
 * @param id - 
 * @param token - 
 */
export const publicSwaggerUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/swagger'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['token'] !== undefined) {
    queryParameters['token'] = parameters['token']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const publicSwaggerUsingGET_RAW_URL = function() {
  return '/application/{id}/swagger'
}
export const publicSwaggerUsingGET_TYPE = function() {
  return 'get'
}
export const publicSwaggerUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/swagger'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['token'] !== undefined) {
    queryParameters['token'] = parameters['token']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getOperationLogsUsingGET
 * url: getOperationLogsUsingGETURL
 * method: getOperationLogsUsingGET_TYPE
 * raw_url: getOperationLogsUsingGET_RAW_URL
 * @param id - 
 * @param size - 
 * @param page - 
 */
export const getOperationLogsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/operation-logs'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOperationLogsUsingGET_RAW_URL = function() {
  return '/application/{id}/operation-logs'
}
export const getOperationLogsUsingGET_TYPE = function() {
  return 'get'
}
export const getOperationLogsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/operation-logs'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationLifecycleStatusUsingGET
 * url: getApplicationLifecycleStatusUsingGETURL
 * method: getApplicationLifecycleStatusUsingGET_TYPE
 * raw_url: getApplicationLifecycleStatusUsingGET_RAW_URL
 * @param id - 
 */
export const getApplicationLifecycleStatusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/lifecycle/status'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationLifecycleStatusUsingGET_RAW_URL = function() {
  return '/application/{id}/lifecycle/status'
}
export const getApplicationLifecycleStatusUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationLifecycleStatusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/lifecycle/status'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationGitStatusUsingGET
 * url: getApplicationGitStatusUsingGETURL
 * method: getApplicationGitStatusUsingGET_TYPE
 * raw_url: getApplicationGitStatusUsingGET_RAW_URL
 * @param id - 
 */
export const getApplicationGitStatusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/status'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationGitStatusUsingGET_RAW_URL = function() {
  return '/application/{id}/git/status'
}
export const getApplicationGitStatusUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationGitStatusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/status'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationGitLogUsingGET
 * url: getApplicationGitLogUsingGETURL
 * method: getApplicationGitLogUsingGET_TYPE
 * raw_url: getApplicationGitLogUsingGET_RAW_URL
 * @param id - 
 * @param limit - 
 */
export const getApplicationGitLogUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/log'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['limit'] !== undefined) {
    queryParameters['limit'] = parameters['limit']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationGitLogUsingGET_RAW_URL = function() {
  return '/application/{id}/git/log'
}
export const getApplicationGitLogUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationGitLogUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/log'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['limit'] !== undefined) {
    queryParameters['limit'] = parameters['limit']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationGitDiffUsingGET
 * url: getApplicationGitDiffUsingGETURL
 * method: getApplicationGitDiffUsingGET_TYPE
 * raw_url: getApplicationGitDiffUsingGET_RAW_URL
 * @param id - 
 * @param path - 
 */
export const getApplicationGitDiffUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/diff'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationGitDiffUsingGET_RAW_URL = function() {
  return '/application/{id}/git/diff'
}
export const getApplicationGitDiffUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationGitDiffUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/diff'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationGitBranchesUsingGET
 * url: getApplicationGitBranchesUsingGETURL
 * method: getApplicationGitBranchesUsingGET_TYPE
 * raw_url: getApplicationGitBranchesUsingGET_RAW_URL
 * @param id - 
 */
export const getApplicationGitBranchesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/git/branches'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationGitBranchesUsingGET_RAW_URL = function() {
  return '/application/{id}/git/branches'
}
export const getApplicationGitBranchesUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationGitBranchesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/git/branches'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: downloadFileUsingGET
 * url: downloadFileUsingGETURL
 * method: downloadFileUsingGET_TYPE
 * raw_url: downloadFileUsingGET_RAW_URL
 * @param id - 
 * @param path - 
 */
export const downloadFileUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/files/download'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters['path'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: path'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const downloadFileUsingGET_RAW_URL = function() {
  return '/application/{id}/files/download'
}
export const downloadFileUsingGET_TYPE = function() {
  return 'get'
}
export const downloadFileUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/files/download'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['path'] !== undefined) {
    queryParameters['path'] = parameters['path']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableApplicationUsingGET
 * url: enableApplicationUsingGETURL
 * method: enableApplicationUsingGET_TYPE
 * raw_url: enableApplicationUsingGET_RAW_URL
 * @param id - 
 */
export const enableApplicationUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableApplicationUsingGET_RAW_URL = function() {
  return '/application/{id}/enable'
}
export const enableApplicationUsingGET_TYPE = function() {
  return 'get'
}
export const enableApplicationUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableApplicationUsingGET
 * url: disableApplicationUsingGETURL
 * method: disableApplicationUsingGET_TYPE
 * raw_url: disableApplicationUsingGET_RAW_URL
 * @param id - 
 */
export const disableApplicationUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableApplicationUsingGET_RAW_URL = function() {
  return '/application/{id}/disable'
}
export const disableApplicationUsingGET_TYPE = function() {
  return 'get'
}
export const disableApplicationUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationContainerStatusUsingGET
 * url: getApplicationContainerStatusUsingGETURL
 * method: getApplicationContainerStatusUsingGET_TYPE
 * raw_url: getApplicationContainerStatusUsingGET_RAW_URL
 * @param id - 
 */
export const getApplicationContainerStatusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/container'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationContainerStatusUsingGET_RAW_URL = function() {
  return '/application/{id}/container'
}
export const getApplicationContainerStatusUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationContainerStatusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/container'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getApplicationVolumesUsingGET
 * url: getApplicationVolumesUsingGETURL
 * method: getApplicationVolumesUsingGET_TYPE
 * raw_url: getApplicationVolumesUsingGET_RAW_URL
 * @param id - 
 */
export const getApplicationVolumesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/container/volumes'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getApplicationVolumesUsingGET_RAW_URL = function() {
  return '/application/{id}/container/volumes'
}
export const getApplicationVolumesUsingGET_TYPE = function() {
  return 'get'
}
export const getApplicationVolumesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/container/volumes'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: removeApplicationVolumesUsingDELETE
 * url: removeApplicationVolumesUsingDELETEURL
 * method: removeApplicationVolumesUsingDELETE_TYPE
 * raw_url: removeApplicationVolumesUsingDELETE_RAW_URL
 * @param id - 
 */
export const removeApplicationVolumesUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/container/volumes'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const removeApplicationVolumesUsingDELETE_RAW_URL = function() {
  return '/application/{id}/container/volumes'
}
export const removeApplicationVolumesUsingDELETE_TYPE = function() {
  return 'delete'
}
export const removeApplicationVolumesUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/container/volumes'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getCdnDomainsUsingGET
 * url: getCdnDomainsUsingGETURL
 * method: getCdnDomainsUsingGET_TYPE
 * raw_url: getCdnDomainsUsingGET_RAW_URL
 * @param id - 
 */
export const getCdnDomainsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/cdn/domains'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCdnDomainsUsingGET_RAW_URL = function() {
  return '/application/{id}/cdn/domains'
}
export const getCdnDomainsUsingGET_TYPE = function() {
  return 'get'
}
export const getCdnDomainsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/cdn/domains'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getCdnRefreshStatusUsingGET
 * url: getCdnRefreshStatusUsingGETURL
 * method: getCdnRefreshStatusUsingGET_TYPE
 * raw_url: getCdnRefreshStatusUsingGET_RAW_URL
 * @param id - 
 * @param logId - 
 */
export const getCdnRefreshStatusUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/application/{id}/cdn-refresh/{logId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{logId}', `${parameters['logId']}`)
  if (parameters['logId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: logId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCdnRefreshStatusUsingGET_RAW_URL = function() {
  return '/application/{id}/cdn-refresh/{logId}'
}
export const getCdnRefreshStatusUsingGET_TYPE = function() {
  return 'get'
}
export const getCdnRefreshStatusUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/application/{id}/cdn-refresh/{logId}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{logId}', `${parameters['logId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getAiAgentUsagesByIdUsingGET
 * url: getAiAgentUsagesByIdUsingGETURL
 * method: getAiAgentUsagesByIdUsingGET_TYPE
 * raw_url: getAiAgentUsagesByIdUsingGET_RAW_URL
 * @param id - 
 * @param request - 
 */
export const getAiAgentUsagesByIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/usages'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters['request'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: request'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAiAgentUsagesByIdUsingGET_RAW_URL = function() {
  return '/ai-agent/{id}/usages'
}
export const getAiAgentUsagesByIdUsingGET_TYPE = function() {
  return 'get'
}
export const getAiAgentUsagesByIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/usages'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['request'] !== undefined) {
    queryParameters['request'] = parameters['request']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getAiAgentTagsUsingGET
 * url: getAiAgentTagsUsingGETURL
 * method: getAiAgentTagsUsingGET_TYPE
 * raw_url: getAiAgentTagsUsingGET_RAW_URL
 * @param id - 
 */
export const getAiAgentTagsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/tags'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAiAgentTagsUsingGET_RAW_URL = function() {
  return '/ai-agent/{id}/tags'
}
export const getAiAgentTagsUsingGET_TYPE = function() {
  return 'get'
}
export const getAiAgentTagsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/tags'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: enableAiAgentUsingGET
 * url: enableAiAgentUsingGETURL
 * method: enableAiAgentUsingGET_TYPE
 * raw_url: enableAiAgentUsingGET_RAW_URL
 * @param id - 
 */
export const enableAiAgentUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/enable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const enableAiAgentUsingGET_RAW_URL = function() {
  return '/ai-agent/{id}/enable'
}
export const enableAiAgentUsingGET_TYPE = function() {
  return 'get'
}
export const enableAiAgentUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/enable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: disableAiAgentUsingGET
 * url: disableAiAgentUsingGETURL
 * method: disableAiAgentUsingGET_TYPE
 * raw_url: disableAiAgentUsingGET_RAW_URL
 * @param id - 
 */
export const disableAiAgentUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/disable'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const disableAiAgentUsingGET_RAW_URL = function() {
  return '/ai-agent/{id}/disable'
}
export const disableAiAgentUsingGET_TYPE = function() {
  return 'get'
}
export const disableAiAgentUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/disable'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: getChatUsingGET
 * url: getChatUsingGETURL
 * method: getChatUsingGET_TYPE
 * raw_url: getChatUsingGET_RAW_URL
 * @param id - 
 * @param chatId - 
 */
export const getChatUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/chat/{chatId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{chatId}', `${parameters['chatId']}`)
  if (parameters['chatId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chatId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getChatUsingGET_RAW_URL = function() {
  return '/ai-agent/{id}/chat/{chatId}'
}
export const getChatUsingGET_TYPE = function() {
  return 'get'
}
export const getChatUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/chat/{chatId}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{chatId}', `${parameters['chatId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteChatUsingDELETE
 * url: deleteChatUsingDELETEURL
 * method: deleteChatUsingDELETE_TYPE
 * raw_url: deleteChatUsingDELETE_RAW_URL
 * @param id - 
 * @param chatId - 
 */
export const deleteChatUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ai-agent/{id}/chat/{chatId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{chatId}', `${parameters['chatId']}`)
  if (parameters['chatId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: chatId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteChatUsingDELETE_RAW_URL = function() {
  return '/ai-agent/{id}/chat/{chatId}'
}
export const deleteChatUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteChatUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ai-agent/{id}/chat/{chatId}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{chatId}', `${parameters['chatId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: twoFactorAuthDisableByUserIdUsingDELETE
 * url: twoFactorAuthDisableByUserIdUsingDELETEURL
 * method: twoFactorAuthDisableByUserIdUsingDELETE_TYPE
 * raw_url: twoFactorAuthDisableByUserIdUsingDELETE_RAW_URL
 * @param id - 
 */
export const twoFactorAuthDisableByUserIdUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/two-factor-auth'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const twoFactorAuthDisableByUserIdUsingDELETE_RAW_URL = function() {
  return '/user/{id}/two-factor-auth'
}
export const twoFactorAuthDisableByUserIdUsingDELETE_TYPE = function() {
  return 'delete'
}
export const twoFactorAuthDisableByUserIdUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/two-factor-auth'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteUserSessionsUsingDELETE
 * url: deleteUserSessionsUsingDELETEURL
 * method: deleteUserSessionsUsingDELETE_TYPE
 * raw_url: deleteUserSessionsUsingDELETE_RAW_URL
 * @param id - 
 */
export const deleteUserSessionsUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/user/{id}/sessions'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteUserSessionsUsingDELETE_RAW_URL = function() {
  return '/user/{id}/sessions'
}
export const deleteUserSessionsUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteUserSessionsUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/user/{id}/sessions'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: removeSkillUsingDELETE
 * url: removeSkillUsingDELETEURL
 * method: removeSkillUsingDELETE_TYPE
 * raw_url: removeSkillUsingDELETE_RAW_URL
 * @param id - 
 * @param staticResourceName - 
 */
export const removeSkillUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/process-credential/{id}/skills/{staticResourceName}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{staticResourceName}', `${parameters['staticResourceName']}`)
  if (parameters['staticResourceName'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: staticResourceName'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const removeSkillUsingDELETE_RAW_URL = function() {
  return '/process-credential/{id}/skills/{staticResourceName}'
}
export const removeSkillUsingDELETE_TYPE = function() {
  return 'delete'
}
export const removeSkillUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/process-credential/{id}/skills/{staticResourceName}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{staticResourceName}', `${parameters['staticResourceName']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: deleteReviewUsingDELETE
 * url: deleteReviewUsingDELETEURL
 * method: deleteReviewUsingDELETE_TYPE
 * raw_url: deleteReviewUsingDELETE_RAW_URL
 * @param id - 
 */
export const deleteReviewUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/hub/review/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteReviewUsingDELETE_RAW_URL = function() {
  return '/hub/review/{id}'
}
export const deleteReviewUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteReviewUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/hub/review/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: entityPersistenceDeleteUsingDELETE
 * url: entityPersistenceDeleteUsingDELETEURL
 * method: entityPersistenceDeleteUsingDELETE_TYPE
 * raw_url: entityPersistenceDeleteUsingDELETE_RAW_URL
 * @param id - 
 */
export const entityPersistenceDeleteUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/entity/{id}/persistence'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const entityPersistenceDeleteUsingDELETE_RAW_URL = function() {
  return '/entity/{id}/persistence'
}
export const entityPersistenceDeleteUsingDELETE_TYPE = function() {
  return 'delete'
}
export const entityPersistenceDeleteUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/entity/{id}/persistence'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}